import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  LocalDate: { input: any; output: any; }
  Long: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** What deleting the current account would do to an organisation it owns. */
export type AccountDeletionOrganisationSummary = {
  __typename?: 'AccountDeletionOrganisationSummary';
  id: Scalars['UUID']['output'];
  isAutocreated: Scalars['Boolean']['output'];
  /** Members other than the current user. */
  memberCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  outcome: OrganisationOwnerDepartureOutcome;
  testCount: Scalars['Int']['output'];
};

/** What deleting the current account would involve. Informational; never used to block. */
export type AccountDeletionPreview = {
  __typename?: 'AccountDeletionPreview';
  ownedOrganisations: Array<AccountDeletionOrganisationSummary>;
  /** Whether a current password must be supplied to confirm. */
  requiresPassword: Scalars['Boolean']['output'];
  /** Soil tests recorded by this user; retained by their organisations. */
  testCount: Scalars['Int']['output'];
};

export enum AccountDeletionStatus {
  Completed = 'COMPLETED',
  PurgePending = 'PURGE_PENDING'
}

export type ActiveFirmware = {
  __typename?: 'ActiveFirmware';
  byteLength: Scalars['Long']['output'];
  downloadUrl: Scalars['String']['output'];
  downloadUrlExpiresAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  sha256: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for adding a cassette entitlement adjustment. */
export type AddCassetteEntitlementAdjustmentInput = {
  cassetteId: Scalars['UUID']['input'];
  customerTestDelta: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
};

/** Input for enabling a target locale system wide and returning the requested file summary. */
export type AddLocalisationTargetLocaleInput = {
  fileName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type AdminSetUserPasswordInput = {
  password: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** Defines when a policy shall be executed. */
export enum ApplyPolicy {
  /** After the resolver was executed. */
  AfterResolver = 'AFTER_RESOLVER',
  /** Before the resolver was executed. */
  BeforeResolver = 'BEFORE_RESOLVER',
  /** The policy is applied in the validation step before the execution. */
  Validation = 'VALIDATION'
}

/** A persisted audit log entry. */
export type AuditLog = {
  __typename?: 'AuditLog';
  actingUser?: Maybe<User>;
  /** Audit action type. */
  actionType: Scalars['String']['output'];
  /** Additional structured context as JSON. */
  additionalContext: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Optional notes. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Optional reason. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Optional target entity ID. */
  targetEntityId?: Maybe<Scalars['UUID']['output']>;
  /** Optional target entity type. */
  targetEntityType?: Maybe<Scalars['String']['output']>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A persisted audit log entry. */
export type AuditLogFilterInput = {
  /** Audit action type. */
  actionType?: InputMaybe<StringOperationFilterInput>;
  /** Additional structured context as JSON. */
  additionalContext?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AuditLogFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuditLogFilterInput>>;
  /** Optional reason. */
  reason?: InputMaybe<StringOperationFilterInput>;
  /** Optional target entity ID. */
  targetEntityId?: InputMaybe<UuidOperationFilterInput>;
  /** Optional target entity type. */
  targetEntityType?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A persisted audit log entry. */
export type AuditLogSortInput = {
  /** Audit action type. */
  actionType?: InputMaybe<SortEnumType>;
  /** Additional structured context as JSON. */
  additionalContext?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Optional reason. */
  reason?: InputMaybe<SortEnumType>;
  /** Optional target entity ID. */
  targetEntityId?: InputMaybe<SortEnumType>;
  /** Optional target entity type. */
  targetEntityType?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuditLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AuditLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditLogsEdge = {
  __typename?: 'AuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AuditLog;
};

export type BackgroundJobStatus = {
  __typename?: 'BackgroundJobStatus';
  predictionBacklog: PredictionBacklogStatus;
  processingCount: Scalars['Int']['output'];
  processingJobs: Array<ProcessingBackgroundJob>;
  queuedByType: Array<QueuedBackgroundJobType>;
  queuedCount: Scalars['Int']['output'];
  scheduledCount: Scalars['Int']['output'];
};

/** A batch (unique by name and batch number). */
export type Batch = {
  __typename?: 'Batch';
  /** Unique batch number. */
  batchNumber: Scalars['String']['output'];
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Batch description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A batch (unique by name and batch number). */
export type BatchFilterInput = {
  and?: InputMaybe<Array<BatchFilterInput>>;
  /** Unique batch number. */
  batchNumber?: InputMaybe<StringOperationFilterInput>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Batch description. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BatchFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A batch (unique by name and batch number). */
export type BatchSortInput = {
  /** Unique batch number. */
  batchNumber?: InputMaybe<SortEnumType>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Batch description. */
  description?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchesConnection = {
  __typename?: 'BatchesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Batch>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BatchesEdge = {
  __typename?: 'BatchesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Batch;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A cassette. */
export type Cassette = {
  __typename?: 'Cassette';
  allocatedCustomerTests: Scalars['Int']['output'];
  /** Number of failing sensor checks (non-debug). */
  badSensorCount: Scalars['Int']['output'];
  baseCustomerTests: Scalars['Int']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  currentCassetteExtraAllocatableTests: Scalars['Int']['output'];
  entitlementAdjustments?: Maybe<EntitlementAdjustmentsConnection>;
  /** Expiry date. */
  expiryDate: Scalars['DateTime']['output'];
  /** Extra JSON metadata. */
  extraMetadata: Scalars['String']['output'];
  /** Number of passing sensor checks (non-debug). */
  goodSensorCount: Scalars['Int']['output'];
  hasOpenOverflowWarning: Scalars['Boolean']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  lastUsedBy?: Maybe<CassetteLastUsedInfo>;
  manualCustomerTestAdjustments: Scalars['Int']['output'];
  /** Manufacture date. */
  manufactureDate: Scalars['DateTime']['output'];
  /** Maximum index time in seconds. */
  maxIndexTimeSeconds: Scalars['Float']['output'];
  /** Number of sensors. */
  numSensors: Scalars['Int']['output'];
  openOverflowRequestedTests: Scalars['Int']['output'];
  overflowRequests?: Maybe<OverflowRequestsConnection>;
  physicalSensorsUsed: Scalars['Int']['output'];
  remainingCustomerTests: Scalars['Int']['output'];
  remainingPhysicalSensors: Scalars['Int']['output'];
  /** Sensor check UUID. */
  sensorCheckUuid: Scalars['UUID']['output'];
  serialNumber?: Maybe<SerialNumber>;
  /** Soil test UUID. */
  soilTestUuid: Scalars['UUID']['output'];
  /** TRH type. */
  trhType: TrhType;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  usedCustomerTests: Scalars['Int']['output'];
};


/** A cassette. */
export type CassetteEntitlementAdjustmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CassetteEntitlementAdjustmentSortInput>>;
  where?: InputMaybe<CassetteEntitlementAdjustmentFilterInput>;
};


/** A cassette. */
export type CassetteOverflowRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CassetteOverflowRequestSortInput>>;
  where?: InputMaybe<CassetteOverflowRequestFilterInput>;
};

/** A cassette-local customer entitlement adjustment. */
export type CassetteEntitlementAdjustment = {
  __typename?: 'CassetteEntitlementAdjustment';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Signed change in customer test entitlement. */
  customerTestDelta: Scalars['Int']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Optional notes. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Adjustment reason code. */
  reasonCode: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A cassette-local customer entitlement adjustment. */
export type CassetteEntitlementAdjustmentFilterInput = {
  and?: InputMaybe<Array<CassetteEntitlementAdjustmentFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Signed change in customer test entitlement. */
  customerTestDelta?: InputMaybe<IntOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CassetteEntitlementAdjustmentFilterInput>>;
  /** Adjustment reason code. */
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A cassette-local customer entitlement adjustment. */
export type CassetteEntitlementAdjustmentSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Signed change in customer test entitlement. */
  customerTestDelta?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Adjustment reason code. */
  reasonCode?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A cassette. */
export type CassetteFilterInput = {
  and?: InputMaybe<Array<CassetteFilterInput>>;
  /** Number of failing sensor checks (non-debug). */
  badSensorCount?: InputMaybe<IntOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Expiry date. */
  expiryDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<StringOperationFilterInput>;
  /** Number of passing sensor checks (non-debug). */
  goodSensorCount?: InputMaybe<IntOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Manufacture date. */
  manufactureDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Maximum index time in seconds. */
  maxIndexTimeSeconds?: InputMaybe<FloatOperationFilterInput>;
  /** Number of sensors. */
  numSensors?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CassetteFilterInput>>;
  /** Sensor check UUID. */
  sensorCheckUuid?: InputMaybe<UuidOperationFilterInput>;
  /** Soil test UUID. */
  soilTestUuid?: InputMaybe<UuidOperationFilterInput>;
  /** TRH type. */
  trhType?: InputMaybe<TrhTypeOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CassetteLastUsedInfo = {
  __typename?: 'CassetteLastUsedInfo';
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  usedAt: Scalars['DateTime']['output'];
};

export type CassetteListSummary = {
  __typename?: 'CassetteListSummary';
  allocatedCustomerTests: Scalars['Int']['output'];
  openOverflowWarningCount: Scalars['Int']['output'];
  provisionedCount: Scalars['Int']['output'];
  remainingCustomerTests: Scalars['Int']['output'];
};

/** A request to carry owed tests forward from an exhausted cassette. */
export type CassetteOverflowRequest = {
  __typename?: 'CassetteOverflowRequest';
  cassette?: Maybe<Cassette>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Optional notes. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Outstanding tests still to be fulfilled. */
  outstandingTests: Scalars['Int']['output'];
  /** Reason code. */
  reasonCode: Scalars['String']['output'];
  /** Requested tests to carry forward. */
  requestedTests: Scalars['Int']['output'];
  /** When the request was resolved. */
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current request status. */
  status: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A request to carry owed tests forward from an exhausted cassette. */
export type CassetteOverflowRequestFilterInput = {
  and?: InputMaybe<Array<CassetteOverflowRequestFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CassetteOverflowRequestFilterInput>>;
  /** Outstanding tests still to be fulfilled. */
  outstandingTests?: InputMaybe<IntOperationFilterInput>;
  /** Reason code. */
  reasonCode?: InputMaybe<StringOperationFilterInput>;
  /** Requested tests to carry forward. */
  requestedTests?: InputMaybe<IntOperationFilterInput>;
  /** When the request was resolved. */
  resolvedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Current request status. */
  status?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A request to carry owed tests forward from an exhausted cassette. */
export type CassetteOverflowRequestSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Outstanding tests still to be fulfilled. */
  outstandingTests?: InputMaybe<SortEnumType>;
  /** Reason code. */
  reasonCode?: InputMaybe<SortEnumType>;
  /** Requested tests to carry forward. */
  requestedTests?: InputMaybe<SortEnumType>;
  /** When the request was resolved. */
  resolvedAt?: InputMaybe<SortEnumType>;
  /** Current request status. */
  status?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A cassette. */
export type CassetteSortInput = {
  /** Number of failing sensor checks (non-debug). */
  badSensorCount?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Expiry date. */
  expiryDate?: InputMaybe<SortEnumType>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<SortEnumType>;
  /** Number of passing sensor checks (non-debug). */
  goodSensorCount?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Manufacture date. */
  manufactureDate?: InputMaybe<SortEnumType>;
  /** Maximum index time in seconds. */
  maxIndexTimeSeconds?: InputMaybe<SortEnumType>;
  /** Number of sensors. */
  numSensors?: InputMaybe<SortEnumType>;
  /** Sensor check UUID. */
  sensorCheckUuid?: InputMaybe<SortEnumType>;
  /** Soil test UUID. */
  soilTestUuid?: InputMaybe<SortEnumType>;
  /** TRH type. */
  trhType?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CassettesConnection = {
  __typename?: 'CassettesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CassettesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Cassette>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CassettesEdge = {
  __typename?: 'CassettesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Cassette;
};

export type ChangeOwnPasswordInput = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type ChunksConnection = {
  __typename?: 'ChunksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ChunksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UploadChunk>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ChunksEdge = {
  __typename?: 'ChunksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UploadChunk;
};

/** Input for copying a trained indicator to another model. */
export type CopyTrainedIndicatorInput = {
  /** Target MLModel ID. */
  targetModelId: Scalars['UUID']['input'];
  /** Source trained indicator ID. */
  trainedIndicatorId: Scalars['UUID']['input'];
};

/** A cover crop option (unique by normalized name). */
export type CoverCrop = {
  __typename?: 'CoverCrop';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A cover crop option (unique by normalized name). */
export type CoverCropFilterInput = {
  and?: InputMaybe<Array<CoverCropFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CoverCropFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A cover crop option (unique by normalized name). */
export type CoverCropSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CoverCropsConnection = {
  __typename?: 'CoverCropsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CoverCropsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CoverCrop>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CoverCropsEdge = {
  __typename?: 'CoverCropsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CoverCrop;
};

export type CreateAccountWithPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Input for creating a Batch. */
export type CreateBatchInput = {
  batchNumber: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Input for creating a Cassette. */
export type CreateCassetteInput = {
  expiryDate: Scalars['DateTime']['input'];
  extraMetadata?: InputMaybe<Scalars['String']['input']>;
  manufactureDate: Scalars['DateTime']['input'];
  maxIndexTimeSeconds: Scalars['Float']['input'];
  numSensors: Scalars['Int']['input'];
  sensorCheckUuid: Scalars['UUID']['input'];
  serialNumberId?: InputMaybe<Scalars['UUID']['input']>;
  soilTestUuid: Scalars['UUID']['input'];
  trhType?: InputMaybe<TrhType>;
};

/** Input for creating an overflow request on an exhausted cassette. */
export type CreateCassetteOverflowRequestInput = {
  cassetteId: Scalars['UUID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reasonCode: Scalars['String']['input'];
  requestedTests: Scalars['Int']['input'];
};

export type CreateCoverCropInput = {
  /** Display name. */
  name: Scalars['String']['input'];
};

export type CreateCropInput = {
  /** Display name. */
  name: Scalars['String']['input'];
};

export type CreateCropTypeInput = {
  /** Display name. */
  name: Scalars['String']['input'];
};

export type CreateCultivationInput = {
  /** Display name. */
  name: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  /** Lab indicator definition IDs the customer's users may see (required when limitIndicators is true). */
  allowedIndicatorDefinitionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Cassette IDs to attach (optional). */
  cassetteIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact name. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** When the customer relationship began (defaults to now). */
  customerSince?: InputMaybe<Scalars['DateTime']['input']>;
  /** Description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ERU IDs to attach (optional). */
  eruIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Whether to limit visible results to the allowed indicator definitions (defaults to false). */
  limitIndicators?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Internal notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Organisation IDs to attach (optional). */
  organisationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CreateEruInput = {
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<Scalars['String']['input']>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<Scalars['String']['input']>;
  /** Internal UUID for the ERU. */
  internalId: Scalars['UUID']['input'];
  /** Display name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating an Example. */
export type CreateExampleInput = {
  name: Scalars['String']['input'];
};

export type CreateFarmInput = {
  /** Display name. */
  name: Scalars['String']['input'];
  /** Organisation ID. */
  organisationId: Scalars['UUID']['input'];
  /** Owner name. */
  ownerName?: InputMaybe<Scalars['String']['input']>;
  /** Postcode. */
  postcode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFieldInput = {
  /** Farm ID. */
  farmId: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type CreateFirmwareInstallLogInput = {
  dfuProductId?: InputMaybe<Scalars['String']['input']>;
  dfuSerialNumber?: InputMaybe<Scalars['String']['input']>;
  eruId?: InputMaybe<Scalars['UUID']['input']>;
  eruName?: InputMaybe<Scalars['String']['input']>;
  firmwareVersionId: Scalars['UUID']['input'];
  fromVersion?: InputMaybe<Scalars['String']['input']>;
  runtimePortName?: InputMaybe<Scalars['String']['input']>;
  runtimeProductId?: InputMaybe<Scalars['String']['input']>;
  runtimeSerialNumber?: InputMaybe<Scalars['String']['input']>;
  technicalLog?: InputMaybe<Scalars['String']['input']>;
  toVersion: Scalars['String']['input'];
};

export type CreateFirmwareInstallLogPayload = {
  __typename?: 'CreateFirmwareInstallLogPayload';
  log: FirmwareInstallLog;
  updateToken: Scalars['String']['output'];
};

/** Input for creating a GPS location. */
export type CreateGpsLocationInput = {
  /** Accuracy in meters. */
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  /** Latitude. */
  latitude: Scalars['Float']['input'];
  /** Longitude. */
  longitude: Scalars['Float']['input'];
};

export type CreateLabIndicatorDefinitionInput = {
  /** Whether to always show this indicator. */
  alwaysShow?: Scalars['Boolean']['input'];
  /** Indicator description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  displayDecimalPlaces?: Scalars['Int']['input'];
  /** Optional display name override. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Unit label. */
  unit?: Scalars['String']['input'];
  /** Value type. */
  valueType: LabIndicatorValueType;
};

export type CreateLabResultInput = {
  /** Indicator definition ID. */
  indicatorId: Scalars['UUID']['input'];
  /** Laboratory ID. */
  laboratoryId: Scalars['UUID']['input'];
  /** SoilSample ID. */
  soilSampleId: Scalars['UUID']['input'];
  /** Lab result value. */
  value: Scalars['String']['input'];
};

export type CreateLaboratoryInput = {
  /** Display name. */
  name: Scalars['String']['input'];
};

/** Input for creating a localisation file from a base JSON upload. */
export type CreateLocalisationFileInput = {
  jsonContent: Scalars['String']['input'];
  name: Scalars['String']['input'];
  translationContext?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMlModelInput = {
  /** Display name. */
  name: Scalars['String']['input'];
};

export type CreateOrganisationInput = {
  contactEmail: Scalars['String']['input'];
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isAutocreated?: Scalars['Boolean']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  public?: Scalars['Boolean']['input'];
};

export type CreatePesTestInput = {
  /** Cassette ID. */
  cassetteId: Scalars['UUID']['input'];
  /** CropType ID. */
  cropTypeId: Scalars['UUID']['input'];
  /** ERU ID. */
  eruId: Scalars['UUID']['input'];
  /** Whether to exclude from ML. */
  excludeFromMl?: Scalars['Boolean']['input'];
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<Scalars['String']['input']>;
  /** Failure reasons. */
  failureReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Field ID (used to derive farm and organisation). */
  fieldId: Scalars['UUID']['input'];
  /** Firmware version. */
  firmwareVersion: Scalars['String']['input'];
  /** GPS accuracy in meters. */
  gpsAccuracy?: InputMaybe<Scalars['Float']['input']>;
  /** GPS latitude. */
  gpsLatitude: Scalars['Float']['input'];
  /** GPS longitude. */
  gpsLongitude: Scalars['Float']['input'];
  /** Whether this test was run in debug mode. */
  isDebug?: Scalars['Boolean']['input'];
  /** Whether this test failed. */
  isFailure?: Scalars['Boolean']['input'];
  /** Whether this test is from a reference zone. */
  isReferenceZone?: Scalars['Boolean']['input'];
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Original model name. */
  originalModelName: Scalars['String']['input'];
  /** Logical run UUID. */
  runId: Scalars['UUID']['input'];
  /** Season. */
  season: Season;
  /** Optional SoilSample ID. */
  soilSampleId?: InputMaybe<Scalars['UUID']['input']>;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** SRF UUID. */
  srfUuid: Scalars['UUID']['input'];
  /** Test type. */
  testType: PesTestType;
  /** TRO UUID. */
  troUuid: Scalars['UUID']['input'];
  /** UTC test time. */
  utcTestTime: Scalars['DateTime']['input'];
};

/** Input for creating a ProductType. */
export type CreateProductTypeInput = {
  location: Scalars['String']['input'];
  model: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subType: Scalars['String']['input'];
};

/** Input for creating a report. */
export type CreateReportInput = {
  format?: InputMaybe<ReportFormat>;
  pesTestIds: Array<Scalars['UUID']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a result. */
export type CreateResultInput = {
  /** Trained indicator ID. */
  indicatorId: Scalars['UUID']['input'];
  /** PESTest ID. */
  pesTestId: Scalars['UUID']['input'];
  /** Result value. */
  value: Scalars['Float']['input'];
};

export type CreateSerialNumberInput = {
  /** Batch ID. */
  batchId: Scalars['UUID']['input'];
  /** Serial number (0-9999999). */
  serialNumber: Scalars['Int']['input'];
  /** Serial range ID. */
  serialRangeId: Scalars['UUID']['input'];
};

export type CreateSerialRangeInput = {
  /** Build description. */
  buildDescription: Scalars['String']['input'];
  /** Build end date. */
  buildEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Build start date. */
  buildStartDate: Scalars['DateTime']['input'];
  /** Inclusive end of the range. */
  endNumber: Scalars['Int']['input'];
  /** Firmware version. */
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  /** Notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Product type ID. */
  productTypeId: Scalars['UUID']['input'];
  /** Inclusive start of the range. */
  startNumber: Scalars['Int']['input'];
};

export type CreateSoilSampleInput = {
  /** CoverCrop ID. */
  coverCropId?: InputMaybe<Scalars['UUID']['input']>;
  /** CropType ID. */
  cropTypeId?: InputMaybe<Scalars['UUID']['input']>;
  /** Cultivation ID. */
  cultivationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Farm ID. */
  farmId?: InputMaybe<Scalars['UUID']['input']>;
  /** Field ID. */
  fieldId?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether farmyard manure (FYM) was applied. */
  fym: Scalars['Boolean']['input'];
  /** GPS latitude. Provide both latitude and longitude to set a location. */
  gpsLatitude?: InputMaybe<Scalars['Float']['input']>;
  /** GPS longitude. Provide both latitude and longitude to set a location. */
  gpsLongitude?: InputMaybe<Scalars['Float']['input']>;
  /** Whether this sample is from a reference zone. */
  isReferenceZone: Scalars['Boolean']['input'];
  /** Last year's crop ID. */
  lastYearCropId?: InputMaybe<Scalars['UUID']['input']>;
  /** Moisture level. */
  moisture?: InputMaybe<MoistureLevel>;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Season. */
  season?: InputMaybe<Season>;
  /** SoilType ID. */
  soilTypeId?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether straw was removed. */
  strawRemoved: Scalars['Boolean']['input'];
  /** Year before last crop ID. */
  yearBeforeLastCropId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateSoilTypeInput = {
  /** Display name. */
  name: Scalars['String']['input'];
};

export type CreateTroFromUnknownInput = {
  /** Display name for the TRO. */
  name: Scalars['String']['input'];
  /** Unknown TRO UUID currently referenced by at least one PES test. */
  uuid: Scalars['UUID']['input'];
};

/** Input for creating a trained indicator. */
export type CreateTrainedIndicatorInput = {
  /** Lab indicator definition ID. */
  indicatorDefinitionId: Scalars['UUID']['input'];
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum value. */
  maxValue: Scalars['Float']['input'];
  /** Minimum value. */
  minValue: Scalars['Float']['input'];
  /** MLModel ID. */
  modelId: Scalars['UUID']['input'];
};

/** Input for creating or updating an upload chunk. */
export type CreateUploadChunkInput = {
  chunkIndex: Scalars['Int']['input'];
  data: Scalars['String']['input'];
  uploadRequestId: Scalars['UUID']['input'];
};

/** Input for creating an upload request. */
export type CreateUploadRequestInput = {
  pesTestId: Scalars['UUID']['input'];
  totalChunks: Scalars['Int']['input'];
};

/** Input for creating a What3Words location. */
export type CreateWhat3WordsLocationInput = {
  gpsLatitudeCenter: Scalars['Float']['input'];
  gpsLatitudeNe: Scalars['Float']['input'];
  gpsLatitudeSw: Scalars['Float']['input'];
  gpsLongitudeCenter: Scalars['Float']['input'];
  gpsLongitudeNe: Scalars['Float']['input'];
  gpsLongitudeSw: Scalars['Float']['input'];
  words: Scalars['String']['input'];
};

/** A crop (unique by normalized name). */
export type Crop = {
  __typename?: 'Crop';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A crop (unique by normalized name). */
export type CropFilterInput = {
  and?: InputMaybe<Array<CropFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CropFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A crop (unique by normalized name). */
export type CropSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A type of crop/cultivation area (unique by normalized name). */
export type CropType = {
  __typename?: 'CropType';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A type of crop/cultivation area (unique by normalized name). */
export type CropTypeFilterInput = {
  and?: InputMaybe<Array<CropTypeFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CropTypeFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A type of crop/cultivation area (unique by normalized name). */
export type CropTypeSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CropTypesConnection = {
  __typename?: 'CropTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CropTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CropType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CropTypesEdge = {
  __typename?: 'CropTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CropType;
};

/** A connection to a list of items. */
export type CropsConnection = {
  __typename?: 'CropsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CropsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Crop>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CropsEdge = {
  __typename?: 'CropsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Crop;
};

/** A cultivation method (unique by normalized name). */
export type Cultivation = {
  __typename?: 'Cultivation';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A cultivation method (unique by normalized name). */
export type CultivationFilterInput = {
  and?: InputMaybe<Array<CultivationFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CultivationFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A cultivation method (unique by normalized name). */
export type CultivationSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CultivationsConnection = {
  __typename?: 'CultivationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CultivationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Cultivation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CultivationsEdge = {
  __typename?: 'CultivationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Cultivation;
};

/** A customer. */
export type Customer = {
  __typename?: 'Customer';
  /** Lab indicator definitions this customer's users may see when limitIndicators is enabled. */
  allowedIndicatorDefinitions: Array<LabIndicatorDefinition>;
  cassettes?: Maybe<CassettesConnection>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** Primary contact email address. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Primary contact name. */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Primary contact phone number. */
  contactPhone?: Maybe<Scalars['String']['output']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** When the customer relationship began. */
  customerSince: Scalars['DateTime']['output'];
  /** Description. */
  description?: Maybe<Scalars['String']['output']>;
  erus?: Maybe<ErusConnection>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Whether results visible to this customer's (non-staff) users are limited to the allowed indicator definitions. */
  limitIndicators: Scalars['Boolean']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** Internal notes. */
  notes?: Maybe<Scalars['String']['output']>;
  organisations?: Maybe<OrganisationsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A customer. */
export type CustomerCassettesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CassetteSortInput>>;
  where?: InputMaybe<CassetteFilterInput>;
};


/** A customer. */
export type CustomerErusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EruSortInput>>;
  where?: InputMaybe<EruFilterInput>;
};


/** A customer. */
export type CustomerOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};

/** A customer. */
export type CustomerFilterInput = {
  and?: InputMaybe<Array<CustomerFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  /** Primary contact name. */
  contactName?: InputMaybe<StringOperationFilterInput>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When the customer relationship began. */
  customerSince?: InputMaybe<DateTimeOperationFilterInput>;
  /** Description. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether results visible to this customer's (non-staff) users are limited to the allowed indicator definitions. */
  limitIndicators?: InputMaybe<BooleanOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Internal notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A customer. */
export type CustomerSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<SortEnumType>;
  /** Primary contact name. */
  contactName?: InputMaybe<SortEnumType>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** When the customer relationship began. */
  customerSince?: InputMaybe<SortEnumType>;
  /** Description. */
  description?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether results visible to this customer's (non-staff) users are limited to the allowed indicator definitions. */
  limitIndicators?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Internal notes. */
  notes?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CustomersConnection = {
  __typename?: 'CustomersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Customer>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomersEdge = {
  __typename?: 'CustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Customer;
};

export type DailyTestMetrics = {
  __typename?: 'DailyTestMetrics';
  date: Scalars['DateTime']['output'];
  failedSensorChecks: Scalars['Int']['output'];
  soilTests: Scalars['Int']['output'];
  successfulSensorChecks: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  currentPeriod: Array<DailyTestMetrics>;
  mapPoints: Array<MapPoint>;
  organisationStats: Array<OrganisationTestStats>;
  previousPeriod: Array<DailyTestMetrics>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteOwnAccountInput = {
  /** The account's email address, typed by the user to confirm. */
  confirmationEmail: Scalars['String']['input'];
  /** Required only when the account has a password. */
  currentPassword?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteOwnAccountPayload = {
  __typename?: 'DeleteOwnAccountPayload';
  /** Deletion request id. Safe to quote to support; contains no personal data. */
  reference: Scalars['UUID']['output'];
  status: AccountDeletionStatus;
};

export type DeletePesTestInput = {
  /** Reason for deleting the test. */
  reason: Scalars['String']['input'];
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

/** An ERU device. */
export type Eru = {
  __typename?: 'ERU';
  /** BLE identifier (unique when present). */
  bleId?: Maybe<Scalars['String']['output']>;
  /** BLE MAC address (unique when present). */
  bleMac?: Maybe<Scalars['String']['output']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Internal UUID for the ERU. */
  internalId: Scalars['UUID']['output'];
  /** Display name. */
  name?: Maybe<Scalars['String']['output']>;
  tests?: Maybe<TestsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** An ERU device. */
export type EruTestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  where?: InputMaybe<PesTestFilterInput>;
};

/** An ERU device. */
export type EruFilterInput = {
  and?: InputMaybe<Array<EruFilterInput>>;
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<StringOperationFilterInput>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Internal UUID for the ERU. */
  internalId?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EruFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An ERU device. */
export type EruSortInput = {
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<SortEnumType>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Internal UUID for the ERU. */
  internalId?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EntitlementAdjustmentsConnection = {
  __typename?: 'EntitlementAdjustmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EntitlementAdjustmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CassetteEntitlementAdjustment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EntitlementAdjustmentsEdge = {
  __typename?: 'EntitlementAdjustmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CassetteEntitlementAdjustment;
};

/** A connection to a list of items. */
export type ErusConnection = {
  __typename?: 'ErusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ErusEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Eru>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ErusEdge = {
  __typename?: 'ErusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Eru;
};

/** A simple example entity from the Example module. */
export type Example = {
  __typename?: 'Example';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  items?: Maybe<ItemsConnection>;
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A simple example entity from the Example module. */
export type ExampleItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ExampleItemSortInput>>;
  where?: InputMaybe<ExampleItemFilterInput>;
};

/** A simple example entity from the Example module. */
export type ExampleFilterInput = {
  and?: InputMaybe<Array<ExampleFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExampleFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An item belonging to an Example. */
export type ExampleItem = {
  __typename?: 'ExampleItem';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An item belonging to an Example. */
export type ExampleItemFilterInput = {
  and?: InputMaybe<Array<ExampleItemFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ExampleItemFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An item belonging to an Example. */
export type ExampleItemSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A simple example entity from the Example module. */
export type ExampleSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ExamplesConnection = {
  __typename?: 'ExamplesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ExamplesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Example>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ExamplesEdge = {
  __typename?: 'ExamplesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Example;
};

/** A connection to a list of items. */
export type FailedItemsConnection = {
  __typename?: 'FailedItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FailedItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FeatureExtractionExportItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FailedItemsEdge = {
  __typename?: 'FailedItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeatureExtractionExportItem;
};

/** A farm. */
export type Farm = {
  __typename?: 'Farm';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  fields?: Maybe<FieldsConnection>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  organisation?: Maybe<Organisation>;
  /** Owner name. */
  ownerName?: Maybe<Scalars['String']['output']>;
  /** Postcode. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A farm. */
export type FarmFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FieldSortInput>>;
  where?: InputMaybe<FieldFilterInput>;
};

/** A farm. */
export type FarmFilterInput = {
  and?: InputMaybe<Array<FarmFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FarmFilterInput>>;
  /** Owner name. */
  ownerName?: InputMaybe<StringOperationFilterInput>;
  /** Postcode. */
  postcode?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A farm. */
export type FarmSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Owner name. */
  ownerName?: InputMaybe<SortEnumType>;
  /** Postcode. */
  postcode?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FarmsConnection = {
  __typename?: 'FarmsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FarmsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Farm>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FarmsEdge = {
  __typename?: 'FarmsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Farm;
};

export type FeatureExtractionExportDownload = {
  __typename?: 'FeatureExtractionExportDownload';
  expiresAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum FeatureExtractionExportDownloadState {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Unavailable = 'UNAVAILABLE'
}

export type FeatureExtractionExportDownloadStateOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportDownloadState>;
  in?: InputMaybe<Array<FeatureExtractionExportDownloadState>>;
  neq?: InputMaybe<FeatureExtractionExportDownloadState>;
  nin?: InputMaybe<Array<FeatureExtractionExportDownloadState>>;
};

/** The snapshotted state and extraction outcome for one PES test in an export run. */
export type FeatureExtractionExportItem = {
  __typename?: 'FeatureExtractionExportItem';
  attemptCount: Scalars['Int']['output'];
  cacheSourceUri?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  farmName: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  sampleDate: Scalars['String']['output'];
  sampleUrl: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: FeatureExtractionExportItemStatus;
  /** PES test UUID represented by this row. */
  testId: Scalars['UUID']['output'];
  testName: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The snapshotted state and extraction outcome for one PES test in an export run. */
export type FeatureExtractionExportItemFilterInput = {
  and?: InputMaybe<Array<FeatureExtractionExportItemFilterInput>>;
  attemptCount?: InputMaybe<IntOperationFilterInput>;
  cacheSourceUri?: InputMaybe<StringOperationFilterInput>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  error?: InputMaybe<StringOperationFilterInput>;
  farmName?: InputMaybe<StringOperationFilterInput>;
  fieldName?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<FeatureExtractionExportItemFilterInput>>;
  sampleDate?: InputMaybe<StringOperationFilterInput>;
  sampleUrl?: InputMaybe<StringOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<FeatureExtractionExportItemStatusOperationFilterInput>;
  /** PES test UUID represented by this row. */
  testId?: InputMaybe<UuidOperationFilterInput>;
  testName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** The snapshotted state and extraction outcome for one PES test in an export run. */
export type FeatureExtractionExportItemSortInput = {
  attemptCount?: InputMaybe<SortEnumType>;
  cacheSourceUri?: InputMaybe<SortEnumType>;
  completedAt?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  error?: InputMaybe<SortEnumType>;
  farmName?: InputMaybe<SortEnumType>;
  fieldName?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  sampleDate?: InputMaybe<SortEnumType>;
  sampleUrl?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /** PES test UUID represented by this row. */
  testId?: InputMaybe<SortEnumType>;
  testName?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum FeatureExtractionExportItemStatus {
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  ReusedCache = 'REUSED_CACHE',
  Succeeded = 'SUCCEEDED'
}

export type FeatureExtractionExportItemStatusOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportItemStatus>;
  in?: InputMaybe<Array<FeatureExtractionExportItemStatus>>;
  neq?: InputMaybe<FeatureExtractionExportItemStatus>;
  nin?: InputMaybe<Array<FeatureExtractionExportItemStatus>>;
};

export enum FeatureExtractionExportMode {
  FromScratch = 'FROM_SCRATCH',
  MissingCurrentVersion = 'MISSING_CURRENT_VERSION'
}

export type FeatureExtractionExportModeOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportMode>;
  in?: InputMaybe<Array<FeatureExtractionExportMode>>;
  neq?: InputMaybe<FeatureExtractionExportMode>;
  nin?: InputMaybe<Array<FeatureExtractionExportMode>>;
};

/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRun = {
  __typename?: 'FeatureExtractionExportRun';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedExtractionCount: Scalars['Int']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  csvBucket?: Maybe<Scalars['String']['output']>;
  csvColumnCount?: Maybe<Scalars['Int']['output']>;
  csvFileName?: Maybe<Scalars['String']['output']>;
  csvObjectGeneration?: Maybe<Scalars['String']['output']>;
  csvObjectName?: Maybe<Scalars['String']['output']>;
  csvRowCount?: Maybe<Scalars['Int']['output']>;
  csvSha256?: Maybe<Scalars['String']['output']>;
  csvSizeBytes?: Maybe<Scalars['Long']['output']>;
  csvSourceUri?: Maybe<Scalars['String']['output']>;
  downloadState: FeatureExtractionExportDownloadState;
  errorSummary?: Maybe<Scalars['String']['output']>;
  excludedTestCount: Scalars['Int']['output'];
  failedExtractionCount: Scalars['Int']['output'];
  failedItems?: Maybe<FailedItemsConnection>;
  /** Feature-set version snapshotted when the run started. */
  featureSetVersion: Scalars['String']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  labResultWarningCount: Scalars['Int']['output'];
  mode: FeatureExtractionExportMode;
  queuedExtractionCount: Scalars['Int']['output'];
  /** Email of the superadmin who requested the run. */
  requestedByEmail?: Maybe<Scalars['String']['output']>;
  reusedCacheCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: FeatureExtractionExportStatus;
  /** Optional maximum number of valid PES tests selected for this run. */
  testLimit?: Maybe<Scalars['Int']['output']>;
  totalTestCount: Scalars['Int']['output'];
  /** TRO UUID selected for this run. */
  troUuid: Scalars['UUID']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRunFailedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FeatureExtractionExportItemSortInput>>;
  where?: InputMaybe<FeatureExtractionExportItemFilterInput>;
};

/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRunFilterInput = {
  and?: InputMaybe<Array<FeatureExtractionExportRunFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  completedExtractionCount?: InputMaybe<IntOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  csvBucket?: InputMaybe<StringOperationFilterInput>;
  csvColumnCount?: InputMaybe<IntOperationFilterInput>;
  csvFileName?: InputMaybe<StringOperationFilterInput>;
  csvObjectGeneration?: InputMaybe<StringOperationFilterInput>;
  csvObjectName?: InputMaybe<StringOperationFilterInput>;
  csvRowCount?: InputMaybe<IntOperationFilterInput>;
  csvSha256?: InputMaybe<StringOperationFilterInput>;
  csvSizeBytes?: InputMaybe<LongOperationFilterInput>;
  csvSourceUri?: InputMaybe<StringOperationFilterInput>;
  downloadState?: InputMaybe<FeatureExtractionExportDownloadStateOperationFilterInput>;
  errorSummary?: InputMaybe<StringOperationFilterInput>;
  excludedTestCount?: InputMaybe<IntOperationFilterInput>;
  failedExtractionCount?: InputMaybe<IntOperationFilterInput>;
  /** Feature-set version snapshotted when the run started. */
  featureSetVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  labResultWarningCount?: InputMaybe<IntOperationFilterInput>;
  mode?: InputMaybe<FeatureExtractionExportModeOperationFilterInput>;
  or?: InputMaybe<Array<FeatureExtractionExportRunFilterInput>>;
  queuedExtractionCount?: InputMaybe<IntOperationFilterInput>;
  /** Email of the superadmin who requested the run. */
  requestedByEmail?: InputMaybe<StringOperationFilterInput>;
  reusedCacheCount?: InputMaybe<IntOperationFilterInput>;
  startedAt?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<FeatureExtractionExportStatusOperationFilterInput>;
  /** Optional maximum number of valid PES tests selected for this run. */
  testLimit?: InputMaybe<IntOperationFilterInput>;
  totalTestCount?: InputMaybe<IntOperationFilterInput>;
  /** TRO UUID selected for this run. */
  troUuid?: InputMaybe<UuidOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A durable feature-extraction and CSV-export run for one TRO. */
export type FeatureExtractionExportRunSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  completedExtractionCount?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  csvBucket?: InputMaybe<SortEnumType>;
  csvColumnCount?: InputMaybe<SortEnumType>;
  csvFileName?: InputMaybe<SortEnumType>;
  csvObjectGeneration?: InputMaybe<SortEnumType>;
  csvObjectName?: InputMaybe<SortEnumType>;
  csvRowCount?: InputMaybe<SortEnumType>;
  csvSha256?: InputMaybe<SortEnumType>;
  csvSizeBytes?: InputMaybe<SortEnumType>;
  csvSourceUri?: InputMaybe<SortEnumType>;
  downloadState?: InputMaybe<SortEnumType>;
  errorSummary?: InputMaybe<SortEnumType>;
  excludedTestCount?: InputMaybe<SortEnumType>;
  failedExtractionCount?: InputMaybe<SortEnumType>;
  /** Feature-set version snapshotted when the run started. */
  featureSetVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  labResultWarningCount?: InputMaybe<SortEnumType>;
  mode?: InputMaybe<SortEnumType>;
  queuedExtractionCount?: InputMaybe<SortEnumType>;
  /** Email of the superadmin who requested the run. */
  requestedByEmail?: InputMaybe<SortEnumType>;
  reusedCacheCount?: InputMaybe<SortEnumType>;
  startedAt?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  /** Optional maximum number of valid PES tests selected for this run. */
  testLimit?: InputMaybe<SortEnumType>;
  totalTestCount?: InputMaybe<SortEnumType>;
  /** TRO UUID selected for this run. */
  troUuid?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FeatureExtractionExportRunsConnection = {
  __typename?: 'FeatureExtractionExportRunsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FeatureExtractionExportRunsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FeatureExtractionExportRun>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FeatureExtractionExportRunsEdge = {
  __typename?: 'FeatureExtractionExportRunsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeatureExtractionExportRun;
};

export enum FeatureExtractionExportStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Extracting = 'EXTRACTING',
  Failed = 'FAILED',
  GeneratingCsv = 'GENERATING_CSV',
  Preparing = 'PREPARING'
}

export type FeatureExtractionExportStatusOperationFilterInput = {
  eq?: InputMaybe<FeatureExtractionExportStatus>;
  in?: InputMaybe<Array<FeatureExtractionExportStatus>>;
  neq?: InputMaybe<FeatureExtractionExportStatus>;
  nin?: InputMaybe<Array<FeatureExtractionExportStatus>>;
};

/** A field. */
export type Field = {
  __typename?: 'Field';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  farm?: Maybe<Farm>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A field. */
export type FieldFilterInput = {
  and?: InputMaybe<Array<FieldFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FieldFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A field. */
export type FieldSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FieldsConnection = {
  __typename?: 'FieldsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FieldsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Field>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FieldsEdge = {
  __typename?: 'FieldsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Field;
};

export type FirmwareInstallLog = {
  __typename?: 'FirmwareInstallLog';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  dfuProductId?: Maybe<Scalars['String']['output']>;
  dfuSerialNumber?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eru?: Maybe<Eru>;
  eruName?: Maybe<Scalars['String']['output']>;
  firmwareVersion?: Maybe<FirmwareVersion>;
  fromVersion?: Maybe<Scalars['String']['output']>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  runtimePortName?: Maybe<Scalars['String']['output']>;
  runtimeProductId?: Maybe<Scalars['String']['output']>;
  runtimeSerialNumber?: Maybe<Scalars['String']['output']>;
  status: FirmwareInstallLogStatus;
  technicalLog?: Maybe<Scalars['String']['output']>;
  toVersion: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

export type FirmwareInstallLogFilterInput = {
  and?: InputMaybe<Array<FirmwareInstallLogFilterInput>>;
  completedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  dfuProductId?: InputMaybe<StringOperationFilterInput>;
  dfuSerialNumber?: InputMaybe<StringOperationFilterInput>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  eruName?: InputMaybe<StringOperationFilterInput>;
  fromVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareInstallLogFilterInput>>;
  runtimePortName?: InputMaybe<StringOperationFilterInput>;
  runtimeProductId?: InputMaybe<StringOperationFilterInput>;
  runtimeSerialNumber?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<FirmwareInstallLogStatusOperationFilterInput>;
  technicalLog?: InputMaybe<StringOperationFilterInput>;
  toVersion?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export type FirmwareInstallLogSortInput = {
  completedAt?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  dfuProductId?: InputMaybe<SortEnumType>;
  dfuSerialNumber?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  eruName?: InputMaybe<SortEnumType>;
  fromVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  runtimePortName?: InputMaybe<SortEnumType>;
  runtimeProductId?: InputMaybe<SortEnumType>;
  runtimeSerialNumber?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  technicalLog?: InputMaybe<SortEnumType>;
  toVersion?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum FirmwareInstallLogStatus {
  Downloading = 'DOWNLOADING',
  Failed = 'FAILED',
  Flashing = 'FLASHING',
  Requested = 'REQUESTED',
  Succeeded = 'SUCCEEDED'
}

export type FirmwareInstallLogStatusOperationFilterInput = {
  eq?: InputMaybe<FirmwareInstallLogStatus>;
  in?: InputMaybe<Array<FirmwareInstallLogStatus>>;
  neq?: InputMaybe<FirmwareInstallLogStatus>;
  nin?: InputMaybe<Array<FirmwareInstallLogStatus>>;
};

/** A connection to a list of items. */
export type FirmwareInstallLogsConnection = {
  __typename?: 'FirmwareInstallLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareInstallLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareInstallLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FirmwareInstallLogsEdge = {
  __typename?: 'FirmwareInstallLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FirmwareInstallLog;
};

export type FirmwareVersion = {
  __typename?: 'FirmwareVersion';
  blobContainer: Scalars['String']['output'];
  blobName: Scalars['String']['output'];
  blobUrl: Scalars['String']['output'];
  byteLength: Scalars['Long']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  installCount: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  sha256: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  uploadedByUser?: Maybe<User>;
  version: Scalars['String']['output'];
};

export type FirmwareVersionFilterInput = {
  and?: InputMaybe<Array<FirmwareVersionFilterInput>>;
  blobContainer?: InputMaybe<StringOperationFilterInput>;
  blobName?: InputMaybe<StringOperationFilterInput>;
  blobUrl?: InputMaybe<StringOperationFilterInput>;
  byteLength?: InputMaybe<LongOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareVersionFilterInput>>;
  sha256?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareVersionSortInput = {
  blobContainer?: InputMaybe<SortEnumType>;
  blobName?: InputMaybe<SortEnumType>;
  blobUrl?: InputMaybe<SortEnumType>;
  byteLength?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  fileName?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  sha256?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FirmwareVersionsConnection = {
  __typename?: 'FirmwareVersionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareVersionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareVersion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FirmwareVersionsEdge = {
  __typename?: 'FirmwareVersionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FirmwareVersion;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

/** Input for fulfilling an overflow request from a future cassette. */
export type FulfilCassetteOverflowRequestInput = {
  fulfilledByCassetteId: Scalars['UUID']['input'];
  fulfilledTests: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  overflowRequestId: Scalars['UUID']['input'];
};

/** A GPS location. */
export type GpsLocation = {
  __typename?: 'GPSLocation';
  /** Accuracy in meters. */
  accuracy?: Maybe<Scalars['Float']['output']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Latitude. */
  latitude: Scalars['Float']['output'];
  /** Longitude. */
  longitude: Scalars['Float']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  what3Words?: Maybe<What3WordsLocation>;
};

/** A GPS location. */
export type GpsLocationFilterInput = {
  /** Accuracy in meters. */
  accuracy?: InputMaybe<FloatOperationFilterInput>;
  and?: InputMaybe<Array<GpsLocationFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Latitude. */
  latitude?: InputMaybe<FloatOperationFilterInput>;
  /** Longitude. */
  longitude?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<GpsLocationFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A GPS location. */
export type GpsLocationSortInput = {
  /** Accuracy in meters. */
  accuracy?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Latitude. */
  latitude?: InputMaybe<SortEnumType>;
  /** Longitude. */
  longitude?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type GpsLocationsConnection = {
  __typename?: 'GpsLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GpsLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<GpsLocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GpsLocationsEdge = {
  __typename?: 'GpsLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GpsLocation;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

/** A connection to a list of items. */
export type InviteRequestsConnection = {
  __typename?: 'InviteRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InviteRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrganisationInviteRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InviteRequestsEdge = {
  __typename?: 'InviteRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganisationInviteRequest;
};

export type InviteUserToOrganisationInput = {
  email: Scalars['String']['input'];
  organisationId: Scalars['UUID']['input'];
};

/** A connection to a list of items. */
export type ItemsConnection = {
  __typename?: 'ItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ItemsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ExampleItem>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ItemsEdge = {
  __typename?: 'ItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ExampleItem;
};

/** A lab indicator definition. */
export type LabIndicatorDefinition = {
  __typename?: 'LabIndicatorDefinition';
  /** Whether to always show this indicator. */
  alwaysShow: Scalars['Boolean']['output'];
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Indicator description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Number of decimal places to display. */
  displayDecimalPlaces: Scalars['Int']['output'];
  /** Optional display name override. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** Unit label. */
  unit: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Value type. */
  valueType: LabIndicatorValueType;
};

/** A lab indicator definition. */
export type LabIndicatorDefinitionFilterInput = {
  /** Whether to always show this indicator. */
  alwaysShow?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<LabIndicatorDefinitionFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Indicator description. */
  description?: InputMaybe<StringOperationFilterInput>;
  /** Number of decimal places to display. */
  displayDecimalPlaces?: InputMaybe<IntOperationFilterInput>;
  /** Optional display name override. */
  displayName?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LabIndicatorDefinitionFilterInput>>;
  /** Unit label. */
  unit?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Value type. */
  valueType?: InputMaybe<LabIndicatorValueTypeOperationFilterInput>;
};

/** A lab indicator definition. */
export type LabIndicatorDefinitionSortInput = {
  /** Whether to always show this indicator. */
  alwaysShow?: InputMaybe<SortEnumType>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Indicator description. */
  description?: InputMaybe<SortEnumType>;
  /** Number of decimal places to display. */
  displayDecimalPlaces?: InputMaybe<SortEnumType>;
  /** Optional display name override. */
  displayName?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Unit label. */
  unit?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Value type. */
  valueType?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LabIndicatorDefinitionsConnection = {
  __typename?: 'LabIndicatorDefinitionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LabIndicatorDefinitionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LabIndicatorDefinition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LabIndicatorDefinitionsEdge = {
  __typename?: 'LabIndicatorDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LabIndicatorDefinition;
};

export enum LabIndicatorValueType {
  Categorical = 'CATEGORICAL',
  Continuous = 'CONTINUOUS'
}

export type LabIndicatorValueTypeOperationFilterInput = {
  eq?: InputMaybe<LabIndicatorValueType>;
  in?: InputMaybe<Array<LabIndicatorValueType>>;
  neq?: InputMaybe<LabIndicatorValueType>;
  nin?: InputMaybe<Array<LabIndicatorValueType>>;
};

/** A laboratory result for a soil sample. */
export type LabResult = {
  __typename?: 'LabResult';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  indicator?: Maybe<LabIndicatorDefinition>;
  laboratory?: Maybe<Laboratory>;
  /** Indicator display name. */
  name: Scalars['String']['output'];
  /** Parsed numeric value when possible. */
  numericValue?: Maybe<Scalars['Float']['output']>;
  soilSample?: Maybe<SoilSample>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Lab result value. */
  value: Scalars['String']['output'];
};

/** A laboratory result for a soil sample. */
export type LabResultFilterInput = {
  and?: InputMaybe<Array<LabResultFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Indicator display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  /** Parsed numeric value when possible. */
  numericValue?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<LabResultFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Lab result value. */
  value?: InputMaybe<StringOperationFilterInput>;
};

/** A laboratory result for a soil sample. */
export type LabResultSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Indicator display name. */
  name?: InputMaybe<SortEnumType>;
  /** Parsed numeric value when possible. */
  numericValue?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Lab result value. */
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LabResultsConnection = {
  __typename?: 'LabResultsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LabResultsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LabResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LabResultsEdge = {
  __typename?: 'LabResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LabResult;
};

/** A connection to a list of items. */
export type LaboratoriesConnection = {
  __typename?: 'LaboratoriesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LaboratoriesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Laboratory>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LaboratoriesEdge = {
  __typename?: 'LaboratoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Laboratory;
};

/** A laboratory (unique by normalized name). */
export type Laboratory = {
  __typename?: 'Laboratory';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A laboratory (unique by normalized name). */
export type LaboratoryFilterInput = {
  and?: InputMaybe<Array<LaboratoryFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LaboratoryFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A laboratory (unique by normalized name). */
export type LaboratorySortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  neq?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['LocalDate']['input']>>>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

/** Admin overview of configured localisation files. */
export type LocalisationAdminOverview = {
  __typename?: 'LocalisationAdminOverview';
  enabledLocaleSummaries: Array<LocalisationEnabledLocaleSummary>;
  enabledLocales: Array<Scalars['String']['output']>;
  files: Array<LocalisationFileSummary>;
};

/** One editable localisation row for a selected file and locale. */
export type LocalisationEditorRow = {
  __typename?: 'LocalisationEditorRow';
  baseValue: Scalars['String']['output'];
  effectiveValue: Scalars['String']['output'];
  isApproved: Scalars['Boolean']['output'];
  isFallback: Scalars['Boolean']['output'];
  isTranslating: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  targetValue?: Maybe<Scalars['String']['output']>;
};

/** Editor data for a selected localisation file and locale. */
export type LocalisationEditorView = {
  __typename?: 'LocalisationEditorView';
  fileName: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  rows: Array<LocalisationEditorRow>;
};

/** Summary information about one enabled target locale. */
export type LocalisationEnabledLocaleSummary = {
  __typename?: 'LocalisationEnabledLocaleSummary';
  locale: Scalars['String']['output'];
  setupFailureMessage?: Maybe<Scalars['String']['output']>;
  setupStatus?: Maybe<Scalars['String']['output']>;
  setupUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Summary information about a localisation file. */
export type LocalisationFileSummary = {
  __typename?: 'LocalisationFileSummary';
  baseEntryCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  setupFailureMessage?: Maybe<Scalars['String']['output']>;
  setupStatus?: Maybe<Scalars['String']['output']>;
  setupUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  targetLocaleCount: Scalars['Int']['output'];
  targetLocales: Array<Scalars['String']['output']>;
  translationContext?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LoginWithPasswordInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

/** A machine learning model (unique by normalized name). */
export type MlModel = {
  __typename?: 'MLModel';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  trainedIndicators?: Maybe<TrainedIndicatorsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A machine learning model (unique by normalized name). */
export type MlModelTrainedIndicatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TrainedIndicatorSortInput>>;
  where?: InputMaybe<TrainedIndicatorFilterInput>;
};

/** A machine learning model (unique by normalized name). */
export type MlModelFilterInput = {
  and?: InputMaybe<Array<MlModelFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MlModelFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A machine learning model (unique by normalized name). */
export type MlModelSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type MapPoint = {
  __typename?: 'MapPoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  organisationName?: Maybe<Scalars['String']['output']>;
  testId: Scalars['UUID']['output'];
  testName?: Maybe<Scalars['String']['output']>;
  what3Words?: Maybe<Scalars['String']['output']>;
};

export type MarkTestFailedInput = {
  /** Failure reasons. An empty array clears the failure status. */
  failureReasons: Array<Scalars['String']['input']>;
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

/** A connection to a list of items. */
export type MembersConnection = {
  __typename?: 'MembersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MembersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembersEdge = {
  __typename?: 'MembersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** A connection to a list of items. */
export type MlModelsConnection = {
  __typename?: 'MlModelsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MlModelsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MlModel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MlModelsEdge = {
  __typename?: 'MlModelsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MlModel;
};

export enum MoistureLevel {
  Dry = 'DRY',
  Moist = 'MOIST',
  Wet = 'WET'
}

export type MoistureLevelOperationFilterInput = {
  eq?: InputMaybe<MoistureLevel>;
  in?: InputMaybe<Array<MoistureLevel>>;
  neq?: InputMaybe<MoistureLevel>;
  nin?: InputMaybe<Array<MoistureLevel>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOrganisationAccessRequest?: Maybe<OrganisationInviteRequest>;
  acceptOrganisationInviteRequest?: Maybe<OrganisationInviteRequest>;
  addCassetteEntitlementAdjustment: CassetteEntitlementAdjustment;
  addLocalisationTargetLocale: LocalisationFileSummary;
  adminSetUserPassword: Scalars['Boolean']['output'];
  changeOwnPassword: Scalars['Boolean']['output'];
  copyTrainedIndicator?: Maybe<TrainedIndicator>;
  createAccountWithPassword?: Maybe<Scalars['String']['output']>;
  createBatch: Batch;
  createCassette: Cassette;
  createCassetteOverflowRequest: CassetteOverflowRequest;
  createCoverCrop: CoverCrop;
  createCrop: Crop;
  createCropType: CropType;
  createCultivation: Cultivation;
  createCustomer: Customer;
  createERU: Eru;
  createExample: Example;
  createFarm: Farm;
  createField: Field;
  createFirmwareInstallLog: CreateFirmwareInstallLogPayload;
  createGPSLocation: GpsLocation;
  createLabIndicatorDefinition: LabIndicatorDefinition;
  createLabResult: LabResult;
  createLaboratory: Laboratory;
  createLocalisationFile: LocalisationFileSummary;
  createMLModel: MlModel;
  createOrganisation: Organisation;
  createPESTest: PesTest;
  createProductType: ProductType;
  createReport: Report;
  createResult: Result;
  createSerialNumber: SerialNumber;
  createSerialRange: SerialRange;
  createSoilSample: SoilSample;
  createSoilType: SoilType;
  createTROFromUnknown: Tro;
  createTrainedIndicator: TrainedIndicator;
  createUploadChunk: UploadChunk;
  createUploadRequest: UploadRequest;
  createWhat3WordsLocation: What3WordsLocation;
  dedupeLabResults: Scalars['Int']['output'];
  deleteBatch: Scalars['Boolean']['output'];
  deleteCassette: Scalars['Boolean']['output'];
  deleteCoverCrop: Scalars['Boolean']['output'];
  deleteCrop: Scalars['Boolean']['output'];
  deleteCropType: Scalars['Boolean']['output'];
  deleteCultivation: Scalars['Boolean']['output'];
  deleteCustomer: Scalars['Boolean']['output'];
  deleteERU: Scalars['Boolean']['output'];
  deleteExample: Scalars['Boolean']['output'];
  deleteFarm: Scalars['Boolean']['output'];
  deleteField: Scalars['Boolean']['output'];
  deleteGPSLocation: Scalars['Boolean']['output'];
  deleteLabIndicatorDefinition: Scalars['Boolean']['output'];
  deleteLabResult: Scalars['Boolean']['output'];
  deleteLaboratory: Scalars['Boolean']['output'];
  deleteMLModel: Scalars['Boolean']['output'];
  deleteOrganisation: Scalars['Boolean']['output'];
  deleteOwnAccount?: Maybe<DeleteOwnAccountPayload>;
  deletePESTest: Scalars['Boolean']['output'];
  deleteProductType: Scalars['Boolean']['output'];
  deleteResult: Scalars['Boolean']['output'];
  deleteSerialNumber: Scalars['Boolean']['output'];
  deleteSerialRange: Scalars['Boolean']['output'];
  deleteSoilSample: Scalars['Boolean']['output'];
  deleteSoilType: Scalars['Boolean']['output'];
  deleteTrainedIndicator: Scalars['Boolean']['output'];
  deleteWhat3WordsLocation: Scalars['Boolean']['output'];
  denyOrganisationAccessRequest?: Maybe<OrganisationInviteRequest>;
  denyOrganisationInviteRequest?: Maybe<OrganisationInviteRequest>;
  featureExtractionExportDownloadUrl?: Maybe<FeatureExtractionExportDownload>;
  fulfilCassetteOverflowRequest: CassetteOverflowRequest;
  inviteUserToOrganisation: OrganisationInviteRequest;
  loginWithPassword?: Maybe<Scalars['String']['output']>;
  markTestFailed?: Maybe<PesTest>;
  purgePesTestFeatureCache: PesTestFeatureCachePurgeResult;
  purgePesTestFeatureCaches: PesTestFeatureCachePurgeResult;
  queueBackgroundJobDelayTest: Scalars['String']['output'];
  queueBackgroundJobPredictionDelayTest: Scalars['String']['output'];
  queueLocalisationTranslation: Scalars['String']['output'];
  queuePesTestPrediction?: Maybe<PesTest>;
  queuePesTestTargetPredictions: Array<PesTest>;
  queueSemanticKernelDemo: Scalars['String']['output'];
  recordPesTestFeatureCache?: Maybe<PesTestFeatureCache>;
  recoverPesTestFeatureCache?: Maybe<PesTestFeatureCache>;
  redeemMagicLink?: Maybe<Scalars['String']['output']>;
  removeOrganisationMember: Scalars['Boolean']['output'];
  renamePesTest?: Maybe<PesTest>;
  requestMagicLink: Scalars['Boolean']['output'];
  requestOrganisationAccess: OrganisationInviteRequest;
  requestPasswordReset: Scalars['Boolean']['output'];
  resetPasswordWithCode?: Maybe<Scalars['String']['output']>;
  resolveLegacyCachedRunId: Scalars['UUID']['output'];
  sendReport: Scalars['Boolean']['output'];
  setActiveFirmwareVersion?: Maybe<FirmwareVersion>;
  setLocalisationLocaleEnabled: SetLocalisationLocaleEnabledResult;
  setOwnPassword: Scalars['Boolean']['output'];
  setUserRole?: Maybe<User>;
  startFeatureExtractionExport: FeatureExtractionExportRun;
  transferPesTest: PesTest;
  updateBatch?: Maybe<Batch>;
  updateCassette?: Maybe<Cassette>;
  updateCoverCrop?: Maybe<CoverCrop>;
  updateCrop?: Maybe<Crop>;
  updateCropType?: Maybe<CropType>;
  updateCultivation?: Maybe<Cultivation>;
  updateCustomer?: Maybe<Customer>;
  updateERU?: Maybe<Eru>;
  updateExample?: Maybe<Example>;
  updateExcludeFromMl?: Maybe<PesTest>;
  updateFarm?: Maybe<Farm>;
  updateField?: Maybe<Field>;
  updateFirmwareInstallLog: FirmwareInstallLog;
  updateLabIndicatorDefinition?: Maybe<LabIndicatorDefinition>;
  updateLabResult?: Maybe<LabResult>;
  updateLaboratory?: Maybe<Laboratory>;
  updateLocalisationFile: LocalisationFileSummary;
  updateLocalisationTranslation: Scalars['Boolean']['output'];
  updateMLModel?: Maybe<MlModel>;
  updateOrganisation?: Maybe<Organisation>;
  updateOrganisationLogo: Organisation;
  updatePESTest?: Maybe<PesTest>;
  updatePesTestCharacteristics?: Maybe<PesTest>;
  updatePesTestLocation?: Maybe<PesTest>;
  updateProductType?: Maybe<ProductType>;
  updateResult?: Maybe<Result>;
  updateSerialNumber?: Maybe<SerialNumber>;
  updateSerialRange?: Maybe<SerialRange>;
  updateSoilSample?: Maybe<SoilSample>;
  updateSoilType?: Maybe<SoilType>;
  updateTRO?: Maybe<Tro>;
  updateTrainedIndicator?: Maybe<TrainedIndicator>;
  updateUserName: User;
  updateUserProfilePicture: User;
  updateWhat3WordsLocation?: Maybe<What3WordsLocation>;
  uploadFirmware: FirmwareVersion;
};


export type MutationAcceptOrganisationAccessRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationAcceptOrganisationInviteRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationAddCassetteEntitlementAdjustmentArgs = {
  input: AddCassetteEntitlementAdjustmentInput;
};


export type MutationAddLocalisationTargetLocaleArgs = {
  input: AddLocalisationTargetLocaleInput;
};


export type MutationAdminSetUserPasswordArgs = {
  input: AdminSetUserPasswordInput;
};


export type MutationChangeOwnPasswordArgs = {
  input: ChangeOwnPasswordInput;
};


export type MutationCopyTrainedIndicatorArgs = {
  input: CopyTrainedIndicatorInput;
};


export type MutationCreateAccountWithPasswordArgs = {
  input: CreateAccountWithPasswordInput;
};


export type MutationCreateBatchArgs = {
  input: CreateBatchInput;
};


export type MutationCreateCassetteArgs = {
  input: CreateCassetteInput;
};


export type MutationCreateCassetteOverflowRequestArgs = {
  input: CreateCassetteOverflowRequestInput;
};


export type MutationCreateCoverCropArgs = {
  input: CreateCoverCropInput;
};


export type MutationCreateCropArgs = {
  input: CreateCropInput;
};


export type MutationCreateCropTypeArgs = {
  input: CreateCropTypeInput;
};


export type MutationCreateCultivationArgs = {
  input: CreateCultivationInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateEruArgs = {
  input: CreateEruInput;
};


export type MutationCreateExampleArgs = {
  input: CreateExampleInput;
};


export type MutationCreateFarmArgs = {
  input: CreateFarmInput;
};


export type MutationCreateFieldArgs = {
  input: CreateFieldInput;
};


export type MutationCreateFirmwareInstallLogArgs = {
  input: CreateFirmwareInstallLogInput;
};


export type MutationCreateGpsLocationArgs = {
  input: CreateGpsLocationInput;
};


export type MutationCreateLabIndicatorDefinitionArgs = {
  input: CreateLabIndicatorDefinitionInput;
};


export type MutationCreateLabResultArgs = {
  input: CreateLabResultInput;
};


export type MutationCreateLaboratoryArgs = {
  input: CreateLaboratoryInput;
};


export type MutationCreateLocalisationFileArgs = {
  input: CreateLocalisationFileInput;
};


export type MutationCreateMlModelArgs = {
  input: CreateMlModelInput;
};


export type MutationCreateOrganisationArgs = {
  input: CreateOrganisationInput;
};


export type MutationCreatePesTestArgs = {
  input: CreatePesTestInput;
};


export type MutationCreateProductTypeArgs = {
  input: CreateProductTypeInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateResultArgs = {
  input: CreateResultInput;
};


export type MutationCreateSerialNumberArgs = {
  input: CreateSerialNumberInput;
};


export type MutationCreateSerialRangeArgs = {
  input: CreateSerialRangeInput;
};


export type MutationCreateSoilSampleArgs = {
  input: CreateSoilSampleInput;
};


export type MutationCreateSoilTypeArgs = {
  input: CreateSoilTypeInput;
};


export type MutationCreateTroFromUnknownArgs = {
  input: CreateTroFromUnknownInput;
};


export type MutationCreateTrainedIndicatorArgs = {
  input: CreateTrainedIndicatorInput;
};


export type MutationCreateUploadChunkArgs = {
  input: CreateUploadChunkInput;
};


export type MutationCreateUploadRequestArgs = {
  input: CreateUploadRequestInput;
};


export type MutationCreateWhat3WordsLocationArgs = {
  input: CreateWhat3WordsLocationInput;
};


export type MutationDeleteBatchArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCassetteArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCoverCropArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCropArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCropTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCultivationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteEruArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteExampleArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFarmArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFieldArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteGpsLocationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteLabIndicatorDefinitionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteLabResultArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteLaboratoryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteMlModelArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOrganisationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOwnAccountArgs = {
  input: DeleteOwnAccountInput;
};


export type MutationDeletePesTestArgs = {
  input: DeletePesTestInput;
};


export type MutationDeleteProductTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteResultArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSerialNumberArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSerialRangeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSoilSampleArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSoilTypeArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteTrainedIndicatorArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteWhat3WordsLocationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDenyOrganisationAccessRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationDenyOrganisationInviteRequestArgs = {
  input: RespondToOrganisationInviteRequestInput;
};


export type MutationFeatureExtractionExportDownloadUrlArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationFulfilCassetteOverflowRequestArgs = {
  input: FulfilCassetteOverflowRequestInput;
};


export type MutationInviteUserToOrganisationArgs = {
  input: InviteUserToOrganisationInput;
};


export type MutationLoginWithPasswordArgs = {
  input: LoginWithPasswordInput;
};


export type MutationMarkTestFailedArgs = {
  input: MarkTestFailedInput;
};


export type MutationPurgePesTestFeatureCacheArgs = {
  input: PurgePesTestFeatureCacheInput;
};


export type MutationPurgePesTestFeatureCachesArgs = {
  input: PurgePesTestFeatureCachesInput;
};


export type MutationQueueLocalisationTranslationArgs = {
  input: QueueLocalisationTranslationInput;
};


export type MutationQueuePesTestPredictionArgs = {
  input: QueuePesTestPredictionInput;
};


export type MutationQueuePesTestTargetPredictionsArgs = {
  input: QueuePesTestTargetPredictionsInput;
};


export type MutationRecordPesTestFeatureCacheArgs = {
  input: RecordPesTestFeatureCacheInput;
};


export type MutationRecoverPesTestFeatureCacheArgs = {
  testId: Scalars['UUID']['input'];
};


export type MutationRedeemMagicLinkArgs = {
  input: RedeemMagicLinkInput;
};


export type MutationRemoveOrganisationMemberArgs = {
  input: RemoveOrganisationMemberInput;
};


export type MutationRenamePesTestArgs = {
  input: UpdatePesTestNameInput;
};


export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationRequestOrganisationAccessArgs = {
  input: RequestOrganisationAccessInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationResetPasswordWithCodeArgs = {
  input: ResetPasswordWithCodeInput;
};


export type MutationResolveLegacyCachedRunIdArgs = {
  input: ResolveLegacyCachedRunIdInput;
};


export type MutationSendReportArgs = {
  input: SendReportInput;
};


export type MutationSetActiveFirmwareVersionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationSetLocalisationLocaleEnabledArgs = {
  input: SetLocalisationLocaleEnabledInput;
};


export type MutationSetOwnPasswordArgs = {
  input: SetOwnPasswordInput;
};


export type MutationSetUserRoleArgs = {
  input: SetUserRoleInput;
};


export type MutationStartFeatureExtractionExportArgs = {
  input: StartFeatureExtractionExportInput;
};


export type MutationTransferPesTestArgs = {
  input: TransferPesTestInput;
};


export type MutationUpdateBatchArgs = {
  input: UpdateBatchInput;
};


export type MutationUpdateCassetteArgs = {
  input: UpdateCassetteInput;
};


export type MutationUpdateCoverCropArgs = {
  input: UpdateCoverCropInput;
};


export type MutationUpdateCropArgs = {
  input: UpdateCropInput;
};


export type MutationUpdateCropTypeArgs = {
  input: UpdateCropTypeInput;
};


export type MutationUpdateCultivationArgs = {
  input: UpdateCultivationInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateEruArgs = {
  input: UpdateEruInput;
};


export type MutationUpdateExampleArgs = {
  input: UpdateExampleInput;
};


export type MutationUpdateExcludeFromMlArgs = {
  exclude: Scalars['Boolean']['input'];
  testId: Scalars['UUID']['input'];
};


export type MutationUpdateFarmArgs = {
  input: UpdateFarmInput;
};


export type MutationUpdateFieldArgs = {
  input: UpdateFieldInput;
};


export type MutationUpdateFirmwareInstallLogArgs = {
  input: UpdateFirmwareInstallLogInput;
};


export type MutationUpdateLabIndicatorDefinitionArgs = {
  input: UpdateLabIndicatorDefinitionInput;
};


export type MutationUpdateLabResultArgs = {
  input: UpdateLabResultInput;
};


export type MutationUpdateLaboratoryArgs = {
  input: UpdateLaboratoryInput;
};


export type MutationUpdateLocalisationFileArgs = {
  input: UpdateLocalisationFileInput;
};


export type MutationUpdateLocalisationTranslationArgs = {
  input: UpdateLocalisationTranslationInput;
};


export type MutationUpdateMlModelArgs = {
  input: UpdateMlModelInput;
};


export type MutationUpdateOrganisationArgs = {
  input: UpdateOrganisationInput;
};


export type MutationUpdateOrganisationLogoArgs = {
  dataUrl: Scalars['String']['input'];
  organisationId: Scalars['UUID']['input'];
};


export type MutationUpdatePesTestArgs = {
  input: UpdatePesTestInput;
};


export type MutationUpdatePesTestCharacteristicsArgs = {
  input: UpdatePesTestCharacteristicsInput;
};


export type MutationUpdatePesTestLocationArgs = {
  input: UpdatePesTestLocationInput;
};


export type MutationUpdateProductTypeArgs = {
  input: UpdateProductTypeInput;
};


export type MutationUpdateResultArgs = {
  input: UpdateResultInput;
};


export type MutationUpdateSerialNumberArgs = {
  input: UpdateSerialNumberInput;
};


export type MutationUpdateSerialRangeArgs = {
  input: UpdateSerialRangeInput;
};


export type MutationUpdateSoilSampleArgs = {
  input: UpdateSoilSampleInput;
};


export type MutationUpdateSoilTypeArgs = {
  input: UpdateSoilTypeInput;
};


export type MutationUpdateTroArgs = {
  input: UpdateTroInput;
};


export type MutationUpdateTrainedIndicatorArgs = {
  input: UpdateTrainedIndicatorInput;
};


export type MutationUpdateUserNameArgs = {
  name: Scalars['String']['input'];
};


export type MutationUpdateUserProfilePictureArgs = {
  dataUrl: Scalars['String']['input'];
};


export type MutationUpdateWhat3WordsLocationArgs = {
  input: UpdateWhat3WordsLocationInput;
};


export type MutationUploadFirmwareArgs = {
  input: UploadFirmwareInput;
};

export type NullableOfMoistureLevelOperationFilterInput = {
  eq?: InputMaybe<MoistureLevel>;
  in?: InputMaybe<Array<InputMaybe<MoistureLevel>>>;
  neq?: InputMaybe<MoistureLevel>;
  nin?: InputMaybe<Array<InputMaybe<MoistureLevel>>>;
};

export type NullableOfSeasonOperationFilterInput = {
  eq?: InputMaybe<Season>;
  in?: InputMaybe<Array<InputMaybe<Season>>>;
  neq?: InputMaybe<Season>;
  nin?: InputMaybe<Array<InputMaybe<Season>>>;
};

/** A connection to a list of items. */
export type OpenCassetteOverflowRequestsConnection = {
  __typename?: 'OpenCassetteOverflowRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OpenCassetteOverflowRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CassetteOverflowRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OpenCassetteOverflowRequestsEdge = {
  __typename?: 'OpenCassetteOverflowRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CassetteOverflowRequest;
};

/** An organisation. */
export type Organisation = {
  __typename?: 'Organisation';
  /** Name trimmed and lowercased; includes id suffix when autocreated. */
  cleanName: Scalars['String']['output'];
  /** Contact email address. */
  contactEmail: Scalars['String']['output'];
  /** Contact phone number. */
  contactNumber?: Maybe<Scalars['String']['output']>;
  /** Country. */
  country?: Maybe<Scalars['String']['output']>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  farms?: Maybe<FarmsConnection>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  inviteRequests?: Maybe<InviteRequestsConnection>;
  /** Whether the organisation was automatically created by the system. */
  isAutocreated: Scalars['Boolean']['output'];
  /** Logo URL. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  members?: Maybe<MembersConnection>;
  /** Display name. */
  name: Scalars['String']['output'];
  /** Owner user id. */
  ownerId: Scalars['UUID']['output'];
  /** Whether the organisation is publicly visible. */
  public: Scalars['Boolean']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** An organisation. */
export type OrganisationFarmsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FarmSortInput>>;
  where?: InputMaybe<FarmFilterInput>;
};


/** An organisation. */
export type OrganisationInviteRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganisationInviteRequestSortInput>>;
  where?: InputMaybe<OrganisationInviteRequestFilterInput>;
};


/** An organisation. */
export type OrganisationMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  where?: InputMaybe<UserFilterInput>;
};

/** An organisation. */
export type OrganisationFilterInput = {
  and?: InputMaybe<Array<OrganisationFilterInput>>;
  /** Name trimmed and lowercased; includes id suffix when autocreated. */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** Contact email address. */
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  /** Contact phone number. */
  contactNumber?: InputMaybe<StringOperationFilterInput>;
  /** Country. */
  country?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether the organisation was automatically created by the system. */
  isAutocreated?: InputMaybe<BooleanOperationFilterInput>;
  /** Logo URL. */
  logoUrl?: InputMaybe<StringOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrganisationFilterInput>>;
  /** Owner user id. */
  ownerId?: InputMaybe<UuidOperationFilterInput>;
  /** Whether the organisation is publicly visible. */
  public?: InputMaybe<BooleanOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A request to join an organisation or an invitation to join an organisation. */
export type OrganisationInviteRequest = {
  __typename?: 'OrganisationInviteRequest';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  initiatingUser?: Maybe<User>;
  /** The user who created this request/invitation. */
  initiatingUserId: Scalars['UUID']['output'];
  /** Whether this record is an access request or an invitation. */
  kind: OrganisationInviteRequestKind;
  organisation?: Maybe<Organisation>;
  /** Organisation id. */
  organisationId: Scalars['UUID']['output'];
  /** When the invitation was responded to (accept/deny). */
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of the request/invitation. */
  status: OrganisationInviteRequestStatus;
  /** The email address this request targets (normalized to lowercase). */
  targetEmail: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A request to join an organisation or an invitation to join an organisation. */
export type OrganisationInviteRequestFilterInput = {
  and?: InputMaybe<Array<OrganisationInviteRequestFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** The user who created this request/invitation. */
  initiatingUserId?: InputMaybe<UuidOperationFilterInput>;
  /** Whether this record is an access request or an invitation. */
  kind?: InputMaybe<OrganisationInviteRequestKindOperationFilterInput>;
  or?: InputMaybe<Array<OrganisationInviteRequestFilterInput>>;
  /** Organisation id. */
  organisationId?: InputMaybe<UuidOperationFilterInput>;
  /** When the invitation was responded to (accept/deny). */
  respondedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Current status of the request/invitation. */
  status?: InputMaybe<OrganisationInviteRequestStatusOperationFilterInput>;
  /** The email address this request targets (normalized to lowercase). */
  targetEmail?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

export enum OrganisationInviteRequestKind {
  AccessRequest = 'ACCESS_REQUEST',
  Invite = 'INVITE'
}

export type OrganisationInviteRequestKindOperationFilterInput = {
  eq?: InputMaybe<OrganisationInviteRequestKind>;
  in?: InputMaybe<Array<OrganisationInviteRequestKind>>;
  neq?: InputMaybe<OrganisationInviteRequestKind>;
  nin?: InputMaybe<Array<OrganisationInviteRequestKind>>;
};

/** A request to join an organisation or an invitation to join an organisation. */
export type OrganisationInviteRequestSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** The user who created this request/invitation. */
  initiatingUserId?: InputMaybe<SortEnumType>;
  /** Whether this record is an access request or an invitation. */
  kind?: InputMaybe<SortEnumType>;
  /** Organisation id. */
  organisationId?: InputMaybe<SortEnumType>;
  /** When the invitation was responded to (accept/deny). */
  respondedAt?: InputMaybe<SortEnumType>;
  /** Current status of the request/invitation. */
  status?: InputMaybe<SortEnumType>;
  /** The email address this request targets (normalized to lowercase). */
  targetEmail?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export enum OrganisationInviteRequestStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type OrganisationInviteRequestStatusOperationFilterInput = {
  eq?: InputMaybe<OrganisationInviteRequestStatus>;
  in?: InputMaybe<Array<OrganisationInviteRequestStatus>>;
  neq?: InputMaybe<OrganisationInviteRequestStatus>;
  nin?: InputMaybe<Array<OrganisationInviteRequestStatus>>;
};

/** A connection to a list of items. */
export type OrganisationInviteRequestsConnection = {
  __typename?: 'OrganisationInviteRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrganisationInviteRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<OrganisationInviteRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganisationInviteRequestsEdge = {
  __typename?: 'OrganisationInviteRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OrganisationInviteRequest;
};

export enum OrganisationOwnerDepartureOutcome {
  Deleted = 'DELETED',
  Orphaned = 'ORPHANED',
  OwnershipTransferred = 'OWNERSHIP_TRANSFERRED'
}

/** An organisation. */
export type OrganisationSortInput = {
  /** Name trimmed and lowercased; includes id suffix when autocreated. */
  cleanName?: InputMaybe<SortEnumType>;
  /** Contact email address. */
  contactEmail?: InputMaybe<SortEnumType>;
  /** Contact phone number. */
  contactNumber?: InputMaybe<SortEnumType>;
  /** Country. */
  country?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether the organisation was automatically created by the system. */
  isAutocreated?: InputMaybe<SortEnumType>;
  /** Logo URL. */
  logoUrl?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Owner user id. */
  ownerId?: InputMaybe<SortEnumType>;
  /** Whether the organisation is publicly visible. */
  public?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type OrganisationTestStats = {
  __typename?: 'OrganisationTestStats';
  failedSensorChecks: Scalars['Int']['output'];
  organisationId: Scalars['UUID']['output'];
  organisationName: Scalars['String']['output'];
  soilTests: Scalars['Int']['output'];
  successfulSensorChecks: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type OrganisationsConnection = {
  __typename?: 'OrganisationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OrganisationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Organisation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganisationsEdge = {
  __typename?: 'OrganisationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Organisation;
};

/** A connection to a list of items. */
export type OverflowRequestsConnection = {
  __typename?: 'OverflowRequestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OverflowRequestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CassetteOverflowRequest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OverflowRequestsEdge = {
  __typename?: 'OverflowRequestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CassetteOverflowRequest;
};

/** A PES test. */
export type PesTest = {
  __typename?: 'PESTest';
  /** Indicator definitions that non-staff users may see for this test, derived from the customer(s) owning its ERU, cassette or organisation. Null when no customer limit applies. */
  allowedIndicatorDefinitions?: Maybe<Array<LabIndicatorDefinition>>;
  cassette?: Maybe<Cassette>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  cropType?: Maybe<CropType>;
  displayCropTypeName?: Maybe<Scalars['String']['output']>;
  eru?: Maybe<Eru>;
  /** Whether to exclude this test from ML. */
  excludeFromMl: Scalars['Boolean']['output'];
  /** Extra JSON metadata. */
  extraMetadata: Scalars['String']['output'];
  /** Failure reasons. */
  failureReasons: Array<Scalars['String']['output']>;
  farm?: Maybe<Farm>;
  featureCaches: Array<PesTestFeatureCache>;
  field?: Maybe<Field>;
  /** Firmware version. */
  firmwareVersion: Scalars['String']['output'];
  /** Whether any results exist for this test, regardless of the viewer's customer indicator limit. Use this (not an empty `results` connection) to decide whether a test is still being processed. */
  hasResults: Scalars['Boolean']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Whether this test was run in debug mode. */
  isDebug: Scalars['Boolean']['output'];
  /** Whether this test failed. */
  isFailure: Scalars['Boolean']['output'];
  /** Whether this test is from a reference zone. */
  isReferenceZone: Scalars['Boolean']['output'];
  location?: Maybe<GpsLocation>;
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Display name. */
  name: Scalars['String']['output'];
  organisation?: Maybe<Organisation>;
  /** Original model name. */
  originalModelName: Scalars['String']['output'];
  results?: Maybe<ResultsConnection>;
  /** Logical run UUID. */
  runId?: Maybe<Scalars['UUID']['output']>;
  /** Optional URL to the sample file. */
  sampleFileUrl?: Maybe<Scalars['String']['output']>;
  /** Season. */
  season: Season;
  soilSample?: Maybe<SoilSample>;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** SRF UUID. */
  srfUuid: Scalars['UUID']['output'];
  /** Test type. */
  testType: PesTestType;
  tro?: Maybe<Tro>;
  /** TRO UUID. */
  troUuid: Scalars['UUID']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** When this test's uploaded sample data was first successfully processed. */
  uploadProcessedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadRequest?: Maybe<UploadRequest>;
  /** UTC test time. */
  utcTestTime: Scalars['DateTime']['output'];
};


/** A PES test. */
export type PesTestResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ResultSortInput>>;
  where?: InputMaybe<ResultFilterInput>;
};

/** A cassette. */
export type PesTestCassetteRefFilterInput = {
  and?: InputMaybe<Array<PesTestCassetteRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestCassetteRefFilterInput>>;
};

/** An ERU device. */
export type PesTestEruRefFilterInput = {
  and?: InputMaybe<Array<PesTestEruRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestEruRefFilterInput>>;
};

/** A farm. */
export type PesTestFarmRefFilterInput = {
  and?: InputMaybe<Array<PesTestFarmRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestFarmRefFilterInput>>;
};

/** A farm. */
export type PesTestFarmSortInput = {
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
};

/** A cached extracted feature payload for a PES test. */
export type PesTestFeatureCache = {
  __typename?: 'PESTestFeatureCache';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** When the feature payload was extracted. */
  extractedAt: Scalars['DateTime']['output'];
  /** Number of extracted features in the payload. */
  featureCount: Scalars['Int']['output'];
  featureMatches: Array<PesTestFeatureCacheFeature>;
  /** Feature-set version or cache namespace. */
  featureSetVersion: Scalars['String']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Extra JSON metadata for the cached payload. */
  metadataJson: Scalars['String']['output'];
  /** Optional SHA-256 digest for the cached payload. */
  payloadSha256?: Maybe<Scalars['String']['output']>;
  /** Optional reason recorded when the cache was purged. */
  purgeReason?: Maybe<Scalars['String']['output']>;
  /** When this cache record was purged, if no longer active. */
  purgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Stable sample identifier used by the extractor. */
  sampleId: Scalars['String']['output'];
  /** Storage URI for the cached feature payload. */
  sourceUri: Scalars['String']['output'];
  /** Google Cloud Storage bucket parsed from SourceUri, when applicable. */
  storageBucket?: Maybe<Scalars['String']['output']>;
  /** Google Cloud Storage object name parsed from SourceUri, when applicable. */
  storageObjectName?: Maybe<Scalars['String']['output']>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  warningSummary: PesTestFeatureCacheWarningSummary;
};


/** A cached extracted feature payload for a PES test. */
export type PesTestFeatureCacheFeatureMatchesArgs = {
  limit: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PesTestFeatureCacheFeature = {
  __typename?: 'PESTestFeatureCacheFeature';
  displayValue: Scalars['String']['output'];
  hasValue: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type PesTestFeatureCacheOverview = {
  __typename?: 'PESTestFeatureCacheOverview';
  activeCacheCount: Scalars['Int']['output'];
  activeFeatureCount: Scalars['Long']['output'];
  activeTestCount: Scalars['Int']['output'];
  lastExtractedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PesTestFeatureCachePurgeResult = {
  __typename?: 'PESTestFeatureCachePurgeResult';
  purgedCount: Scalars['Int']['output'];
  sampleIds: Array<Scalars['String']['output']>;
  testIds: Array<Scalars['UUID']['output']>;
};

export type PesTestFeatureCacheWarningSummary = {
  __typename?: 'PESTestFeatureCacheWarningSummary';
  hasWarnings: Scalars['Boolean']['output'];
  messages: Array<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** A field. */
export type PesTestFieldRefFilterInput = {
  and?: InputMaybe<Array<PesTestFieldRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestFieldRefFilterInput>>;
};

/** A field. */
export type PesTestFieldSortInput = {
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
};

/** A PES test. */
export type PesTestFilterInput = {
  and?: InputMaybe<Array<PesTestFilterInput>>;
  cassette?: InputMaybe<PesTestCassetteRefFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  eru?: InputMaybe<PesTestEruRefFilterInput>;
  /** Whether to exclude this test from ML. */
  excludeFromMl?: InputMaybe<BooleanOperationFilterInput>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<StringOperationFilterInput>;
  /** Failure reasons. */
  failureReasons?: InputMaybe<ListStringOperationFilterInput>;
  farm?: InputMaybe<PesTestFarmRefFilterInput>;
  field?: InputMaybe<PesTestFieldRefFilterInput>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether this test was run in debug mode. */
  isDebug?: InputMaybe<BooleanOperationFilterInput>;
  /** Whether this test failed. */
  isFailure?: InputMaybe<BooleanOperationFilterInput>;
  /** Whether this test is from a reference zone. */
  isReferenceZone?: InputMaybe<BooleanOperationFilterInput>;
  /** Moisture level. */
  moisture?: InputMaybe<MoistureLevelOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PesTestFilterInput>>;
  organisation?: InputMaybe<PesTestOrganisationRefFilterInput>;
  /** Original model name. */
  originalModelName?: InputMaybe<StringOperationFilterInput>;
  /** Logical run UUID. */
  runId?: InputMaybe<UuidOperationFilterInput>;
  /** Optional URL to the sample file. */
  sampleFileUrl?: InputMaybe<StringOperationFilterInput>;
  /** Season. */
  season?: InputMaybe<SeasonOperationFilterInput>;
  /** Soil texture. */
  soilTexture?: InputMaybe<SimpleSoilTextureOperationFilterInput>;
  /** SRF UUID. */
  srfUuid?: InputMaybe<UuidOperationFilterInput>;
  /** Test type. */
  testType?: InputMaybe<PesTestTypeOperationFilterInput>;
  /** TRO UUID. */
  troUuid?: InputMaybe<UuidOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this test's uploaded sample data was first successfully processed. */
  uploadProcessedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** UTC test time. */
  utcTestTime?: InputMaybe<DateTimeOperationFilterInput>;
};

/** An organisation. */
export type PesTestOrganisationRefFilterInput = {
  and?: InputMaybe<Array<PesTestOrganisationRefFilterInput>>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<PesTestOrganisationRefFilterInput>>;
};

/** A PES test. */
export type PesTestSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Whether to exclude this test from ML. */
  excludeFromMl?: InputMaybe<SortEnumType>;
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<SortEnumType>;
  farm?: InputMaybe<PesTestFarmSortInput>;
  field?: InputMaybe<PesTestFieldSortInput>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether this test was run in debug mode. */
  isDebug?: InputMaybe<SortEnumType>;
  /** Whether this test failed. */
  isFailure?: InputMaybe<SortEnumType>;
  /** Whether this test is from a reference zone. */
  isReferenceZone?: InputMaybe<SortEnumType>;
  /** Moisture level. */
  moisture?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Original model name. */
  originalModelName?: InputMaybe<SortEnumType>;
  /** Logical run UUID. */
  runId?: InputMaybe<SortEnumType>;
  /** Optional URL to the sample file. */
  sampleFileUrl?: InputMaybe<SortEnumType>;
  /** Season. */
  season?: InputMaybe<SortEnumType>;
  /** Soil texture. */
  soilTexture?: InputMaybe<SortEnumType>;
  /** SRF UUID. */
  srfUuid?: InputMaybe<SortEnumType>;
  /** Test type. */
  testType?: InputMaybe<SortEnumType>;
  /** TRO UUID. */
  troUuid?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** When this test's uploaded sample data was first successfully processed. */
  uploadProcessedAt?: InputMaybe<SortEnumType>;
  /** UTC test time. */
  utcTestTime?: InputMaybe<SortEnumType>;
};

/** PESTest type. */
export enum PesTestType {
  SensorCheck = 'SENSOR_CHECK',
  SoilTest = 'SOIL_TEST'
}

export type PesTestTypeOperationFilterInput = {
  eq?: InputMaybe<PesTestType>;
  in?: InputMaybe<Array<PesTestType>>;
  neq?: InputMaybe<PesTestType>;
  nin?: InputMaybe<Array<PesTestType>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordAuthStatus = {
  __typename?: 'PasswordAuthStatus';
  hasPassword: Scalars['Boolean']['output'];
};

/** A connection to a list of items. */
export type PesTestsConnection = {
  __typename?: 'PesTestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PesTestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PesTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PesTestsEdge = {
  __typename?: 'PesTestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PesTest;
};

/** A connection to a list of items. */
export type PesTestsForMlConnection = {
  __typename?: 'PesTestsForMlConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PesTestsForMlEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PesTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PesTestsForMlEdge = {
  __typename?: 'PesTestsForMlEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PesTest;
};

export type PredictionBacklogStatus = {
  __typename?: 'PredictionBacklogStatus';
  averagePredictionDurationSeconds?: Maybe<Scalars['Float']['output']>;
  effectiveWorkerSlots: Scalars['Int']['output'];
  estimatedWaitSeconds?: Maybe<Scalars['Float']['output']>;
  queuedPredictionCount: Scalars['Int']['output'];
  runningPredictionCount: Scalars['Int']['output'];
};

/** Prediction pipeline to queue. */
export enum PredictionPipeline {
  Both = 'BOTH',
  New = 'NEW',
  Old = 'OLD'
}

export type ProcessingBackgroundJob = {
  __typename?: 'ProcessingBackgroundJob';
  averageDurationSeconds?: Maybe<Scalars['Float']['output']>;
  displayName: Scalars['String']['output'];
  elapsedSeconds: Scalars['Float']['output'];
  etaSeconds?: Maybe<Scalars['Float']['output']>;
  jobId: Scalars['String']['output'];
  methodType: Scalars['String']['output'];
  queue?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A product type (unique by product type code). */
export type ProductType = {
  __typename?: 'ProductType';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** Computed code (Location + Model + SubType). */
  code: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Location code (1 character). */
  location: Scalars['String']['output'];
  /** Model code (1 character). */
  model: Scalars['String']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** Sub-type code (1 character). */
  subType: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A product type (unique by product type code). */
export type ProductTypeFilterInput = {
  and?: InputMaybe<Array<ProductTypeFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** Computed code (Location + Model + SubType). */
  code?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Location code (1 character). */
  location?: InputMaybe<StringOperationFilterInput>;
  /** Model code (1 character). */
  model?: InputMaybe<StringOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductTypeFilterInput>>;
  /** Sub-type code (1 character). */
  subType?: InputMaybe<StringOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A product type (unique by product type code). */
export type ProductTypeSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** Computed code (Location + Model + SubType). */
  code?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Location code (1 character). */
  location?: InputMaybe<SortEnumType>;
  /** Model code (1 character). */
  model?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Sub-type code (1 character). */
  subType?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProductTypesConnection = {
  __typename?: 'ProductTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProductTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProductType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductTypesEdge = {
  __typename?: 'ProductTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProductType;
};

/** A connection to a list of items. */
export type PublicOrganisationsConnection = {
  __typename?: 'PublicOrganisationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PublicOrganisationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Organisation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PublicOrganisationsEdge = {
  __typename?: 'PublicOrganisationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Organisation;
};

export type PurgePesTestFeatureCacheInput = {
  /** Optional feature-set version to purge. Defaults to every active cache for the test. */
  featureSetVersion?: InputMaybe<Scalars['String']['input']>;
  /** Optional purge reason. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

export type PurgePesTestFeatureCachesInput = {
  /** Optional feature-set version to purge. */
  featureSetVersion?: InputMaybe<Scalars['String']['input']>;
  /** Whether to purge every active feature cache. */
  purgeAll?: Scalars['Boolean']['input'];
  /** Optional purge reason. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Sample IDs to purge. */
  sampleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** PESTest IDs to purge. */
  testIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type Query = {
  __typename?: 'Query';
  accountDeletionPreview: AccountDeletionPreview;
  activeFirmware?: Maybe<ActiveFirmware>;
  assignableRoles: Array<Scalars['String']['output']>;
  auditLogActionTypes: Array<Scalars['String']['output']>;
  auditLogs?: Maybe<AuditLogsConnection>;
  backgroundJobStatus: BackgroundJobStatus;
  batch?: Maybe<Batch>;
  batches?: Maybe<BatchesConnection>;
  cassette?: Maybe<Cassette>;
  cassetteListSummary: CassetteListSummary;
  cassettes?: Maybe<CassettesConnection>;
  countTestsPerDayForDateRange: Array<TestCountByDay>;
  coverCropById?: Maybe<CoverCrop>;
  coverCrops?: Maybe<CoverCropsConnection>;
  cropById?: Maybe<Crop>;
  cropTypeById?: Maybe<CropType>;
  cropTypes?: Maybe<CropTypesConnection>;
  crops?: Maybe<CropsConnection>;
  cultivationById?: Maybe<Cultivation>;
  cultivations?: Maybe<CultivationsConnection>;
  customer?: Maybe<Customer>;
  customers?: Maybe<CustomersConnection>;
  dashboardStats: DashboardStats;
  duplicatedLabResultsCount: Scalars['Int']['output'];
  eru?: Maybe<Eru>;
  eruByBleId?: Maybe<Eru>;
  erus?: Maybe<ErusConnection>;
  exampleById?: Maybe<Example>;
  examples?: Maybe<ExamplesConnection>;
  farm?: Maybe<Farm>;
  farms?: Maybe<FarmsConnection>;
  featureExtractionExportRun?: Maybe<FeatureExtractionExportRun>;
  featureExtractionExportRuns?: Maybe<FeatureExtractionExportRunsConnection>;
  field?: Maybe<Field>;
  fields?: Maybe<FieldsConnection>;
  firmwareInstallLogs?: Maybe<FirmwareInstallLogsConnection>;
  firmwareVersions?: Maybe<FirmwareVersionsConnection>;
  gpsLocationById?: Maybe<GpsLocation>;
  gpsLocations?: Maybe<GpsLocationsConnection>;
  impersonateUser: Scalars['String']['output'];
  labIndicatorDefinition?: Maybe<LabIndicatorDefinition>;
  labIndicatorDefinitions?: Maybe<LabIndicatorDefinitionsConnection>;
  labResult?: Maybe<LabResult>;
  laboratories?: Maybe<LaboratoriesConnection>;
  laboratoryById?: Maybe<Laboratory>;
  localisationAdminOverview: LocalisationAdminOverview;
  localisationEditor: LocalisationEditorView;
  localisationFile?: Maybe<Scalars['Any']['output']>;
  localisationLocales: Array<Scalars['String']['output']>;
  localisationString: Scalars['String']['output'];
  me: User;
  mlModelById?: Maybe<MlModel>;
  mlModels?: Maybe<MlModelsConnection>;
  openCassetteOverflowRequests?: Maybe<OpenCassetteOverflowRequestsConnection>;
  organisationById?: Maybe<Organisation>;
  organisationInviteRequest?: Maybe<OrganisationInviteRequest>;
  organisations?: Maybe<OrganisationsConnection>;
  passwordAuthStatus: PasswordAuthStatus;
  pesTest?: Maybe<PesTest>;
  pesTestFeatureCacheOverview: PesTestFeatureCacheOverview;
  pesTests?: Maybe<PesTestsConnection>;
  pesTestsForMl?: Maybe<PesTestsForMlConnection>;
  productTypeById?: Maybe<ProductType>;
  productTypes?: Maybe<ProductTypesConnection>;
  publicOrganisations?: Maybe<PublicOrganisationsConnection>;
  report?: Maybe<Report>;
  reports?: Maybe<ReportsConnection>;
  serialNumber?: Maybe<SerialNumber>;
  serialNumbers?: Maybe<SerialNumbersConnection>;
  serialRangeById?: Maybe<SerialRange>;
  serialRanges?: Maybe<SerialRangesConnection>;
  soilSample?: Maybe<SoilSample>;
  soilSamples?: Maybe<SoilSamplesConnection>;
  soilTypeById?: Maybe<SoilType>;
  soilTypes?: Maybe<SoilTypesConnection>;
  testsToDelete: Array<Scalars['UUID']['output']>;
  troManagementOverview: TroManagementOverview;
  user?: Maybe<User>;
  users?: Maybe<UsersConnection>;
  what3WordsLocation?: Maybe<What3WordsLocation>;
  what3WordsLocationByLatLon?: Maybe<What3WordsLocation>;
  what3WordsLocationByWords?: Maybe<What3WordsLocation>;
  what3WordsLocations?: Maybe<What3WordsLocationsConnection>;
};


export type QueryAuditLogsArgs = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  occurredFrom?: InputMaybe<Scalars['DateTime']['input']>;
  occurredTo?: InputMaybe<Scalars['DateTime']['input']>;
  order?: InputMaybe<Array<AuditLogSortInput>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<AuditLogFilterInput>;
};


export type QueryBatchArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BatchSortInput>>;
  where?: InputMaybe<BatchFilterInput>;
};


export type QueryCassetteArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCassettesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CassetteSortInput>>;
  where?: InputMaybe<CassetteFilterInput>;
};


export type QueryCountTestsPerDayForDateRangeArgs = {
  endDate: Scalars['DateTime']['input'];
  organisationId: Scalars['UUID']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryCoverCropByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCoverCropsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CoverCropSortInput>>;
  where?: InputMaybe<CoverCropFilterInput>;
};


export type QueryCropByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCropTypeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCropTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CropTypeSortInput>>;
  where?: InputMaybe<CropTypeFilterInput>;
};


export type QueryCropsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CropSortInput>>;
  where?: InputMaybe<CropFilterInput>;
};


export type QueryCultivationByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCultivationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CultivationSortInput>>;
  where?: InputMaybe<CultivationFilterInput>;
};


export type QueryCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomerSortInput>>;
  where?: InputMaybe<CustomerFilterInput>;
};


export type QueryDashboardStatsArgs = {
  endDate: Scalars['DateTime']['input'];
  excludedOrganisationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  includedOrganisationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  previousEndDate: Scalars['DateTime']['input'];
  previousStartDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryEruArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryEruByBleIdArgs = {
  bleId: Scalars['String']['input'];
};


export type QueryErusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EruSortInput>>;
  where?: InputMaybe<EruFilterInput>;
};


export type QueryExampleByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryExamplesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ExampleSortInput>>;
  where?: InputMaybe<ExampleFilterInput>;
};


export type QueryFarmArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryFarmsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FarmSortInput>>;
  where?: InputMaybe<FarmFilterInput>;
};


export type QueryFeatureExtractionExportRunArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryFeatureExtractionExportRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FeatureExtractionExportRunSortInput>>;
  where?: InputMaybe<FeatureExtractionExportRunFilterInput>;
};


export type QueryFieldArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FieldSortInput>>;
  where?: InputMaybe<FieldFilterInput>;
};


export type QueryFirmwareInstallLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareInstallLogSortInput>>;
  where?: InputMaybe<FirmwareInstallLogFilterInput>;
};


export type QueryFirmwareVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareVersionSortInput>>;
  where?: InputMaybe<FirmwareVersionFilterInput>;
};


export type QueryGpsLocationByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGpsLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GpsLocationSortInput>>;
  where?: InputMaybe<GpsLocationFilterInput>;
};


export type QueryImpersonateUserArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryLabIndicatorDefinitionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLabIndicatorDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LabIndicatorDefinitionSortInput>>;
  where?: InputMaybe<LabIndicatorDefinitionFilterInput>;
};


export type QueryLabResultArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLaboratoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LaboratorySortInput>>;
  where?: InputMaybe<LaboratoryFilterInput>;
};


export type QueryLaboratoryByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryLocalisationEditorArgs = {
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QueryLocalisationFileArgs = {
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QueryLocalisationLocalesArgs = {
  name: Scalars['String']['input'];
};


export type QueryLocalisationStringArgs = {
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
  string: Scalars['String']['input'];
};


export type QueryMlModelByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryMlModelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MlModelSortInput>>;
  where?: InputMaybe<MlModelFilterInput>;
};


export type QueryOpenCassetteOverflowRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludingCassetteId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CassetteOverflowRequestSortInput>>;
  where?: InputMaybe<CassetteOverflowRequestFilterInput>;
};


export type QueryOrganisationByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrganisationInviteRequestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};


export type QueryPesTestArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPesTestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  where?: InputMaybe<PesTestFilterInput>;
};


export type QueryPesTestsForMlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  troId: Scalars['UUID']['input'];
  where?: InputMaybe<PesTestFilterInput>;
};


export type QueryProductTypeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProductTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProductTypeSortInput>>;
  where?: InputMaybe<ProductTypeFilterInput>;
};


export type QueryPublicOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};


export type QueryReportArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportSortInput>>;
  where?: InputMaybe<ReportFilterInput>;
};


export type QuerySerialNumberArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySerialNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SerialNumberSortInput>>;
  where?: InputMaybe<SerialNumberFilterInput>;
};


export type QuerySerialRangeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySerialRangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SerialRangeSortInput>>;
  where?: InputMaybe<SerialRangeFilterInput>;
};


export type QuerySoilSampleArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySoilSamplesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SoilSampleSortInput>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SoilSampleFilterInput>;
};


export type QuerySoilTypeByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySoilTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SoilTypeSortInput>>;
  where?: InputMaybe<SoilTypeFilterInput>;
};


export type QueryTestsToDeleteArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserSortInput>>;
  organisationId?: InputMaybe<Scalars['UUID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserFilterInput>;
};


export type QueryWhat3WordsLocationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryWhat3WordsLocationByLatLonArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryWhat3WordsLocationByWordsArgs = {
  words: Scalars['String']['input'];
};


export type QueryWhat3WordsLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<What3WordsLocationSortInput>>;
  where?: InputMaybe<What3WordsLocationFilterInput>;
};

/** Input for queueing one AI-generated localisation translation. */
export type QueueLocalisationTranslationInput = {
  context?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  key: Scalars['String']['input'];
  locale: Scalars['String']['input'];
};

export type QueuePesTestPredictionInput = {
  /** Optional new-model name override. Defaults to ML_MODEL_NAME. The old pipeline always uses nn_attention_v2. */
  modelName?: InputMaybe<Scalars['String']['input']>;
  /** Pipeline to run. Defaults to the new feature-extraction pipeline. */
  pipeline?: PredictionPipeline;
  /** Whether to recalculate cached features before prediction. */
  refreshCache?: InputMaybe<Scalars['Boolean']['input']>;
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

export type QueuePesTestTargetPredictionsInput = {
  /** Optional new-model name override. Defaults to ML_MODEL_NAME. The old pipeline always uses nn_attention_v2. */
  modelName?: InputMaybe<Scalars['String']['input']>;
  /** Pipeline to run. Defaults to the new feature-extraction pipeline. */
  pipeline?: PredictionPipeline;
  /** Whether to recalculate cached features before prediction. */
  refreshCache?: InputMaybe<Scalars['Boolean']['input']>;
  /** Prediction target names to create or update. */
  targetNames: Array<Scalars['String']['input']>;
  /** PESTest IDs to queue. */
  testIds: Array<Scalars['UUID']['input']>;
};

export type QueuedBackgroundJobType = {
  __typename?: 'QueuedBackgroundJobType';
  averageDurationSeconds?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  displayName: Scalars['String']['output'];
  estimatedTotalDurationSeconds?: Maybe<Scalars['Float']['output']>;
  methodType: Scalars['String']['output'];
  nextScheduledAt?: Maybe<Scalars['DateTime']['output']>;
  queue: Scalars['String']['output'];
};

export type RecordPesTestFeatureCacheInput = {
  /** When the feature payload was extracted. Defaults to now. */
  extractedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Number of extracted features in the payload. */
  featureCount: Scalars['Int']['input'];
  /** Feature-set version or cache namespace. */
  featureSetVersion: Scalars['String']['input'];
  /** Extra JSON metadata for the cached payload. */
  metadataJson?: InputMaybe<Scalars['String']['input']>;
  /** Optional SHA-256 digest for the cached payload. */
  payloadSha256?: InputMaybe<Scalars['String']['input']>;
  /** Stable sample identifier used by the extractor. */
  sampleId: Scalars['String']['input'];
  /** Storage URI for the cached feature payload. */
  sourceUri: Scalars['String']['input'];
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

export type RedeemMagicLinkInput = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RemoveOrganisationMemberInput = {
  organisationId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

/** A generated report. */
export type Report = {
  __typename?: 'Report';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** Report format. */
  format: ReportFormat;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Whether the report has completed successfully. */
  isComplete: Scalars['Boolean']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  pesTests?: Maybe<PesTestsConnection>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A generated report. */
export type ReportPesTestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PesTestSortInput>>;
  where?: InputMaybe<PesTestFilterInput>;
};

/** A generated report. */
export type ReportFilterInput = {
  and?: InputMaybe<Array<ReportFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Report format. */
  format?: InputMaybe<ReportFormatOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether the report has completed successfully. */
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** Report output format. */
export enum ReportFormat {
  Csv = 'CSV',
  Pdf = 'PDF'
}

export type ReportFormatOperationFilterInput = {
  eq?: InputMaybe<ReportFormat>;
  in?: InputMaybe<Array<ReportFormat>>;
  neq?: InputMaybe<ReportFormat>;
  nin?: InputMaybe<Array<ReportFormat>>;
};

/** A generated report. */
export type ReportSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Report format. */
  format?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether the report has completed successfully. */
  isComplete?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Report>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Report;
};

export type RequestMagicLinkInput = {
  email: Scalars['String']['input'];
};

export type RequestOrganisationAccessInput = {
  organisationId: Scalars['UUID']['input'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
};

export type ResetPasswordWithCodeInput = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ResolveLegacyCachedRunIdInput = {
  /** Cassette ID. */
  cassetteId: Scalars['UUID']['input'];
  /** ERU ID. */
  eruId: Scalars['UUID']['input'];
  /** Field ID (used to derive farm and organisation). */
  fieldId: Scalars['UUID']['input'];
  /** Whether this test was run in debug mode. */
  isDebug?: Scalars['Boolean']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
  /** SRF UUID. */
  srfUuid: Scalars['UUID']['input'];
  /** Test type. */
  testType: PesTestType;
  /** UTC test time. */
  utcTestTime: Scalars['DateTime']['input'];
};

export type RespondToOrganisationInviteRequestInput = {
  id: Scalars['UUID']['input'];
};

/** A PES test result. */
export type Result = {
  __typename?: 'Result';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  indicator?: Maybe<TrainedIndicator>;
  /** Indicator name. */
  name: Scalars['String']['output'];
  pesTest?: Maybe<PesTest>;
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Result value. */
  value: Scalars['Float']['output'];
};

/** A PES test result. */
export type ResultFilterInput = {
  and?: InputMaybe<Array<ResultFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Indicator name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ResultFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Result value. */
  value?: InputMaybe<FloatOperationFilterInput>;
};

/** A PES test result. */
export type ResultSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Indicator name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** Result value. */
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ResultsConnection = {
  __typename?: 'ResultsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ResultsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Result>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ResultsEdge = {
  __typename?: 'ResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Result;
};

export enum Season {
  Autumn = 'AUTUMN',
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

export type SeasonOperationFilterInput = {
  eq?: InputMaybe<Season>;
  in?: InputMaybe<Array<Season>>;
  neq?: InputMaybe<Season>;
  nin?: InputMaybe<Array<Season>>;
};

/** Input for sending a report. */
export type SendReportInput = {
  reportId: Scalars['UUID']['input'];
};

/** A serial number assigned to a batch within a serial range. */
export type SerialNumber = {
  __typename?: 'SerialNumber';
  batch?: Maybe<Batch>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  formattedSerialNumber?: Maybe<Scalars['String']['output']>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  range?: Maybe<SerialRange>;
  /** Serial number (0-9999999). */
  serialNumber: Scalars['Int']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A serial number assigned to a batch within a serial range. */
export type SerialNumberFilterInput = {
  and?: InputMaybe<Array<SerialNumberFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<SerialNumberFilterInput>>;
  /** Serial number (0-9999999). */
  serialNumber?: InputMaybe<IntOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A serial number assigned to a batch within a serial range. */
export type SerialNumberSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Serial number (0-9999999). */
  serialNumber?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SerialNumbersConnection = {
  __typename?: 'SerialNumbersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SerialNumbersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SerialNumber>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SerialNumbersEdge = {
  __typename?: 'SerialNumbersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SerialNumber;
};

/** A serial number allocation range for a product type. */
export type SerialRange = {
  __typename?: 'SerialRange';
  /** Build description. */
  buildDescription: Scalars['String']['output'];
  /** Build end date. */
  buildEndDate?: Maybe<Scalars['DateTime']['output']>;
  /** Build start date. */
  buildStartDate: Scalars['DateTime']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Inclusive end of the range. */
  endNumber: Scalars['Int']['output'];
  /** Firmware version. */
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  nextAvailable: Scalars['Int']['output'];
  /** Notes. */
  notes?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  /** Inclusive start of the range. */
  startNumber: Scalars['Int']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A serial number allocation range for a product type. */
export type SerialRangeFilterInput = {
  and?: InputMaybe<Array<SerialRangeFilterInput>>;
  /** Build description. */
  buildDescription?: InputMaybe<StringOperationFilterInput>;
  /** Build end date. */
  buildEndDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** Build start date. */
  buildStartDate?: InputMaybe<DateTimeOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Inclusive end of the range. */
  endNumber?: InputMaybe<IntOperationFilterInput>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Notes. */
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SerialRangeFilterInput>>;
  /** Inclusive start of the range. */
  startNumber?: InputMaybe<IntOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A serial number allocation range for a product type. */
export type SerialRangeSortInput = {
  /** Build description. */
  buildDescription?: InputMaybe<SortEnumType>;
  /** Build end date. */
  buildEndDate?: InputMaybe<SortEnumType>;
  /** Build start date. */
  buildStartDate?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Inclusive end of the range. */
  endNumber?: InputMaybe<SortEnumType>;
  /** Firmware version. */
  firmwareVersion?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Notes. */
  notes?: InputMaybe<SortEnumType>;
  /** Inclusive start of the range. */
  startNumber?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SerialRangesConnection = {
  __typename?: 'SerialRangesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SerialRangesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SerialRange>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SerialRangesEdge = {
  __typename?: 'SerialRangesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SerialRange;
};

/** Input for enabling or disabling one target locale system wide. */
export type SetLocalisationLocaleEnabledInput = {
  isEnabled: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
};

/** Result of enabling or disabling a target locale system wide. */
export type SetLocalisationLocaleEnabledResult = {
  __typename?: 'SetLocalisationLocaleEnabledResult';
  isEnabled: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
};

export type SetOwnPasswordInput = {
  password: Scalars['String']['input'];
};

export type SetUserRoleInput = {
  role: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** Simplified soil texture. */
export enum SimpleSoilTexture {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM'
}

export type SimpleSoilTextureOperationFilterInput = {
  eq?: InputMaybe<SimpleSoilTexture>;
  in?: InputMaybe<Array<SimpleSoilTexture>>;
  neq?: InputMaybe<SimpleSoilTexture>;
  nin?: InputMaybe<Array<SimpleSoilTexture>>;
};

/** A soil sample. */
export type SoilSample = {
  __typename?: 'SoilSample';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  coverCrop?: Maybe<CoverCrop>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  cropType?: Maybe<CropType>;
  cultivation?: Maybe<Cultivation>;
  farm?: Maybe<Farm>;
  field?: Maybe<Field>;
  /** Whether farmyard manure (FYM) was applied. */
  fym: Scalars['Boolean']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Whether this sample is from a reference zone. */
  isReferenceZone: Scalars['Boolean']['output'];
  labResults?: Maybe<LabResultsConnection>;
  lastYearCrop?: Maybe<Crop>;
  location?: Maybe<GpsLocation>;
  /** Moisture level. */
  moisture?: Maybe<MoistureLevel>;
  /** Display name. */
  name: Scalars['String']['output'];
  /** Date the sample was collected. */
  sampleDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Season. */
  season?: Maybe<Season>;
  soilType?: Maybe<SoilType>;
  /** Whether straw was removed. */
  strawRemoved: Scalars['Boolean']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  yearBeforeLastCrop?: Maybe<Crop>;
};


/** A soil sample. */
export type SoilSampleLabResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LabResultSortInput>>;
  where?: InputMaybe<LabResultFilterInput>;
};

/** A soil sample. */
export type SoilSampleFilterInput = {
  and?: InputMaybe<Array<SoilSampleFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Whether farmyard manure (FYM) was applied. */
  fym?: InputMaybe<BooleanOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Whether this sample is from a reference zone. */
  isReferenceZone?: InputMaybe<BooleanOperationFilterInput>;
  /** Moisture level. */
  moisture?: InputMaybe<NullableOfMoistureLevelOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SoilSampleFilterInput>>;
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<LocalDateOperationFilterInput>;
  /** Season. */
  season?: InputMaybe<NullableOfSeasonOperationFilterInput>;
  /** Whether straw was removed. */
  strawRemoved?: InputMaybe<BooleanOperationFilterInput>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A soil sample. */
export type SoilSampleSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Whether farmyard manure (FYM) was applied. */
  fym?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Whether this sample is from a reference zone. */
  isReferenceZone?: InputMaybe<SortEnumType>;
  /** Moisture level. */
  moisture?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<SortEnumType>;
  /** Season. */
  season?: InputMaybe<SortEnumType>;
  /** Whether straw was removed. */
  strawRemoved?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SoilSamplesConnection = {
  __typename?: 'SoilSamplesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SoilSamplesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SoilSample>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SoilSamplesEdge = {
  __typename?: 'SoilSamplesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SoilSample;
};

/** A type of soil (unique by normalized name). */
export type SoilType = {
  __typename?: 'SoilType';
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName: Scalars['String']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A type of soil (unique by normalized name). */
export type SoilTypeFilterInput = {
  and?: InputMaybe<Array<SoilTypeFilterInput>>;
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<StringOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Display name. */
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SoilTypeFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A type of soil (unique by normalized name). */
export type SoilTypeSortInput = {
  /** Normalized name used for uniqueness (trimmed + lowercased). */
  cleanName?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Display name. */
  name?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SoilTypesConnection = {
  __typename?: 'SoilTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SoilTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SoilType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SoilTypesEdge = {
  __typename?: 'SoilTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SoilType;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartFeatureExtractionExportInput = {
  /** Optional maximum number of valid tests to include, selected by name then UUID. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to reuse valid current-version caches or re-extract every eligible test. */
  mode: FeatureExtractionExportMode;
  /** TRO UUID whose eligible PES tests should be exported. */
  troUuid: Scalars['UUID']['input'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Cassette TRH type. */
export enum TrhType {
  Old = 'OLD',
  Spring_2025 = 'SPRING_2025'
}

export type TrhTypeOperationFilterInput = {
  eq?: InputMaybe<TrhType>;
  in?: InputMaybe<Array<TrhType>>;
  neq?: InputMaybe<TrhType>;
  nin?: InputMaybe<Array<TrhType>>;
};

/** Test run order metadata. */
export type Tro = {
  __typename?: 'TRO';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** Whether issue notifications should be sent for tests using this TRO. */
  showTestAlerts: Scalars['Boolean']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** TRO UUID used by PES tests. */
  uuid: Scalars['UUID']['output'];
};

export type TroManagementOverview = {
  __typename?: 'TROManagementOverview';
  tros: Array<TroSummary>;
  unknownTros: Array<UnknownTroSummary>;
};

export type TroSummary = {
  __typename?: 'TROSummary';
  id: Scalars['UUID']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  showTestAlerts: Scalars['Boolean']['output'];
  totalTestCount: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
};

/** Number of PES tests on a given date. */
export type TestCountByDay = {
  __typename?: 'TestCountByDay';
  count: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

/** A connection to a list of items. */
export type TestsConnection = {
  __typename?: 'TestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PesTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TestsEdge = {
  __typename?: 'TestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PesTest;
};

/** A trained indicator for a machine learning model. */
export type TrainedIndicator = {
  __typename?: 'TrainedIndicator';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  indicatorDefinition?: Maybe<LabIndicatorDefinition>;
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: Maybe<Scalars['String']['output']>;
  /** Maximum value. */
  maxValue: Scalars['Float']['output'];
  /** Minimum value. */
  minValue: Scalars['Float']['output'];
  model?: Maybe<MlModel>;
  /** Computed name from the indicator definition. */
  name: Scalars['String']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A trained indicator for a machine learning model. */
export type TrainedIndicatorFilterInput = {
  and?: InputMaybe<Array<TrainedIndicatorFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<StringOperationFilterInput>;
  /** Maximum value. */
  maxValue?: InputMaybe<FloatOperationFilterInput>;
  /** Minimum value. */
  minValue?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<TrainedIndicatorFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A trained indicator for a machine learning model. */
export type TrainedIndicatorSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<SortEnumType>;
  /** Maximum value. */
  maxValue?: InputMaybe<SortEnumType>;
  /** Minimum value. */
  minValue?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TrainedIndicatorsConnection = {
  __typename?: 'TrainedIndicatorsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TrainedIndicatorsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TrainedIndicator>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TrainedIndicatorsEdge = {
  __typename?: 'TrainedIndicatorsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TrainedIndicator;
};

export type TransferPesTestInput = {
  /** Existing target farm ID. */
  existingFarmId?: InputMaybe<Scalars['UUID']['input']>;
  /** Existing target field ID. */
  existingFieldId?: InputMaybe<Scalars['UUID']['input']>;
  /** New target farm name. */
  newFarmName?: InputMaybe<Scalars['String']['input']>;
  /** New target field name. */
  newFieldName?: InputMaybe<Scalars['String']['input']>;
  /** Target organisation ID. */
  targetOrganisationId: Scalars['UUID']['input'];
  /** Target user ID. */
  targetUserId: Scalars['UUID']['input'];
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

export type UnknownTroSummary = {
  __typename?: 'UnknownTROSummary';
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  totalTestCount: Scalars['Int']['output'];
  uuid: Scalars['UUID']['output'];
};

/** Input for updating a Batch. */
export type UpdateBatchInput = {
  batchNumber: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

/** Input for updating a Cassette. */
export type UpdateCassetteInput = {
  expiryDate: Scalars['DateTime']['input'];
  extraMetadata: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  manufactureDate: Scalars['DateTime']['input'];
  maxIndexTimeSeconds: Scalars['Float']['input'];
  numSensors: Scalars['Int']['input'];
  sensorCheckUuid: Scalars['UUID']['input'];
  serialNumberId?: InputMaybe<Scalars['UUID']['input']>;
  soilTestUuid: Scalars['UUID']['input'];
  trhType: TrhType;
};

export type UpdateCoverCropInput = {
  /** CoverCrop ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type UpdateCropInput = {
  /** Crop ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type UpdateCropTypeInput = {
  /** CropType ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type UpdateCultivationInput = {
  /** Cultivation ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type UpdateCustomerInput = {
  /** Lab indicator definition IDs the customer's users may see (null = unchanged, [] = clear). Must be non-empty while limitIndicators is true. */
  allowedIndicatorDefinitionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Cassette IDs to attach (null = unchanged, [] = clear). */
  cassetteIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Primary contact email address. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact name. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Primary contact phone number. */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** When the customer relationship began. */
  customerSince: Scalars['DateTime']['input'];
  /** Description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ERU IDs to attach (null = unchanged, [] = clear). */
  eruIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Customer ID. */
  id: Scalars['UUID']['input'];
  /** Whether to limit visible results to the allowed indicator definitions (null = unchanged). */
  limitIndicators?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Internal notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Organisation IDs to attach (null = unchanged, [] = clear). */
  organisationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UpdateEruInput = {
  /** BLE identifier (unique when present). */
  bleId?: InputMaybe<Scalars['String']['input']>;
  /** BLE MAC address (unique when present). */
  bleMac?: InputMaybe<Scalars['String']['input']>;
  /** ERU ID. */
  id: Scalars['UUID']['input'];
  /** Internal UUID for the ERU. */
  internalId: Scalars['UUID']['input'];
  /** Display name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating an Example. */
export type UpdateExampleInput = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateFarmInput = {
  /** Farm ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
  /** Owner name. */
  ownerName?: InputMaybe<Scalars['String']['input']>;
  /** Postcode. */
  postcode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFieldInput = {
  /** Field ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type UpdateFirmwareInstallLogInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  status: FirmwareInstallLogStatus;
  technicalLog?: InputMaybe<Scalars['String']['input']>;
  updateToken: Scalars['String']['input'];
};

export type UpdateLabIndicatorDefinitionInput = {
  /** Whether to always show this indicator. */
  alwaysShow: Scalars['Boolean']['input'];
  /** Indicator description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Number of decimal places to display. */
  displayDecimalPlaces: Scalars['Int']['input'];
  /** Optional display name override. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Lab indicator definition ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
  /** Unit label. */
  unit: Scalars['String']['input'];
  /** Value type. */
  valueType: LabIndicatorValueType;
};

export type UpdateLabResultInput = {
  /** LabResult ID. */
  id: Scalars['UUID']['input'];
  /** Laboratory ID. */
  laboratoryId: Scalars['UUID']['input'];
  /** Lab result value. */
  value: Scalars['String']['input'];
};

export type UpdateLaboratoryInput = {
  /** Laboratory ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

/** Input for updating a localisation file from a newer base JSON upload or file-level translation context change. */
export type UpdateLocalisationFileInput = {
  jsonContent?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  translationContext?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating one translated string. */
export type UpdateLocalisationTranslationInput = {
  fileName: Scalars['String']['input'];
  isApproved: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateMlModelInput = {
  /** MLModel ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type UpdateOrganisationInput = {
  contactEmail: Scalars['String']['input'];
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isAutocreated: Scalars['Boolean']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  public: Scalars['Boolean']['input'];
};

export type UpdatePesTestInput = {
  /** CropType ID. */
  cropTypeId: Scalars['UUID']['input'];
  /** Whether to exclude from ML. */
  excludeFromMl: Scalars['Boolean']['input'];
  /** Extra JSON metadata. */
  extraMetadata?: InputMaybe<Scalars['String']['input']>;
  /** Failure reasons. */
  failureReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Firmware version. */
  firmwareVersion: Scalars['String']['input'];
  /** GPS accuracy in meters. */
  gpsAccuracy?: InputMaybe<Scalars['Float']['input']>;
  /** GPS latitude. */
  gpsLatitude: Scalars['Float']['input'];
  /** GPS longitude. */
  gpsLongitude: Scalars['Float']['input'];
  /** PESTest ID. */
  id: Scalars['UUID']['input'];
  /** Whether this test was run in debug mode. */
  isDebug: Scalars['Boolean']['input'];
  /** Whether this test failed. */
  isFailure: Scalars['Boolean']['input'];
  /** Whether this test is from a reference zone. */
  isReferenceZone: Scalars['Boolean']['input'];
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Original model name. */
  originalModelName: Scalars['String']['input'];
  /** Logical run UUID. */
  runId?: InputMaybe<Scalars['UUID']['input']>;
  /** Season. */
  season: Season;
  /** Optional SoilSample ID. */
  soilSampleId?: InputMaybe<Scalars['UUID']['input']>;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** SRF UUID. */
  srfUuid: Scalars['UUID']['input'];
  /** Test type. */
  testType: PesTestType;
  /** TRO UUID. */
  troUuid: Scalars['UUID']['input'];
  /** UTC test time. */
  utcTestTime: Scalars['DateTime']['input'];
};

export type UpdatePesTestCharacteristicsInput = {
  /** CropType ID. */
  cropTypeId: Scalars['UUID']['input'];
  /** Whether this test is from a reference zone. */
  isReferenceZone: Scalars['Boolean']['input'];
  /** Moisture level. */
  moisture: MoistureLevel;
  /** Season. */
  season: Season;
  /** Soil texture. */
  soilTexture: SimpleSoilTexture;
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

export type UpdatePesTestLocationInput = {
  /** GPS latitude. */
  latitude: Scalars['Float']['input'];
  /** GPS longitude. */
  longitude: Scalars['Float']['input'];
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

export type UpdatePesTestNameInput = {
  /** Display name. */
  name: Scalars['String']['input'];
  /** PESTest ID. */
  testId: Scalars['UUID']['input'];
};

/** Input for updating a ProductType. */
export type UpdateProductTypeInput = {
  id: Scalars['UUID']['input'];
  location: Scalars['String']['input'];
  model: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subType: Scalars['String']['input'];
};

/** Input for updating a result. */
export type UpdateResultInput = {
  /** Result ID. */
  id: Scalars['UUID']['input'];
  /** Result value. */
  value: Scalars['Float']['input'];
};

export type UpdateSerialNumberInput = {
  /** Serial number ID. */
  id: Scalars['UUID']['input'];
  /** Serial number (0-9999999). */
  serialNumber: Scalars['Int']['input'];
};

export type UpdateSerialRangeInput = {
  /** Build description. */
  buildDescription: Scalars['String']['input'];
  /** Build end date. */
  buildEndDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Build start date. */
  buildStartDate: Scalars['DateTime']['input'];
  /** Inclusive end of the range. */
  endNumber: Scalars['Int']['input'];
  /** Firmware version. */
  firmwareVersion?: InputMaybe<Scalars['String']['input']>;
  /** Serial range ID. */
  id: Scalars['UUID']['input'];
  /** Notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Product type ID. */
  productTypeId: Scalars['UUID']['input'];
  /** Inclusive start of the range. */
  startNumber: Scalars['Int']['input'];
};

export type UpdateSoilSampleInput = {
  /** CoverCrop ID. */
  coverCropId?: InputMaybe<Scalars['UUID']['input']>;
  /** CropType ID. */
  cropTypeId?: InputMaybe<Scalars['UUID']['input']>;
  /** Cultivation ID. */
  cultivationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Farm ID. */
  farmId?: InputMaybe<Scalars['UUID']['input']>;
  /** Field ID. */
  fieldId?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether farmyard manure (FYM) was applied. */
  fym: Scalars['Boolean']['input'];
  /** GPS latitude. Provide both latitude and longitude to set a location. */
  gpsLatitude?: InputMaybe<Scalars['Float']['input']>;
  /** GPS longitude. Provide both latitude and longitude to set a location. */
  gpsLongitude?: InputMaybe<Scalars['Float']['input']>;
  /** SoilSample ID. */
  id: Scalars['UUID']['input'];
  /** Whether this sample is from a reference zone. */
  isReferenceZone: Scalars['Boolean']['input'];
  /** Last year's crop ID. */
  lastYearCropId?: InputMaybe<Scalars['UUID']['input']>;
  /** Moisture level. */
  moisture?: InputMaybe<MoistureLevel>;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Date the sample was collected. */
  sampleDate?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Season. */
  season?: InputMaybe<Season>;
  /** SoilType ID. */
  soilTypeId?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether straw was removed. */
  strawRemoved: Scalars['Boolean']['input'];
  /** Year before last crop ID. */
  yearBeforeLastCropId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateSoilTypeInput = {
  /** SoilType ID. */
  id: Scalars['UUID']['input'];
  /** Display name. */
  name: Scalars['String']['input'];
};

export type UpdateTroInput = {
  /** TRO database ID. */
  id: Scalars['UUID']['input'];
  /** Optional replacement display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional replacement alert setting. */
  showTestAlerts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating a trained indicator. */
export type UpdateTrainedIndicatorInput = {
  /** Trained indicator ID. */
  id: Scalars['UUID']['input'];
  /** Optional sparse attention inference API model name for this indicator. */
  inferenceModelName?: InputMaybe<Scalars['String']['input']>;
  /** Maximum value. */
  maxValue: Scalars['Float']['input'];
  /** Minimum value. */
  minValue: Scalars['Float']['input'];
};

/** Input for updating a What3Words location. */
export type UpdateWhat3WordsLocationInput = {
  gpsLatitudeCenter: Scalars['Float']['input'];
  gpsLatitudeNe: Scalars['Float']['input'];
  gpsLatitudeSw: Scalars['Float']['input'];
  gpsLongitudeCenter: Scalars['Float']['input'];
  gpsLongitudeNe: Scalars['Float']['input'];
  gpsLongitudeSw: Scalars['Float']['input'];
  id: Scalars['UUID']['input'];
  words: Scalars['String']['input'];
};

/** A chunk of uploaded test data. */
export type UploadChunk = {
  __typename?: 'UploadChunk';
  /** Zero-based index of this chunk. */
  chunkIndex: Scalars['Int']['output'];
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** JSON data for this chunk. */
  data: Scalars['String']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  uploadRequest?: Maybe<UploadRequest>;
};

/** A chunk of uploaded test data. */
export type UploadChunkFilterInput = {
  and?: InputMaybe<Array<UploadChunkFilterInput>>;
  /** Zero-based index of this chunk. */
  chunkIndex?: InputMaybe<IntOperationFilterInput>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** JSON data for this chunk. */
  data?: InputMaybe<StringOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UploadChunkFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A chunk of uploaded test data. */
export type UploadChunkSortInput = {
  /** Zero-based index of this chunk. */
  chunkIndex?: InputMaybe<SortEnumType>;
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** JSON data for this chunk. */
  data?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
};

export type UploadFirmwareInput = {
  activate: Scalars['Boolean']['input'];
  base64Data: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

/** A request to upload test data in chunks. */
export type UploadRequest = {
  __typename?: 'UploadRequest';
  chunks?: Maybe<ChunksConnection>;
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  isComplete: Scalars['Boolean']['output'];
  pesTest?: Maybe<PesTest>;
  /** When a worker last claimed this request for processing. */
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of the upload request. */
  status: UploadRequestStatus;
  /** Total number of chunks expected. */
  totalChunks: Scalars['Int']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A request to upload test data in chunks. */
export type UploadRequestChunksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UploadChunkSortInput>>;
  where?: InputMaybe<UploadChunkFilterInput>;
};

export enum UploadRequestStatus {
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  organisationInviteRequests?: Maybe<OrganisationInviteRequestsConnection>;
  organisationMemberships: Array<Organisation>;
  organisations?: Maybe<OrganisationsConnection>;
  profilePictureUrl?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type UserOrganisationInviteRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganisationInviteRequestSortInput>>;
  where?: InputMaybe<OrganisationInviteRequestFilterInput>;
};


export type UserOrganisationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OrganisationSortInput>>;
  where?: InputMaybe<OrganisationFilterInput>;
};

export type UserFilterInput = {
  accessFailedCount?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<UserFilterInput>>;
  concurrencyStamp?: InputMaybe<StringOperationFilterInput>;
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  deletedAt?: InputMaybe<DateTimeOperationFilterInput>;
  deletionFailedAttempts?: InputMaybe<IntOperationFilterInput>;
  deletionLockedUntil?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  lockoutEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lockoutEnd?: InputMaybe<DateTimeOperationFilterInput>;
  magicLinkRedeemCount?: InputMaybe<IntOperationFilterInput>;
  normalizedEmail?: InputMaybe<StringOperationFilterInput>;
  normalizedUserName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  passwordHash?: InputMaybe<StringOperationFilterInput>;
  passwordResetCodeExpiresAt?: InputMaybe<DateTimeOperationFilterInput>;
  passwordResetCodeHash?: InputMaybe<StringOperationFilterInput>;
  passwordResetFailedAttempts?: InputMaybe<IntOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  phoneNumberConfirmed?: InputMaybe<BooleanOperationFilterInput>;
  profilePictureUrl?: InputMaybe<StringOperationFilterInput>;
  securityStamp?: InputMaybe<StringOperationFilterInput>;
  twoFactorEnabled?: InputMaybe<BooleanOperationFilterInput>;
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type UserSortInput = {
  accessFailedCount?: InputMaybe<SortEnumType>;
  concurrencyStamp?: InputMaybe<SortEnumType>;
  createdAt?: InputMaybe<SortEnumType>;
  deletedAt?: InputMaybe<SortEnumType>;
  deletionFailedAttempts?: InputMaybe<SortEnumType>;
  deletionLockedUntil?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailConfirmed?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lockoutEnabled?: InputMaybe<SortEnumType>;
  lockoutEnd?: InputMaybe<SortEnumType>;
  magicLinkRedeemCount?: InputMaybe<SortEnumType>;
  normalizedEmail?: InputMaybe<SortEnumType>;
  normalizedUserName?: InputMaybe<SortEnumType>;
  passwordHash?: InputMaybe<SortEnumType>;
  passwordResetCodeExpiresAt?: InputMaybe<SortEnumType>;
  passwordResetCodeHash?: InputMaybe<SortEnumType>;
  passwordResetFailedAttempts?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
  phoneNumberConfirmed?: InputMaybe<SortEnumType>;
  profilePictureUrl?: InputMaybe<SortEnumType>;
  securityStamp?: InputMaybe<SortEnumType>;
  twoFactorEnabled?: InputMaybe<SortEnumType>;
  updatedAt?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UsersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

/** A What3Words location with center point and bounding box. */
export type What3WordsLocation = {
  __typename?: 'What3WordsLocation';
  /** When this record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Center latitude. */
  gpsLatitudeCenter: Scalars['Float']['output'];
  /** North-east latitude corner. */
  gpsLatitudeNe: Scalars['Float']['output'];
  /** South-west latitude corner. */
  gpsLatitudeSw: Scalars['Float']['output'];
  /** Center longitude. */
  gpsLongitudeCenter: Scalars['Float']['output'];
  /** North-east longitude corner. */
  gpsLongitudeNe: Scalars['Float']['output'];
  /** South-west longitude corner. */
  gpsLongitudeSw: Scalars['Float']['output'];
  /** Unique identifier. */
  id: Scalars['UUID']['output'];
  /** When this record was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** What3Words triple (trimmed, exactly two dots). */
  words: Scalars['String']['output'];
};

/** A What3Words location with center point and bounding box. */
export type What3WordsLocationFilterInput = {
  and?: InputMaybe<Array<What3WordsLocationFilterInput>>;
  /** When this record was created. */
  createdAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** Center latitude. */
  gpsLatitudeCenter?: InputMaybe<FloatOperationFilterInput>;
  /** North-east latitude corner. */
  gpsLatitudeNe?: InputMaybe<FloatOperationFilterInput>;
  /** South-west latitude corner. */
  gpsLatitudeSw?: InputMaybe<FloatOperationFilterInput>;
  /** Center longitude. */
  gpsLongitudeCenter?: InputMaybe<FloatOperationFilterInput>;
  /** North-east longitude corner. */
  gpsLongitudeNe?: InputMaybe<FloatOperationFilterInput>;
  /** South-west longitude corner. */
  gpsLongitudeSw?: InputMaybe<FloatOperationFilterInput>;
  /** Unique identifier. */
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<What3WordsLocationFilterInput>>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<DateTimeOperationFilterInput>;
  /** What3Words triple (trimmed, exactly two dots). */
  words?: InputMaybe<StringOperationFilterInput>;
};

/** A What3Words location with center point and bounding box. */
export type What3WordsLocationSortInput = {
  /** When this record was created. */
  createdAt?: InputMaybe<SortEnumType>;
  /** Center latitude. */
  gpsLatitudeCenter?: InputMaybe<SortEnumType>;
  /** North-east latitude corner. */
  gpsLatitudeNe?: InputMaybe<SortEnumType>;
  /** South-west latitude corner. */
  gpsLatitudeSw?: InputMaybe<SortEnumType>;
  /** Center longitude. */
  gpsLongitudeCenter?: InputMaybe<SortEnumType>;
  /** North-east longitude corner. */
  gpsLongitudeNe?: InputMaybe<SortEnumType>;
  /** South-west longitude corner. */
  gpsLongitudeSw?: InputMaybe<SortEnumType>;
  /** Unique identifier. */
  id?: InputMaybe<SortEnumType>;
  /** When this record was last updated. */
  updatedAt?: InputMaybe<SortEnumType>;
  /** What3Words triple (trimmed, exactly two dots). */
  words?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type What3WordsLocationsConnection = {
  __typename?: 'What3WordsLocationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<What3WordsLocationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<What3WordsLocation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type What3WordsLocationsEdge = {
  __typename?: 'What3WordsLocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: What3WordsLocation;
};

export type AuditLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  actionType?: InputMaybe<Scalars['String']['input']>;
  occurredFrom?: InputMaybe<Scalars['DateTime']['input']>;
  occurredTo?: InputMaybe<Scalars['DateTime']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs?: { __typename?: 'AuditLogsConnection', nodes?: Array<{ __typename?: 'AuditLog', id: any, actionType: string, targetEntityType?: string | null, reason?: string | null, notes?: string | null, createdAt: any, actingUser?: { __typename?: 'User', id: any, fullName?: string | null, email?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type AuditLogActionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AuditLogActionTypesQuery = { __typename?: 'Query', auditLogActionTypes: Array<string> };

export type RequestMagicLinkMutationVariables = Exact<{
  input: RequestMagicLinkInput;
}>;


export type RequestMagicLinkMutation = { __typename?: 'Mutation', requestMagicLink: boolean };

export type RedeemMagicLinkMutationVariables = Exact<{
  input: RedeemMagicLinkInput;
}>;


export type RedeemMagicLinkMutation = { __typename?: 'Mutation', redeemMagicLink?: string | null };

export type LoginWithPasswordMutationVariables = Exact<{
  input: LoginWithPasswordInput;
}>;


export type LoginWithPasswordMutation = { __typename?: 'Mutation', loginWithPassword?: string | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: boolean };

export type ResetPasswordWithCodeMutationVariables = Exact<{
  input: ResetPasswordWithCodeInput;
}>;


export type ResetPasswordWithCodeMutation = { __typename?: 'Mutation', resetPasswordWithCode?: string | null };

export type SetOwnPasswordMutationVariables = Exact<{
  input: SetOwnPasswordInput;
}>;


export type SetOwnPasswordMutation = { __typename?: 'Mutation', setOwnPassword: boolean };

export type ChangeOwnPasswordMutationVariables = Exact<{
  input: ChangeOwnPasswordInput;
}>;


export type ChangeOwnPasswordMutation = { __typename?: 'Mutation', changeOwnPassword: boolean };

export type PasswordAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type PasswordAuthStatusQuery = { __typename?: 'Query', passwordAuthStatus: { __typename?: 'PasswordAuthStatus', hasPassword: boolean } };

export type MeQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: any, createdAt: any, email?: string | null, fullName?: string | null, profilePictureUrl?: string | null, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: any, name: string, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } };

export type BackgroundJobStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type BackgroundJobStatusQuery = { __typename?: 'Query', backgroundJobStatus: { __typename?: 'BackgroundJobStatus', processingCount: number, queuedCount: number, scheduledCount: number, processingJobs: Array<{ __typename?: 'ProcessingBackgroundJob', jobId: string, displayName: string, methodType: string, queue?: string | null, startedAt?: any | null, elapsedSeconds: number, averageDurationSeconds?: number | null, etaSeconds?: number | null }>, queuedByType: Array<{ __typename?: 'QueuedBackgroundJobType', displayName: string, methodType: string, queue: string, count: number, nextScheduledAt?: any | null, averageDurationSeconds?: number | null, estimatedTotalDurationSeconds?: number | null }>, predictionBacklog: { __typename?: 'PredictionBacklogStatus', queuedPredictionCount: number, runningPredictionCount: number, effectiveWorkerSlots: number, averagePredictionDurationSeconds?: number | null, estimatedWaitSeconds?: number | null } } };

export type QueueBackgroundJobDelayTestMutationVariables = Exact<{ [key: string]: never; }>;


export type QueueBackgroundJobDelayTestMutation = { __typename?: 'Mutation', queueBackgroundJobDelayTest: string };

export type QueueBackgroundJobPredictionDelayTestMutationVariables = Exact<{ [key: string]: never; }>;


export type QueueBackgroundJobPredictionDelayTestMutation = { __typename?: 'Mutation', queueBackgroundJobPredictionDelayTest: string };

export type BatchesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type BatchesQuery = { __typename?: 'Query', batches?: { __typename?: 'BatchesConnection', nodes?: Array<{ __typename?: 'Batch', id: any, createdAt: any, name: string, batchNumber: string, description?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateBatchMutationVariables = Exact<{
  input: CreateBatchInput;
}>;


export type CreateBatchMutation = { __typename?: 'Mutation', createBatch: { __typename?: 'Batch', id: any, createdAt: any, name: string, batchNumber: string, description?: string | null } };

export type UpdateBatchMutationVariables = Exact<{
  input: UpdateBatchInput;
}>;


export type UpdateBatchMutation = { __typename?: 'Mutation', updateBatch?: { __typename?: 'Batch', id: any, createdAt: any, name: string, batchNumber: string, description?: string | null } | null };

export type CassettesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CassettesQuery = { __typename?: 'Query', cassetteListSummary: { __typename?: 'CassetteListSummary', provisionedCount: number, allocatedCustomerTests: number, remainingCustomerTests: number, openOverflowWarningCount: number }, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: any, numSensors: number, manufactureDate: any, expiryDate: any, goodSensorCount: number, badSensorCount: number, allocatedCustomerTests: number, usedCustomerTests: number, remainingCustomerTests: number, physicalSensorsUsed: number, remainingPhysicalSensors: number, openOverflowRequestedTests: number, hasOpenOverflowWarning: boolean, lastUsedBy?: { __typename?: 'CassetteLastUsedInfo', fullName?: string | null, email?: string | null, usedAt: any } | null, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CassetteDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  afterEntitlementAdjustments?: InputMaybe<Scalars['String']['input']>;
  firstEntitlementAdjustments: Scalars['Int']['input'];
  afterOverflowRequests?: InputMaybe<Scalars['String']['input']>;
  firstOverflowRequests: Scalars['Int']['input'];
}>;


export type CassetteDetailQuery = { __typename?: 'Query', cassette?: { __typename?: 'Cassette', id: any, createdAt: any, updatedAt: any, numSensors: number, manufactureDate: any, expiryDate: any, maxIndexTimeSeconds: number, sensorCheckUuid: any, soilTestUuid: any, goodSensorCount: number, badSensorCount: number, baseCustomerTests: number, manualCustomerTestAdjustments: number, allocatedCustomerTests: number, usedCustomerTests: number, remainingCustomerTests: number, physicalSensorsUsed: number, remainingPhysicalSensors: number, currentCassetteExtraAllocatableTests: number, openOverflowRequestedTests: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null, entitlementAdjustments?: { __typename?: 'EntitlementAdjustmentsConnection', nodes?: Array<{ __typename?: 'CassetteEntitlementAdjustment', id: any, customerTestDelta: number, reasonCode: string, notes?: string | null, createdAt: any }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, overflowRequests?: { __typename?: 'OverflowRequestsConnection', nodes?: Array<{ __typename?: 'CassetteOverflowRequest', id: any, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, resolvedAt?: any | null, createdAt: any }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type OpenCassetteOverflowRequestsQueryVariables = Exact<{
  excludingCassetteId?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OpenCassetteOverflowRequestsQuery = { __typename?: 'Query', openCassetteOverflowRequests?: { __typename?: 'OpenCassetteOverflowRequestsConnection', nodes?: Array<{ __typename?: 'CassetteOverflowRequest', id: any, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, resolvedAt?: any | null, createdAt: any, cassette?: { __typename?: 'Cassette', id: any, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type AddCassetteEntitlementAdjustmentMutationVariables = Exact<{
  input: AddCassetteEntitlementAdjustmentInput;
}>;


export type AddCassetteEntitlementAdjustmentMutation = { __typename?: 'Mutation', addCassetteEntitlementAdjustment: { __typename?: 'CassetteEntitlementAdjustment', id: any, customerTestDelta: number, reasonCode: string, notes?: string | null, createdAt: any } };

export type CreateCassetteOverflowRequestMutationVariables = Exact<{
  input: CreateCassetteOverflowRequestInput;
}>;


export type CreateCassetteOverflowRequestMutation = { __typename?: 'Mutation', createCassetteOverflowRequest: { __typename?: 'CassetteOverflowRequest', id: any, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, createdAt: any } };

export type FulfilCassetteOverflowRequestMutationVariables = Exact<{
  input: FulfilCassetteOverflowRequestInput;
}>;


export type FulfilCassetteOverflowRequestMutation = { __typename?: 'Mutation', fulfilCassetteOverflowRequest: { __typename?: 'CassetteOverflowRequest', id: any, requestedTests: number, outstandingTests: number, reasonCode: string, notes?: string | null, status: string, resolvedAt?: any | null, createdAt: any } };

export type CoverCropsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CoverCropsQuery = { __typename?: 'Query', coverCrops?: { __typename?: 'CoverCropsConnection', nodes?: Array<{ __typename?: 'CoverCrop', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCoverCropMutationVariables = Exact<{
  input: CreateCoverCropInput;
}>;


export type CreateCoverCropMutation = { __typename?: 'Mutation', createCoverCrop: { __typename?: 'CoverCrop', id: any, name: string } };

export type CropsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CropsQuery = { __typename?: 'Query', crops?: { __typename?: 'CropsConnection', nodes?: Array<{ __typename?: 'Crop', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCropMutationVariables = Exact<{
  input: CreateCropInput;
}>;


export type CreateCropMutation = { __typename?: 'Mutation', createCrop: { __typename?: 'Crop', id: any, name: string } };

export type CropTypesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CropTypesQuery = { __typename?: 'Query', cropTypes?: { __typename?: 'CropTypesConnection', nodes?: Array<{ __typename?: 'CropType', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCropTypeMutationVariables = Exact<{
  input: CreateCropTypeInput;
}>;


export type CreateCropTypeMutation = { __typename?: 'Mutation', createCropType: { __typename?: 'CropType', id: any, name: string } };

export type CultivationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CultivationsQuery = { __typename?: 'Query', cultivations?: { __typename?: 'CultivationsConnection', nodes?: Array<{ __typename?: 'Cultivation', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCultivationMutationVariables = Exact<{
  input: CreateCultivationInput;
}>;


export type CreateCultivationMutation = { __typename?: 'Mutation', createCultivation: { __typename?: 'Cultivation', id: any, name: string } };

export type CustomersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', nodes?: Array<{ __typename?: 'Customer', id: any, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, customerSince: any, notes?: string | null, createdAt: any, updatedAt: any, limitIndicators: boolean, allowedIndicatorDefinitions: Array<{ __typename?: 'LabIndicatorDefinition', id: any, name: string, displayName?: string | null }>, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: any, name: string, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: any, name?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: any, remainingCustomerTests: number, remainingPhysicalSensors: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetCustomerOrganisationsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerOrganisationsQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: any, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: any, name: string, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type GetCustomerErusQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerErusQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: any, erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: any, name?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type GetCustomerCassettesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomerCassettesQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: any, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: any, remainingCustomerTests: number, remainingPhysicalSensors: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type GetCustomerByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCustomerByIdQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: any, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, customerSince: any, notes?: string | null, createdAt: any, updatedAt: any, limitIndicators: boolean, allowedIndicatorDefinitions: Array<{ __typename?: 'LabIndicatorDefinition', id: any, name: string, displayName?: string | null }>, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: any, name: string, logoUrl?: string | null }> | null } | null, erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: any, name?: string | null }> | null } | null, cassettes?: { __typename?: 'CassettesConnection', nodes?: Array<{ __typename?: 'Cassette', id: any, remainingCustomerTests: number, remainingPhysicalSensors: number, hasOpenOverflowWarning: boolean, serialNumber?: { __typename?: 'SerialNumber', serialNumber: number, range?: { __typename?: 'SerialRange', productType?: { __typename?: 'ProductType', code: string } | null } | null } | null }> | null } | null } | null };

export type DashboardCustomersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardCustomersQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', nodes?: Array<{ __typename?: 'Customer', id: any, name: string, organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: any }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CreateCustomerInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'Customer', id: any, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, customerSince: any, notes?: string | null, createdAt: any } };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'Customer', id: any, name: string, description?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: string | null, notes?: string | null, limitIndicators: boolean, allowedIndicatorDefinitions: Array<{ __typename?: 'LabIndicatorDefinition', id: any, name: string, displayName?: string | null }> } | null };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: boolean };

export type DashboardStatsQueryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  previousStartDate: Scalars['DateTime']['input'];
  previousEndDate: Scalars['DateTime']['input'];
  includedOrganisationIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  excludedOrganisationIds?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type DashboardStatsQuery = { __typename?: 'Query', dashboardStats: { __typename?: 'DashboardStats', currentPeriod: Array<{ __typename?: 'DailyTestMetrics', date: any, totalCount: number, soilTests: number, successfulSensorChecks: number, failedSensorChecks: number }>, previousPeriod: Array<{ __typename?: 'DailyTestMetrics', date: any, totalCount: number, soilTests: number, successfulSensorChecks: number, failedSensorChecks: number }>, organisationStats: Array<{ __typename?: 'OrganisationTestStats', organisationId: any, organisationName: string, soilTests: number, successfulSensorChecks: number, failedSensorChecks: number }>, mapPoints: Array<{ __typename?: 'MapPoint', testId: any, latitude: number, longitude: number, what3Words?: string | null, testName?: string | null, organisationName?: string | null }> } };

export type DuplicatedLabResultsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type DuplicatedLabResultsCountQuery = { __typename?: 'Query', duplicatedLabResultsCount: number };

export type DedupeLabResultsMutationVariables = Exact<{ [key: string]: never; }>;


export type DedupeLabResultsMutation = { __typename?: 'Mutation', dedupeLabResults: number };

export type ErUsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ErUsQuery = { __typename?: 'Query', erus?: { __typename?: 'ErusConnection', nodes?: Array<{ __typename?: 'ERU', id: any, name?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FarmsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FarmsQuery = { __typename?: 'Query', farms?: { __typename?: 'FarmsConnection', nodes?: Array<{ __typename?: 'Farm', id: any, name: string, organisation?: { __typename?: 'Organisation', id: any } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FeatureExtractionExportRunsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeatureExtractionExportRunsQuery = { __typename?: 'Query', featureExtractionExportRuns?: { __typename?: 'FeatureExtractionExportRunsConnection', nodes?: Array<{ __typename?: 'FeatureExtractionExportRun', id: any, troUuid: any, featureSetVersion: string, mode: FeatureExtractionExportMode, testLimit?: number | null, status: FeatureExtractionExportStatus, requestedByEmail?: string | null, totalTestCount: number, excludedTestCount: number, reusedCacheCount: number, queuedExtractionCount: number, completedExtractionCount: number, failedExtractionCount: number, labResultWarningCount: number, startedAt?: any | null, completedAt?: any | null, errorSummary?: string | null, csvSizeBytes?: any | null, csvRowCount?: number | null, csvColumnCount?: number | null, downloadState: FeatureExtractionExportDownloadState, createdAt: any }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FeatureExtractionExportRunQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeatureExtractionExportRunQuery = { __typename?: 'Query', featureExtractionExportRun?: { __typename?: 'FeatureExtractionExportRun', id: any, troUuid: any, featureSetVersion: string, mode: FeatureExtractionExportMode, testLimit?: number | null, status: FeatureExtractionExportStatus, requestedByEmail?: string | null, totalTestCount: number, excludedTestCount: number, reusedCacheCount: number, queuedExtractionCount: number, completedExtractionCount: number, failedExtractionCount: number, labResultWarningCount: number, startedAt?: any | null, completedAt?: any | null, errorSummary?: string | null, csvSizeBytes?: any | null, csvRowCount?: number | null, csvColumnCount?: number | null, downloadState: FeatureExtractionExportDownloadState, createdAt: any, failedItems?: { __typename?: 'FailedItemsConnection', nodes?: Array<{ __typename?: 'FeatureExtractionExportItem', id: any, testId: any, testName: string, attemptCount: number, error?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type StartFeatureExtractionExportMutationVariables = Exact<{
  input: StartFeatureExtractionExportInput;
}>;


export type StartFeatureExtractionExportMutation = { __typename?: 'Mutation', startFeatureExtractionExport: { __typename?: 'FeatureExtractionExportRun', id: any, troUuid: any, featureSetVersion: string, mode: FeatureExtractionExportMode, testLimit?: number | null, status: FeatureExtractionExportStatus, createdAt: any } };

export type FeatureExtractionExportDownloadUrlMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FeatureExtractionExportDownloadUrlMutation = { __typename?: 'Mutation', featureExtractionExportDownloadUrl?: { __typename?: 'FeatureExtractionExportDownload', url: string, expiresAt: any, fileName: string } | null };

export type FieldsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FieldsQuery = { __typename?: 'Query', fields?: { __typename?: 'FieldsConnection', nodes?: Array<{ __typename?: 'Field', name: string, id: any, farm?: { __typename?: 'Farm', id: any } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FieldsForFarmQueryVariables = Exact<{
  farmId: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FieldsForFarmQuery = { __typename?: 'Query', farm?: { __typename?: 'Farm', id: any, fields?: { __typename?: 'FieldsConnection', nodes?: Array<{ __typename?: 'Field', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type FirmwareVersionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FirmwareVersionsQuery = { __typename?: 'Query', firmwareVersions?: { __typename?: 'FirmwareVersionsConnection', nodes?: Array<{ __typename?: 'FirmwareVersion', id: any, createdAt: any, version: string, fileName: string, byteLength: any, sha256: string, isActive: boolean, installCount: number, uploadedByUser?: { __typename?: 'User', id: any, fullName?: string | null, email?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type FirmwareInstallLogsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FirmwareInstallLogsQuery = { __typename?: 'Query', firmwareInstallLogs?: { __typename?: 'FirmwareInstallLogsConnection', nodes?: Array<{ __typename?: 'FirmwareInstallLog', id: any, createdAt: any, updatedAt: any, status: FirmwareInstallLogStatus, eruName?: string | null, runtimePortName?: string | null, runtimeSerialNumber?: string | null, runtimeProductId?: string | null, dfuSerialNumber?: string | null, dfuProductId?: string | null, fromVersion?: string | null, toVersion: string, completedAt?: any | null, errorMessage?: string | null, technicalLog?: string | null, firmwareVersion?: { __typename?: 'FirmwareVersion', id: any, version: string } | null, eru?: { __typename?: 'ERU', id: any, name?: string | null, bleId?: string | null, bleMac?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UploadFirmwareMutationVariables = Exact<{
  input: UploadFirmwareInput;
}>;


export type UploadFirmwareMutation = { __typename?: 'Mutation', uploadFirmware: { __typename?: 'FirmwareVersion', id: any, version: string, isActive: boolean } };

export type SetActiveFirmwareVersionMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SetActiveFirmwareVersionMutation = { __typename?: 'Mutation', setActiveFirmwareVersion?: { __typename?: 'FirmwareVersion', id: any, version: string, isActive: boolean } | null };

export type LabIndicatorDefinitionQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LabIndicatorDefinitionQuery = { __typename?: 'Query', labIndicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: any, valueType: LabIndicatorValueType, unit: string, name: string, displayName?: string | null, updatedAt: any, createdAt: any, alwaysShow: boolean } | null };

export type LabIndicatorDefinitionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LabIndicatorDefinitionsQuery = { __typename?: 'Query', labIndicatorDefinitions?: { __typename?: 'LabIndicatorDefinitionsConnection', nodes?: Array<{ __typename?: 'LabIndicatorDefinition', id: any, valueType: LabIndicatorValueType, unit: string, name: string, displayName?: string | null, updatedAt: any, createdAt: any, alwaysShow: boolean }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateLabIndicatorDefinitionMutationVariables = Exact<{
  input: CreateLabIndicatorDefinitionInput;
}>;


export type CreateLabIndicatorDefinitionMutation = { __typename?: 'Mutation', createLabIndicatorDefinition: { __typename?: 'LabIndicatorDefinition', id: any, valueType: LabIndicatorValueType, unit: string, name: string, updatedAt: any, createdAt: any, alwaysShow: boolean } };

export type LabResultQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type LabResultQuery = { __typename?: 'Query', labResult?: { __typename?: 'LabResult', id: any, createdAt: any, updatedAt: any, value: string, laboratory?: { __typename?: 'Laboratory', id: any, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: any, name: string } | null, soilSample?: { __typename?: 'SoilSample', id: any } | null } | null };

export type CreateLabResultMutationVariables = Exact<{
  input: CreateLabResultInput;
}>;


export type CreateLabResultMutation = { __typename?: 'Mutation', createLabResult: { __typename?: 'LabResult', id: any, createdAt: any, updatedAt: any, value: string, laboratory?: { __typename?: 'Laboratory', id: any, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: any, name: string } | null, soilSample?: { __typename?: 'SoilSample', id: any } | null } };

export type UpdateLabResultMutationVariables = Exact<{
  input: UpdateLabResultInput;
}>;


export type UpdateLabResultMutation = { __typename?: 'Mutation', updateLabResult?: { __typename?: 'LabResult', id: any, createdAt: any, updatedAt: any, value: string, laboratory?: { __typename?: 'Laboratory', id: any, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: any, name: string } | null, soilSample?: { __typename?: 'SoilSample', id: any } | null } | null };

export type LaboratoriesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LaboratoriesQuery = { __typename?: 'Query', laboratories?: { __typename?: 'LaboratoriesConnection', nodes?: Array<{ __typename?: 'Laboratory', id: any, name: string, updatedAt: any, createdAt: any }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateLaboratoryMutationVariables = Exact<{
  input: CreateLaboratoryInput;
}>;


export type CreateLaboratoryMutation = { __typename?: 'Mutation', createLaboratory: { __typename?: 'Laboratory', id: any, name: string, updatedAt: any, createdAt: any } };

export type LocalisationAdminOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type LocalisationAdminOverviewQuery = { __typename?: 'Query', localisationAdminOverview: { __typename?: 'LocalisationAdminOverview', enabledLocales: Array<string>, enabledLocaleSummaries: Array<{ __typename?: 'LocalisationEnabledLocaleSummary', locale: string, setupStatus?: string | null, setupFailureMessage?: string | null, setupUpdatedAt?: any | null }>, files: Array<{ __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: any, setupStatus?: string | null, setupFailureMessage?: string | null, setupUpdatedAt?: any | null }> } };

export type LocalisationEditorQueryVariables = Exact<{
  name: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type LocalisationEditorQuery = { __typename?: 'Query', localisationEditor: { __typename?: 'LocalisationEditorView', fileName: string, locale: string, rows: Array<{ __typename?: 'LocalisationEditorRow', key: string, baseValue: string, targetValue?: string | null, effectiveValue: string, isFallback: boolean, isApproved: boolean, isTranslating: boolean }> } };

export type CreateLocalisationFileMutationVariables = Exact<{
  input: CreateLocalisationFileInput;
}>;


export type CreateLocalisationFileMutation = { __typename?: 'Mutation', createLocalisationFile: { __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: any } };

export type UpdateLocalisationFileMutationVariables = Exact<{
  input: UpdateLocalisationFileInput;
}>;


export type UpdateLocalisationFileMutation = { __typename?: 'Mutation', updateLocalisationFile: { __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: any } };

export type AddLocalisationTargetLocaleMutationVariables = Exact<{
  input: AddLocalisationTargetLocaleInput;
}>;


export type AddLocalisationTargetLocaleMutation = { __typename?: 'Mutation', addLocalisationTargetLocale: { __typename?: 'LocalisationFileSummary', name: string, baseEntryCount: number, targetLocaleCount: number, targetLocales: Array<string>, translationContext?: string | null, updatedAt: any } };

export type UpdateLocalisationTranslationMutationVariables = Exact<{
  input: UpdateLocalisationTranslationInput;
}>;


export type UpdateLocalisationTranslationMutation = { __typename?: 'Mutation', updateLocalisationTranslation: boolean };

export type QueueLocalisationTranslationMutationVariables = Exact<{
  input: QueueLocalisationTranslationInput;
}>;


export type QueueLocalisationTranslationMutation = { __typename?: 'Mutation', queueLocalisationTranslation: string };

export type SetLocalisationLocaleEnabledMutationVariables = Exact<{
  input: SetLocalisationLocaleEnabledInput;
}>;


export type SetLocalisationLocaleEnabledMutation = { __typename?: 'Mutation', setLocalisationLocaleEnabled: { __typename?: 'SetLocalisationLocaleEnabledResult', locale: string, isEnabled: boolean } };

export type MlModelsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MlModelsQuery = { __typename?: 'Query', mlModels?: { __typename?: 'MlModelsConnection', nodes?: Array<{ __typename?: 'MLModel', id: any, name: string, createdAt: any, trainedIndicators?: { __typename?: 'TrainedIndicatorsConnection', nodes?: Array<{ __typename?: 'TrainedIndicator', id: any, name: string, inferenceModelName?: string | null, maxValue: number, minValue: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type OrganisationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganisationsQuery = { __typename?: 'Query', organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', name: string, id: any, logoUrl?: string | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type PesTestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  resultsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type PesTestQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: any, createdAt: any, utcTestTime: any, runId?: any | null, name: string, displayCropTypeName?: string | null, hasResults: boolean, isReferenceZone: boolean, testType: PesTestType, isFailure: boolean, failureReasons: Array<string>, excludeFromMl: boolean, sampleFileUrl?: string | null, originalModelName: string, troUuid: any, moisture: MoistureLevel, soilTexture: SimpleSoilTexture, season: Season, tro?: { __typename?: 'TRO', id: any, name: string } | null, organisation?: { __typename?: 'Organisation', id: any, name: string } | null, createdBy?: { __typename?: 'User', id: any, fullName?: string | null, email?: string | null, organisationMemberships: Array<{ __typename?: 'Organisation', id: any, name: string }> } | null, cropType?: { __typename?: 'CropType', id: any, name: string } | null, farm?: { __typename?: 'Farm', id: any, name: string } | null, field?: { __typename?: 'Field', id: any, name: string } | null, location?: { __typename?: 'GPSLocation', id: any, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, cassette?: { __typename?: 'Cassette', id: any, serialNumber?: { __typename?: 'SerialNumber', id: any, serialNumber: number, range?: { __typename?: 'SerialRange', id: any, productType?: { __typename?: 'ProductType', id: any, code: string } | null } | null } | null } | null, eru?: { __typename?: 'ERU', id: any, name?: string | null } | null, featureCaches: Array<{ __typename?: 'PESTestFeatureCache', id: any, sampleId: string, featureSetVersion: string, featureCount: number, extractedAt: any, sourceUri: string, payloadSha256?: string | null, createdAt: any, updatedAt: any, warningSummary: { __typename?: 'PESTestFeatureCacheWarningSummary', hasWarnings: boolean, status?: string | null, messages: Array<string> } }>, soilSample?: { __typename?: 'SoilSample', id: any, name: string, location?: { __typename?: 'GPSLocation', id: any, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null } | null, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: any, value: number, createdAt: any, updatedAt: any, indicator?: { __typename?: 'TrainedIndicator', id: any, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: any, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, unit: string, description?: string | null, displayName?: string | null } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type PesTestFeatureCacheFeaturesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  search: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type PesTestFeatureCacheFeaturesQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: any, featureCaches: Array<{ __typename?: 'PESTestFeatureCache', id: any, featureMatches: Array<{ __typename?: 'PESTestFeatureCacheFeature', name: string, value?: number | null, displayValue: string, hasValue: boolean }> }> } | null };

export type UserPesTestQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  resultsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserPesTestQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: any, createdAt: any, name: string, hasResults: boolean, displayCropTypeName?: string | null, isReferenceZone: boolean, moisture: MoistureLevel, soilTexture: SimpleSoilTexture, season: Season, cropType?: { __typename?: 'CropType', id: any, name: string } | null, farm?: { __typename?: 'Farm', id: any, name: string } | null, field?: { __typename?: 'Field', id: any, name: string } | null, location?: { __typename?: 'GPSLocation', id: any, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: any, value: number, createdAt: any, indicator?: { __typename?: 'TrainedIndicator', id: any, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: any, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, unit: string, description?: string | null, displayName?: string | null, displayDecimalPlaces: number } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type PesTestsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PesTestFilterInput>;
  order?: InputMaybe<Array<PesTestSortInput> | PesTestSortInput>;
}>;


export type PesTestsQuery = { __typename?: 'Query', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: any, name: string, sampleFileUrl?: string | null, createdAt: any, utcTestTime: any, testType: PesTestType, isFailure: boolean, excludeFromMl: boolean, organisation?: { __typename?: 'Organisation', id: any, name: string } | null, createdBy?: { __typename?: 'User', id: any, fullName?: string | null, email?: string | null } | null, location?: { __typename?: 'GPSLocation', id: any, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, soilSample?: { __typename?: 'SoilSample', id: any, name: string } | null, farm?: { __typename?: 'Farm', id: any, name: string } | null, field?: { __typename?: 'Field', id: any, name: string } | null, cassette?: { __typename?: 'Cassette', id: any, serialNumber?: { __typename?: 'SerialNumber', id: any, serialNumber: number, range?: { __typename?: 'SerialRange', id: any, productType?: { __typename?: 'ProductType', id: any, code: string } | null } | null } | null } | null, eru?: { __typename?: 'ERU', id: any, name?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type SearchPesTestsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<PesTestFilterInput>;
  order?: InputMaybe<Array<PesTestSortInput> | PesTestSortInput>;
}>;


export type SearchPesTestsQuery = { __typename?: 'Query', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: any, createdAt: any, utcTestTime: any, name: string, testType: PesTestType, isReferenceZone: boolean, location?: { __typename?: 'GPSLocation', id: any, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, farm?: { __typename?: 'Farm', id: any, name: string } | null, field?: { __typename?: 'Field', id: any, name: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UpdateExcludeFromMlMutationVariables = Exact<{
  testId: Scalars['UUID']['input'];
  exclude: Scalars['Boolean']['input'];
}>;


export type UpdateExcludeFromMlMutation = { __typename?: 'Mutation', updateExcludeFromMl?: { __typename?: 'PESTest', id: any, excludeFromMl: boolean } | null };

export type RenamePesTestMutationVariables = Exact<{
  input: UpdatePesTestNameInput;
}>;


export type RenamePesTestMutation = { __typename?: 'Mutation', renamePesTest?: { __typename?: 'PESTest', id: any, name: string } | null };

export type UpdatePesTestLocationMutationVariables = Exact<{
  input: UpdatePesTestLocationInput;
}>;


export type UpdatePesTestLocationMutation = { __typename?: 'Mutation', updatePesTestLocation?: { __typename?: 'PESTest', id: any } | null };

export type UpdatePesTestCharacteristicsMutationVariables = Exact<{
  input: UpdatePesTestCharacteristicsInput;
}>;


export type UpdatePesTestCharacteristicsMutation = { __typename?: 'Mutation', updatePesTestCharacteristics?: { __typename?: 'PESTest', id: any } | null };

export type MarkTestFailedMutationVariables = Exact<{
  input: MarkTestFailedInput;
}>;


export type MarkTestFailedMutation = { __typename?: 'Mutation', markTestFailed?: { __typename?: 'PESTest', id: any, isFailure: boolean, failureReasons: Array<string> } | null };

export type TransferPesTestMutationVariables = Exact<{
  input: TransferPesTestInput;
}>;


export type TransferPesTestMutation = { __typename?: 'Mutation', transferPesTest: { __typename?: 'PESTest', id: any, createdBy?: { __typename?: 'User', id: any, fullName?: string | null, email?: string | null, organisationMemberships: Array<{ __typename?: 'Organisation', id: any, name: string }> } | null, organisation?: { __typename?: 'Organisation', id: any, name: string } | null, farm?: { __typename?: 'Farm', id: any, name: string } | null, field?: { __typename?: 'Field', id: any, name: string } | null } };

export type DeletePesTestMutationVariables = Exact<{
  input: DeletePesTestInput;
}>;


export type DeletePesTestMutation = { __typename?: 'Mutation', deletePESTest: boolean };

export type QueuePesTestPredictionMutationVariables = Exact<{
  input: QueuePesTestPredictionInput;
}>;


export type QueuePesTestPredictionMutation = { __typename?: 'Mutation', queuePesTestPrediction?: { __typename?: 'PESTest', id: any } | null };

export type RecoverPesTestFeatureCacheMutationVariables = Exact<{
  testId: Scalars['UUID']['input'];
}>;


export type RecoverPesTestFeatureCacheMutation = { __typename?: 'Mutation', recoverPesTestFeatureCache?: { __typename?: 'PESTestFeatureCache', id: any } | null };

export type PurgePesTestFeatureCacheMutationVariables = Exact<{
  input: PurgePesTestFeatureCacheInput;
}>;


export type PurgePesTestFeatureCacheMutation = { __typename?: 'Mutation', purgePesTestFeatureCache: { __typename?: 'PESTestFeatureCachePurgeResult', purgedCount: number, testIds: Array<any>, sampleIds: Array<string> } };

export type PurgePesTestFeatureCachesMutationVariables = Exact<{
  input: PurgePesTestFeatureCachesInput;
}>;


export type PurgePesTestFeatureCachesMutation = { __typename?: 'Mutation', purgePesTestFeatureCaches: { __typename?: 'PESTestFeatureCachePurgeResult', purgedCount: number, testIds: Array<any>, sampleIds: Array<string> } };

export type PesTestFeatureCacheOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type PesTestFeatureCacheOverviewQuery = { __typename?: 'Query', pesTestFeatureCacheOverview: { __typename?: 'PESTestFeatureCacheOverview', activeCacheCount: number, activeTestCount: number, activeFeatureCount: any, lastExtractedAt?: any | null } };

export type PesTestResultsQueryVariables = Exact<{
  testId: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PesTestResultsQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: any, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: any, value: number, createdAt: any, indicator?: { __typename?: 'TrainedIndicator', id: any, name: string, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: any, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, displayName?: string | null, description?: string | null, unit: string, displayDecimalPlaces: number } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type AdjacentPesTestQueryVariables = Exact<{
  where?: InputMaybe<PesTestFilterInput>;
  order?: InputMaybe<Array<PesTestSortInput> | PesTestSortInput>;
}>;


export type AdjacentPesTestQuery = { __typename?: 'Query', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: any }> | null } | null };

export type TransferOrganisationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransferOrganisationsQuery = { __typename?: 'Query', organisations?: { __typename?: 'OrganisationsConnection', nodes?: Array<{ __typename?: 'Organisation', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type TransferFarmsQueryVariables = Exact<{
  organisationId: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransferFarmsQuery = { __typename?: 'Query', organisationById?: { __typename?: 'Organisation', farms?: { __typename?: 'FarmsConnection', nodes?: Array<{ __typename?: 'Farm', id: any, name: string, organisation?: { __typename?: 'Organisation', id: any } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type TransferFieldsQueryVariables = Exact<{
  farmId: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransferFieldsQuery = { __typename?: 'Query', farm?: { __typename?: 'Farm', id: any, fields?: { __typename?: 'FieldsConnection', nodes?: Array<{ __typename?: 'Field', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type PesTestIndicatorLimitQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PesTestIndicatorLimitQuery = { __typename?: 'Query', pesTest?: { __typename?: 'PESTest', id: any, allowedIndicatorDefinitions?: Array<{ __typename?: 'LabIndicatorDefinition', id: any, name: string, displayName?: string | null }> | null } | null };

export type ProductTypesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductTypesQuery = { __typename?: 'Query', productTypes?: { __typename?: 'ProductTypesConnection', nodes?: Array<{ __typename?: 'ProductType', id: any, createdAt: any, name: string, code: string, location: string, model: string, subType: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type ReportQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReportQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', nodes?: Array<{ __typename?: 'Report', id: any, name: string, createdBy?: { __typename?: 'User', id: any, fullName?: string | null, email?: string | null } | null }> | null } | null };

export type ReportPesTestsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportPesTestsQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', nodes?: Array<{ __typename?: 'Report', pesTests?: { __typename?: 'PesTestsConnection', nodes?: Array<{ __typename?: 'PESTest', id: any, originalModelName: string, isFailure: boolean, createdAt: any, name: string, allowedIndicatorDefinitions?: Array<{ __typename?: 'LabIndicatorDefinition', id: any, name: string, displayName?: string | null }> | null, location?: { __typename?: 'GPSLocation', id: any, latitude: number, longitude: number, what3Words?: { __typename?: 'What3WordsLocation', words: string } | null } | null, farm?: { __typename?: 'Farm', id: any, name: string } | null, field?: { __typename?: 'Field', id: any, name: string } | null, results?: { __typename?: 'ResultsConnection', nodes?: Array<{ __typename?: 'Result', id: any, createdAt: any, value: number, indicator?: { __typename?: 'TrainedIndicator', id: any, name: string, minValue: number, maxValue: number, model?: { __typename?: 'MLModel', id: any, name: string } | null, indicatorDefinition?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, displayName?: string | null, description?: string | null, unit: string, displayDecimalPlaces: number } | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null }> | null } | null };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: any } };

export type SerialRangesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SerialRangesQuery = { __typename?: 'Query', serialRanges?: { __typename?: 'SerialRangesConnection', nodes?: Array<{ __typename?: 'SerialRange', id: any, createdAt: any, startNumber: number, endNumber: number, nextAvailable: number, buildStartDate: any, buildEndDate?: any | null, buildDescription: string, firmwareVersion?: string | null, notes?: string | null, productType?: { __typename?: 'ProductType', id: any, createdAt: any, name: string, code: string, location: string, model: string, subType: string } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateSerialRangeMutationVariables = Exact<{
  input: CreateSerialRangeInput;
}>;


export type CreateSerialRangeMutation = { __typename?: 'Mutation', createSerialRange: { __typename?: 'SerialRange', id: any } };

export type UpdateSerialRangeMutationVariables = Exact<{
  input: UpdateSerialRangeInput;
}>;


export type UpdateSerialRangeMutation = { __typename?: 'Mutation', updateSerialRange?: { __typename?: 'SerialRange', id: any } | null };

export type SoilSampleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SoilSampleQuery = { __typename?: 'Query', soilSample?: { __typename?: 'SoilSample', id: any, createdAt: any, updatedAt: any, name: string, isReferenceZone: boolean, moisture?: MoistureLevel | null, season?: Season | null, sampleDate?: any | null, strawRemoved: boolean, fym: boolean, coverCrop?: { __typename?: 'CoverCrop', id: any, name: string } | null, cropType?: { __typename?: 'CropType', id: any, name: string } | null, lastYearCrop?: { __typename?: 'Crop', id: any, name: string } | null, yearBeforeLastCrop?: { __typename?: 'Crop', id: any, name: string } | null, soilType?: { __typename?: 'SoilType', id: any, name: string } | null, cultivation?: { __typename?: 'Cultivation', id: any, name: string } | null, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: any, value: string, laboratory?: { __typename?: 'Laboratory', id: any, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null } | null };

export type SoilSamplesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<SoilSampleFilterInput>;
  order?: InputMaybe<Array<SoilSampleSortInput> | SoilSampleSortInput>;
}>;


export type SoilSamplesQuery = { __typename?: 'Query', soilSamples?: { __typename?: 'SoilSamplesConnection', nodes?: Array<{ __typename?: 'SoilSample', id: any, name: string, createdAt: any, updatedAt: any, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: any, value: string, laboratory?: { __typename?: 'Laboratory', id: any, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type UpdateSoilSampleMutationVariables = Exact<{
  input: UpdateSoilSampleInput;
}>;


export type UpdateSoilSampleMutation = { __typename?: 'Mutation', updateSoilSample?: { __typename?: 'SoilSample', id: any, createdAt: any, updatedAt: any, name: string, isReferenceZone: boolean, moisture?: MoistureLevel | null, season?: Season | null, sampleDate?: any | null, strawRemoved: boolean, fym: boolean, coverCrop?: { __typename?: 'CoverCrop', id: any, name: string } | null, cropType?: { __typename?: 'CropType', id: any, name: string } | null, lastYearCrop?: { __typename?: 'Crop', id: any, name: string } | null, yearBeforeLastCrop?: { __typename?: 'Crop', id: any, name: string } | null, soilType?: { __typename?: 'SoilType', id: any, name: string } | null, cultivation?: { __typename?: 'Cultivation', id: any, name: string } | null, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: any, value: string, laboratory?: { __typename?: 'Laboratory', id: any, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null } | null } | null };

export type CreateSoilSampleMutationVariables = Exact<{
  input: CreateSoilSampleInput;
}>;


export type CreateSoilSampleMutation = { __typename?: 'Mutation', createSoilSample: { __typename?: 'SoilSample', id: any, createdAt: any, updatedAt: any, name: string, isReferenceZone: boolean, moisture?: MoistureLevel | null, season?: Season | null, sampleDate?: any | null, strawRemoved: boolean, fym: boolean, coverCrop?: { __typename?: 'CoverCrop', id: any, name: string } | null, cropType?: { __typename?: 'CropType', id: any, name: string } | null, lastYearCrop?: { __typename?: 'Crop', id: any, name: string } | null, yearBeforeLastCrop?: { __typename?: 'Crop', id: any, name: string } | null, soilType?: { __typename?: 'SoilType', id: any, name: string } | null, cultivation?: { __typename?: 'Cultivation', id: any, name: string } | null, labResults?: { __typename?: 'LabResultsConnection', nodes?: Array<{ __typename?: 'LabResult', id: any, value: string, laboratory?: { __typename?: 'Laboratory', id: any, name: string } | null, indicator?: { __typename?: 'LabIndicatorDefinition', id: any, name: string, unit: string, valueType: LabIndicatorValueType } | null }> | null } | null } };

export type SoilTypesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SoilTypesQuery = { __typename?: 'Query', soilTypes?: { __typename?: 'SoilTypesConnection', nodes?: Array<{ __typename?: 'SoilType', id: any, name: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type CreateSoilTypeMutationVariables = Exact<{
  input: CreateSoilTypeInput;
}>;


export type CreateSoilTypeMutation = { __typename?: 'Mutation', createSoilType: { __typename?: 'SoilType', id: any, name: string } };

export type TroManagementOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type TroManagementOverviewQuery = { __typename?: 'Query', troManagementOverview: { __typename?: 'TROManagementOverview', tros: Array<{ __typename?: 'TROSummary', id: any, uuid: any, name: string, showTestAlerts: boolean, totalTestCount: number, lastUsedAt?: any | null }>, unknownTros: Array<{ __typename?: 'UnknownTROSummary', uuid: any, totalTestCount: number, lastUsedAt?: any | null }> } };

export type UpdateTroMutationVariables = Exact<{
  input: UpdateTroInput;
}>;


export type UpdateTroMutation = { __typename?: 'Mutation', updateTRO?: { __typename?: 'TRO', id: any, uuid: any, name: string, showTestAlerts: boolean } | null };

export type CreateTroFromUnknownMutationVariables = Exact<{
  input: CreateTroFromUnknownInput;
}>;


export type CreateTroFromUnknownMutation = { __typename?: 'Mutation', createTROFromUnknown: { __typename?: 'TRO', id: any, uuid: any, name: string, showTestAlerts: boolean } };

export type UpdateTrainedIndicatorMutationVariables = Exact<{
  input: UpdateTrainedIndicatorInput;
}>;


export type UpdateTrainedIndicatorMutation = { __typename?: 'Mutation', updateTrainedIndicator?: { __typename?: 'TrainedIndicator', id: any, minValue: number, maxValue: number, inferenceModelName?: string | null } | null };

export type CopyTrainedIndicatorMutationVariables = Exact<{
  input: CopyTrainedIndicatorInput;
}>;


export type CopyTrainedIndicatorMutation = { __typename?: 'Mutation', copyTrainedIndicator?: { __typename?: 'TrainedIndicator', id: any, name: string, inferenceModelName?: string | null, minValue: number, maxValue: number } | null };

export type DeleteTrainedIndicatorMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteTrainedIndicatorMutation = { __typename?: 'Mutation', deleteTrainedIndicator: boolean };

export type CreateTrainedIndicatorMutationVariables = Exact<{
  input: CreateTrainedIndicatorInput;
}>;


export type CreateTrainedIndicatorMutation = { __typename?: 'Mutation', createTrainedIndicator: { __typename?: 'TrainedIndicator', id: any, name: string, inferenceModelName?: string | null, maxValue: number, minValue: number, model?: { __typename?: 'MLModel', id: any } | null } };

export type GetUsersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<UserFilterInput>;
  order?: InputMaybe<Array<UserSortInput> | UserSortInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes?: Array<{ __typename?: 'User', id: any, email?: string | null, fullName?: string | null, createdAt: any, roles: Array<string>, organisationMemberships: Array<{ __typename?: 'Organisation', id: any, name: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type ImpersonateUserQueryVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type ImpersonateUserQuery = { __typename?: 'Query', impersonateUser: string };

export type AdminSetUserPasswordMutationVariables = Exact<{
  input: AdminSetUserPasswordInput;
}>;


export type AdminSetUserPasswordMutation = { __typename?: 'Mutation', adminSetUserPassword: boolean };

export type AssignableRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignableRolesQuery = { __typename?: 'Query', assignableRoles: Array<string> };

export type SetUserRoleMutationVariables = Exact<{
  input: SetUserRoleInput;
}>;


export type SetUserRoleMutation = { __typename?: 'Mutation', setUserRole?: { __typename?: 'User', id: any, roles: Array<string> } | null };


export const AuditLogsDocument = gql`
    query AuditLogs($after: String, $actionType: String, $occurredFrom: DateTime, $occurredTo: DateTime, $userName: String) {
  auditLogs(
    first: 25
    after: $after
    actionType: $actionType
    occurredFrom: $occurredFrom
    occurredTo: $occurredTo
    userName: $userName
  ) {
    nodes {
      id
      actionType
      targetEntityType
      reason
      notes
      createdAt
      actingUser {
        id
        fullName
        email
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      actionType: // value for 'actionType'
 *      occurredFrom: // value for 'occurredFrom'
 *      occurredTo: // value for 'occurredTo'
 *      userName: // value for 'userName'
 *   },
 * });
 */
export function useAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
      }
export function useAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>;
export type AuditLogsLazyQueryHookResult = ReturnType<typeof useAuditLogsLazyQuery>;
export type AuditLogsSuspenseQueryHookResult = ReturnType<typeof useAuditLogsSuspenseQuery>;
export type AuditLogsQueryResult = Apollo.QueryResult<AuditLogsQuery, AuditLogsQueryVariables>;
export const AuditLogActionTypesDocument = gql`
    query AuditLogActionTypes {
  auditLogActionTypes
}
    `;

/**
 * __useAuditLogActionTypesQuery__
 *
 * To run a query within a React component, call `useAuditLogActionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogActionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogActionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuditLogActionTypesQuery(baseOptions?: Apollo.QueryHookOptions<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>(AuditLogActionTypesDocument, options);
      }
export function useAuditLogActionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>(AuditLogActionTypesDocument, options);
        }
export function useAuditLogActionTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>(AuditLogActionTypesDocument, options);
        }
export type AuditLogActionTypesQueryHookResult = ReturnType<typeof useAuditLogActionTypesQuery>;
export type AuditLogActionTypesLazyQueryHookResult = ReturnType<typeof useAuditLogActionTypesLazyQuery>;
export type AuditLogActionTypesSuspenseQueryHookResult = ReturnType<typeof useAuditLogActionTypesSuspenseQuery>;
export type AuditLogActionTypesQueryResult = Apollo.QueryResult<AuditLogActionTypesQuery, AuditLogActionTypesQueryVariables>;
export const RequestMagicLinkDocument = gql`
    mutation RequestMagicLink($input: RequestMagicLinkInput!) {
  requestMagicLink(input: $input)
}
    `;
export type RequestMagicLinkMutationFn = Apollo.MutationFunction<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>;

/**
 * __useRequestMagicLinkMutation__
 *
 * To run a mutation, you first call `useRequestMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestMagicLinkMutation, { data, loading, error }] = useRequestMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>(RequestMagicLinkDocument, options);
      }
export type RequestMagicLinkMutationHookResult = ReturnType<typeof useRequestMagicLinkMutation>;
export type RequestMagicLinkMutationResult = Apollo.MutationResult<RequestMagicLinkMutation>;
export type RequestMagicLinkMutationOptions = Apollo.BaseMutationOptions<RequestMagicLinkMutation, RequestMagicLinkMutationVariables>;
export const RedeemMagicLinkDocument = gql`
    mutation RedeemMagicLink($input: RedeemMagicLinkInput!) {
  redeemMagicLink(input: $input)
}
    `;
export type RedeemMagicLinkMutationFn = Apollo.MutationFunction<RedeemMagicLinkMutation, RedeemMagicLinkMutationVariables>;

/**
 * __useRedeemMagicLinkMutation__
 *
 * To run a mutation, you first call `useRedeemMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemMagicLinkMutation, { data, loading, error }] = useRedeemMagicLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedeemMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<RedeemMagicLinkMutation, RedeemMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemMagicLinkMutation, RedeemMagicLinkMutationVariables>(RedeemMagicLinkDocument, options);
      }
export type RedeemMagicLinkMutationHookResult = ReturnType<typeof useRedeemMagicLinkMutation>;
export type RedeemMagicLinkMutationResult = Apollo.MutationResult<RedeemMagicLinkMutation>;
export type RedeemMagicLinkMutationOptions = Apollo.BaseMutationOptions<RedeemMagicLinkMutation, RedeemMagicLinkMutationVariables>;
export const LoginWithPasswordDocument = gql`
    mutation LoginWithPassword($input: LoginWithPasswordInput!) {
  loginWithPassword(input: $input)
}
    `;
export type LoginWithPasswordMutationFn = Apollo.MutationFunction<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>;

/**
 * __useLoginWithPasswordMutation__
 *
 * To run a mutation, you first call `useLoginWithPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithPasswordMutation, { data, loading, error }] = useLoginWithPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginWithPasswordMutation(baseOptions?: Apollo.MutationHookOptions<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>(LoginWithPasswordDocument, options);
      }
export type LoginWithPasswordMutationHookResult = ReturnType<typeof useLoginWithPasswordMutation>;
export type LoginWithPasswordMutationResult = Apollo.MutationResult<LoginWithPasswordMutation>;
export type LoginWithPasswordMutationOptions = Apollo.BaseMutationOptions<LoginWithPasswordMutation, LoginWithPasswordMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResetPasswordWithCodeDocument = gql`
    mutation ResetPasswordWithCode($input: ResetPasswordWithCodeInput!) {
  resetPasswordWithCode(input: $input)
}
    `;
export type ResetPasswordWithCodeMutationFn = Apollo.MutationFunction<ResetPasswordWithCodeMutation, ResetPasswordWithCodeMutationVariables>;

/**
 * __useResetPasswordWithCodeMutation__
 *
 * To run a mutation, you first call `useResetPasswordWithCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordWithCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordWithCodeMutation, { data, loading, error }] = useResetPasswordWithCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordWithCodeMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordWithCodeMutation, ResetPasswordWithCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordWithCodeMutation, ResetPasswordWithCodeMutationVariables>(ResetPasswordWithCodeDocument, options);
      }
export type ResetPasswordWithCodeMutationHookResult = ReturnType<typeof useResetPasswordWithCodeMutation>;
export type ResetPasswordWithCodeMutationResult = Apollo.MutationResult<ResetPasswordWithCodeMutation>;
export type ResetPasswordWithCodeMutationOptions = Apollo.BaseMutationOptions<ResetPasswordWithCodeMutation, ResetPasswordWithCodeMutationVariables>;
export const SetOwnPasswordDocument = gql`
    mutation SetOwnPassword($input: SetOwnPasswordInput!) {
  setOwnPassword(input: $input)
}
    `;
export type SetOwnPasswordMutationFn = Apollo.MutationFunction<SetOwnPasswordMutation, SetOwnPasswordMutationVariables>;

/**
 * __useSetOwnPasswordMutation__
 *
 * To run a mutation, you first call `useSetOwnPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOwnPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOwnPasswordMutation, { data, loading, error }] = useSetOwnPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOwnPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetOwnPasswordMutation, SetOwnPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOwnPasswordMutation, SetOwnPasswordMutationVariables>(SetOwnPasswordDocument, options);
      }
export type SetOwnPasswordMutationHookResult = ReturnType<typeof useSetOwnPasswordMutation>;
export type SetOwnPasswordMutationResult = Apollo.MutationResult<SetOwnPasswordMutation>;
export type SetOwnPasswordMutationOptions = Apollo.BaseMutationOptions<SetOwnPasswordMutation, SetOwnPasswordMutationVariables>;
export const ChangeOwnPasswordDocument = gql`
    mutation ChangeOwnPassword($input: ChangeOwnPasswordInput!) {
  changeOwnPassword(input: $input)
}
    `;
export type ChangeOwnPasswordMutationFn = Apollo.MutationFunction<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>;

/**
 * __useChangeOwnPasswordMutation__
 *
 * To run a mutation, you first call `useChangeOwnPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOwnPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOwnPasswordMutation, { data, loading, error }] = useChangeOwnPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeOwnPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>(ChangeOwnPasswordDocument, options);
      }
export type ChangeOwnPasswordMutationHookResult = ReturnType<typeof useChangeOwnPasswordMutation>;
export type ChangeOwnPasswordMutationResult = Apollo.MutationResult<ChangeOwnPasswordMutation>;
export type ChangeOwnPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeOwnPasswordMutation, ChangeOwnPasswordMutationVariables>;
export const PasswordAuthStatusDocument = gql`
    query PasswordAuthStatus {
  passwordAuthStatus {
    hasPassword
  }
}
    `;

/**
 * __usePasswordAuthStatusQuery__
 *
 * To run a query within a React component, call `usePasswordAuthStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasswordAuthStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasswordAuthStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function usePasswordAuthStatusQuery(baseOptions?: Apollo.QueryHookOptions<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>(PasswordAuthStatusDocument, options);
      }
export function usePasswordAuthStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>(PasswordAuthStatusDocument, options);
        }
export function usePasswordAuthStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>(PasswordAuthStatusDocument, options);
        }
export type PasswordAuthStatusQueryHookResult = ReturnType<typeof usePasswordAuthStatusQuery>;
export type PasswordAuthStatusLazyQueryHookResult = ReturnType<typeof usePasswordAuthStatusLazyQuery>;
export type PasswordAuthStatusSuspenseQueryHookResult = ReturnType<typeof usePasswordAuthStatusSuspenseQuery>;
export type PasswordAuthStatusQueryResult = Apollo.QueryResult<PasswordAuthStatusQuery, PasswordAuthStatusQueryVariables>;
export const MeDocument = gql`
    query Me($after: String) {
  me {
    id
    createdAt
    email
    fullName
    profilePictureUrl
    organisations(first: 25, after: $after) {
      nodes {
        id
        name
        logoUrl
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const BackgroundJobStatusDocument = gql`
    query BackgroundJobStatus {
  backgroundJobStatus {
    processingCount
    queuedCount
    scheduledCount
    processingJobs {
      jobId
      displayName
      methodType
      queue
      startedAt
      elapsedSeconds
      averageDurationSeconds
      etaSeconds
    }
    queuedByType {
      displayName
      methodType
      queue
      count
      nextScheduledAt
      averageDurationSeconds
      estimatedTotalDurationSeconds
    }
    predictionBacklog {
      queuedPredictionCount
      runningPredictionCount
      effectiveWorkerSlots
      averagePredictionDurationSeconds
      estimatedWaitSeconds
    }
  }
}
    `;

/**
 * __useBackgroundJobStatusQuery__
 *
 * To run a query within a React component, call `useBackgroundJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundJobStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackgroundJobStatusQuery(baseOptions?: Apollo.QueryHookOptions<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>(BackgroundJobStatusDocument, options);
      }
export function useBackgroundJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>(BackgroundJobStatusDocument, options);
        }
export function useBackgroundJobStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>(BackgroundJobStatusDocument, options);
        }
export type BackgroundJobStatusQueryHookResult = ReturnType<typeof useBackgroundJobStatusQuery>;
export type BackgroundJobStatusLazyQueryHookResult = ReturnType<typeof useBackgroundJobStatusLazyQuery>;
export type BackgroundJobStatusSuspenseQueryHookResult = ReturnType<typeof useBackgroundJobStatusSuspenseQuery>;
export type BackgroundJobStatusQueryResult = Apollo.QueryResult<BackgroundJobStatusQuery, BackgroundJobStatusQueryVariables>;
export const QueueBackgroundJobDelayTestDocument = gql`
    mutation QueueBackgroundJobDelayTest {
  queueBackgroundJobDelayTest
}
    `;
export type QueueBackgroundJobDelayTestMutationFn = Apollo.MutationFunction<QueueBackgroundJobDelayTestMutation, QueueBackgroundJobDelayTestMutationVariables>;

/**
 * __useQueueBackgroundJobDelayTestMutation__
 *
 * To run a mutation, you first call `useQueueBackgroundJobDelayTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueBackgroundJobDelayTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueBackgroundJobDelayTestMutation, { data, loading, error }] = useQueueBackgroundJobDelayTestMutation({
 *   variables: {
 *   },
 * });
 */
export function useQueueBackgroundJobDelayTestMutation(baseOptions?: Apollo.MutationHookOptions<QueueBackgroundJobDelayTestMutation, QueueBackgroundJobDelayTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueueBackgroundJobDelayTestMutation, QueueBackgroundJobDelayTestMutationVariables>(QueueBackgroundJobDelayTestDocument, options);
      }
export type QueueBackgroundJobDelayTestMutationHookResult = ReturnType<typeof useQueueBackgroundJobDelayTestMutation>;
export type QueueBackgroundJobDelayTestMutationResult = Apollo.MutationResult<QueueBackgroundJobDelayTestMutation>;
export type QueueBackgroundJobDelayTestMutationOptions = Apollo.BaseMutationOptions<QueueBackgroundJobDelayTestMutation, QueueBackgroundJobDelayTestMutationVariables>;
export const QueueBackgroundJobPredictionDelayTestDocument = gql`
    mutation QueueBackgroundJobPredictionDelayTest {
  queueBackgroundJobPredictionDelayTest
}
    `;
export type QueueBackgroundJobPredictionDelayTestMutationFn = Apollo.MutationFunction<QueueBackgroundJobPredictionDelayTestMutation, QueueBackgroundJobPredictionDelayTestMutationVariables>;

/**
 * __useQueueBackgroundJobPredictionDelayTestMutation__
 *
 * To run a mutation, you first call `useQueueBackgroundJobPredictionDelayTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueBackgroundJobPredictionDelayTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueBackgroundJobPredictionDelayTestMutation, { data, loading, error }] = useQueueBackgroundJobPredictionDelayTestMutation({
 *   variables: {
 *   },
 * });
 */
export function useQueueBackgroundJobPredictionDelayTestMutation(baseOptions?: Apollo.MutationHookOptions<QueueBackgroundJobPredictionDelayTestMutation, QueueBackgroundJobPredictionDelayTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueueBackgroundJobPredictionDelayTestMutation, QueueBackgroundJobPredictionDelayTestMutationVariables>(QueueBackgroundJobPredictionDelayTestDocument, options);
      }
export type QueueBackgroundJobPredictionDelayTestMutationHookResult = ReturnType<typeof useQueueBackgroundJobPredictionDelayTestMutation>;
export type QueueBackgroundJobPredictionDelayTestMutationResult = Apollo.MutationResult<QueueBackgroundJobPredictionDelayTestMutation>;
export type QueueBackgroundJobPredictionDelayTestMutationOptions = Apollo.BaseMutationOptions<QueueBackgroundJobPredictionDelayTestMutation, QueueBackgroundJobPredictionDelayTestMutationVariables>;
export const BatchesDocument = gql`
    query Batches($after: String) {
  batches(first: 25, after: $after) {
    nodes {
      id
      createdAt
      name
      batchNumber
      description
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useBatchesQuery__
 *
 * To run a query within a React component, call `useBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBatchesQuery(baseOptions?: Apollo.QueryHookOptions<BatchesQuery, BatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BatchesQuery, BatchesQueryVariables>(BatchesDocument, options);
      }
export function useBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BatchesQuery, BatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BatchesQuery, BatchesQueryVariables>(BatchesDocument, options);
        }
export function useBatchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BatchesQuery, BatchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BatchesQuery, BatchesQueryVariables>(BatchesDocument, options);
        }
export type BatchesQueryHookResult = ReturnType<typeof useBatchesQuery>;
export type BatchesLazyQueryHookResult = ReturnType<typeof useBatchesLazyQuery>;
export type BatchesSuspenseQueryHookResult = ReturnType<typeof useBatchesSuspenseQuery>;
export type BatchesQueryResult = Apollo.QueryResult<BatchesQuery, BatchesQueryVariables>;
export const CreateBatchDocument = gql`
    mutation CreateBatch($input: CreateBatchInput!) {
  createBatch(input: $input) {
    id
    createdAt
    name
    batchNumber
    description
  }
}
    `;
export type CreateBatchMutationFn = Apollo.MutationFunction<CreateBatchMutation, CreateBatchMutationVariables>;

/**
 * __useCreateBatchMutation__
 *
 * To run a mutation, you first call `useCreateBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBatchMutation, { data, loading, error }] = useCreateBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBatchMutation(baseOptions?: Apollo.MutationHookOptions<CreateBatchMutation, CreateBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBatchMutation, CreateBatchMutationVariables>(CreateBatchDocument, options);
      }
export type CreateBatchMutationHookResult = ReturnType<typeof useCreateBatchMutation>;
export type CreateBatchMutationResult = Apollo.MutationResult<CreateBatchMutation>;
export type CreateBatchMutationOptions = Apollo.BaseMutationOptions<CreateBatchMutation, CreateBatchMutationVariables>;
export const UpdateBatchDocument = gql`
    mutation UpdateBatch($input: UpdateBatchInput!) {
  updateBatch(input: $input) {
    id
    createdAt
    name
    batchNumber
    description
  }
}
    `;
export type UpdateBatchMutationFn = Apollo.MutationFunction<UpdateBatchMutation, UpdateBatchMutationVariables>;

/**
 * __useUpdateBatchMutation__
 *
 * To run a mutation, you first call `useUpdateBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBatchMutation, { data, loading, error }] = useUpdateBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBatchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBatchMutation, UpdateBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBatchMutation, UpdateBatchMutationVariables>(UpdateBatchDocument, options);
      }
export type UpdateBatchMutationHookResult = ReturnType<typeof useUpdateBatchMutation>;
export type UpdateBatchMutationResult = Apollo.MutationResult<UpdateBatchMutation>;
export type UpdateBatchMutationOptions = Apollo.BaseMutationOptions<UpdateBatchMutation, UpdateBatchMutationVariables>;
export const CassettesDocument = gql`
    query Cassettes($after: String) {
  cassetteListSummary {
    provisionedCount
    allocatedCustomerTests
    remainingCustomerTests
    openOverflowWarningCount
  }
  cassettes(first: 25, after: $after) {
    nodes {
      id
      numSensors
      manufactureDate
      expiryDate
      goodSensorCount
      badSensorCount
      allocatedCustomerTests
      usedCustomerTests
      remainingCustomerTests
      physicalSensorsUsed
      remainingPhysicalSensors
      openOverflowRequestedTests
      hasOpenOverflowWarning
      lastUsedBy {
        fullName
        email
        usedAt
      }
      serialNumber {
        serialNumber
        range {
          productType {
            code
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useCassettesQuery__
 *
 * To run a query within a React component, call `useCassettesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCassettesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCassettesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCassettesQuery(baseOptions?: Apollo.QueryHookOptions<CassettesQuery, CassettesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CassettesQuery, CassettesQueryVariables>(CassettesDocument, options);
      }
export function useCassettesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CassettesQuery, CassettesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CassettesQuery, CassettesQueryVariables>(CassettesDocument, options);
        }
export function useCassettesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CassettesQuery, CassettesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CassettesQuery, CassettesQueryVariables>(CassettesDocument, options);
        }
export type CassettesQueryHookResult = ReturnType<typeof useCassettesQuery>;
export type CassettesLazyQueryHookResult = ReturnType<typeof useCassettesLazyQuery>;
export type CassettesSuspenseQueryHookResult = ReturnType<typeof useCassettesSuspenseQuery>;
export type CassettesQueryResult = Apollo.QueryResult<CassettesQuery, CassettesQueryVariables>;
export const CassetteDetailDocument = gql`
    query CassetteDetail($id: UUID!, $afterEntitlementAdjustments: String, $firstEntitlementAdjustments: Int!, $afterOverflowRequests: String, $firstOverflowRequests: Int!) {
  cassette(id: $id) {
    id
    createdAt
    updatedAt
    numSensors
    manufactureDate
    expiryDate
    maxIndexTimeSeconds
    sensorCheckUuid
    soilTestUuid
    goodSensorCount
    badSensorCount
    baseCustomerTests
    manualCustomerTestAdjustments
    allocatedCustomerTests
    usedCustomerTests
    remainingCustomerTests
    physicalSensorsUsed
    remainingPhysicalSensors
    currentCassetteExtraAllocatableTests
    openOverflowRequestedTests
    hasOpenOverflowWarning
    serialNumber {
      serialNumber
      range {
        productType {
          code
        }
      }
    }
    entitlementAdjustments(
      first: $firstEntitlementAdjustments
      after: $afterEntitlementAdjustments
    ) {
      nodes {
        id
        customerTestDelta
        reasonCode
        notes
        createdAt
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    overflowRequests(first: $firstOverflowRequests, after: $afterOverflowRequests) {
      nodes {
        id
        requestedTests
        outstandingTests
        reasonCode
        notes
        status
        resolvedAt
        createdAt
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useCassetteDetailQuery__
 *
 * To run a query within a React component, call `useCassetteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCassetteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCassetteDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      afterEntitlementAdjustments: // value for 'afterEntitlementAdjustments'
 *      firstEntitlementAdjustments: // value for 'firstEntitlementAdjustments'
 *      afterOverflowRequests: // value for 'afterOverflowRequests'
 *      firstOverflowRequests: // value for 'firstOverflowRequests'
 *   },
 * });
 */
export function useCassetteDetailQuery(baseOptions: Apollo.QueryHookOptions<CassetteDetailQuery, CassetteDetailQueryVariables> & ({ variables: CassetteDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CassetteDetailQuery, CassetteDetailQueryVariables>(CassetteDetailDocument, options);
      }
export function useCassetteDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CassetteDetailQuery, CassetteDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CassetteDetailQuery, CassetteDetailQueryVariables>(CassetteDetailDocument, options);
        }
export function useCassetteDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CassetteDetailQuery, CassetteDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CassetteDetailQuery, CassetteDetailQueryVariables>(CassetteDetailDocument, options);
        }
export type CassetteDetailQueryHookResult = ReturnType<typeof useCassetteDetailQuery>;
export type CassetteDetailLazyQueryHookResult = ReturnType<typeof useCassetteDetailLazyQuery>;
export type CassetteDetailSuspenseQueryHookResult = ReturnType<typeof useCassetteDetailSuspenseQuery>;
export type CassetteDetailQueryResult = Apollo.QueryResult<CassetteDetailQuery, CassetteDetailQueryVariables>;
export const OpenCassetteOverflowRequestsDocument = gql`
    query OpenCassetteOverflowRequests($excludingCassetteId: UUID, $after: String) {
  openCassetteOverflowRequests(
    excludingCassetteId: $excludingCassetteId
    first: 25
    after: $after
  ) {
    nodes {
      id
      requestedTests
      outstandingTests
      reasonCode
      notes
      status
      resolvedAt
      createdAt
      cassette {
        id
        serialNumber {
          serialNumber
          range {
            productType {
              code
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useOpenCassetteOverflowRequestsQuery__
 *
 * To run a query within a React component, call `useOpenCassetteOverflowRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenCassetteOverflowRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenCassetteOverflowRequestsQuery({
 *   variables: {
 *      excludingCassetteId: // value for 'excludingCassetteId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useOpenCassetteOverflowRequestsQuery(baseOptions?: Apollo.QueryHookOptions<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>(OpenCassetteOverflowRequestsDocument, options);
      }
export function useOpenCassetteOverflowRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>(OpenCassetteOverflowRequestsDocument, options);
        }
export function useOpenCassetteOverflowRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>(OpenCassetteOverflowRequestsDocument, options);
        }
export type OpenCassetteOverflowRequestsQueryHookResult = ReturnType<typeof useOpenCassetteOverflowRequestsQuery>;
export type OpenCassetteOverflowRequestsLazyQueryHookResult = ReturnType<typeof useOpenCassetteOverflowRequestsLazyQuery>;
export type OpenCassetteOverflowRequestsSuspenseQueryHookResult = ReturnType<typeof useOpenCassetteOverflowRequestsSuspenseQuery>;
export type OpenCassetteOverflowRequestsQueryResult = Apollo.QueryResult<OpenCassetteOverflowRequestsQuery, OpenCassetteOverflowRequestsQueryVariables>;
export const AddCassetteEntitlementAdjustmentDocument = gql`
    mutation AddCassetteEntitlementAdjustment($input: AddCassetteEntitlementAdjustmentInput!) {
  addCassetteEntitlementAdjustment(input: $input) {
    id
    customerTestDelta
    reasonCode
    notes
    createdAt
  }
}
    `;
export type AddCassetteEntitlementAdjustmentMutationFn = Apollo.MutationFunction<AddCassetteEntitlementAdjustmentMutation, AddCassetteEntitlementAdjustmentMutationVariables>;

/**
 * __useAddCassetteEntitlementAdjustmentMutation__
 *
 * To run a mutation, you first call `useAddCassetteEntitlementAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCassetteEntitlementAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCassetteEntitlementAdjustmentMutation, { data, loading, error }] = useAddCassetteEntitlementAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCassetteEntitlementAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<AddCassetteEntitlementAdjustmentMutation, AddCassetteEntitlementAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCassetteEntitlementAdjustmentMutation, AddCassetteEntitlementAdjustmentMutationVariables>(AddCassetteEntitlementAdjustmentDocument, options);
      }
export type AddCassetteEntitlementAdjustmentMutationHookResult = ReturnType<typeof useAddCassetteEntitlementAdjustmentMutation>;
export type AddCassetteEntitlementAdjustmentMutationResult = Apollo.MutationResult<AddCassetteEntitlementAdjustmentMutation>;
export type AddCassetteEntitlementAdjustmentMutationOptions = Apollo.BaseMutationOptions<AddCassetteEntitlementAdjustmentMutation, AddCassetteEntitlementAdjustmentMutationVariables>;
export const CreateCassetteOverflowRequestDocument = gql`
    mutation CreateCassetteOverflowRequest($input: CreateCassetteOverflowRequestInput!) {
  createCassetteOverflowRequest(input: $input) {
    id
    requestedTests
    outstandingTests
    reasonCode
    notes
    status
    createdAt
  }
}
    `;
export type CreateCassetteOverflowRequestMutationFn = Apollo.MutationFunction<CreateCassetteOverflowRequestMutation, CreateCassetteOverflowRequestMutationVariables>;

/**
 * __useCreateCassetteOverflowRequestMutation__
 *
 * To run a mutation, you first call `useCreateCassetteOverflowRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCassetteOverflowRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCassetteOverflowRequestMutation, { data, loading, error }] = useCreateCassetteOverflowRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCassetteOverflowRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateCassetteOverflowRequestMutation, CreateCassetteOverflowRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCassetteOverflowRequestMutation, CreateCassetteOverflowRequestMutationVariables>(CreateCassetteOverflowRequestDocument, options);
      }
export type CreateCassetteOverflowRequestMutationHookResult = ReturnType<typeof useCreateCassetteOverflowRequestMutation>;
export type CreateCassetteOverflowRequestMutationResult = Apollo.MutationResult<CreateCassetteOverflowRequestMutation>;
export type CreateCassetteOverflowRequestMutationOptions = Apollo.BaseMutationOptions<CreateCassetteOverflowRequestMutation, CreateCassetteOverflowRequestMutationVariables>;
export const FulfilCassetteOverflowRequestDocument = gql`
    mutation FulfilCassetteOverflowRequest($input: FulfilCassetteOverflowRequestInput!) {
  fulfilCassetteOverflowRequest(input: $input) {
    id
    requestedTests
    outstandingTests
    reasonCode
    notes
    status
    resolvedAt
    createdAt
  }
}
    `;
export type FulfilCassetteOverflowRequestMutationFn = Apollo.MutationFunction<FulfilCassetteOverflowRequestMutation, FulfilCassetteOverflowRequestMutationVariables>;

/**
 * __useFulfilCassetteOverflowRequestMutation__
 *
 * To run a mutation, you first call `useFulfilCassetteOverflowRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfilCassetteOverflowRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfilCassetteOverflowRequestMutation, { data, loading, error }] = useFulfilCassetteOverflowRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFulfilCassetteOverflowRequestMutation(baseOptions?: Apollo.MutationHookOptions<FulfilCassetteOverflowRequestMutation, FulfilCassetteOverflowRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FulfilCassetteOverflowRequestMutation, FulfilCassetteOverflowRequestMutationVariables>(FulfilCassetteOverflowRequestDocument, options);
      }
export type FulfilCassetteOverflowRequestMutationHookResult = ReturnType<typeof useFulfilCassetteOverflowRequestMutation>;
export type FulfilCassetteOverflowRequestMutationResult = Apollo.MutationResult<FulfilCassetteOverflowRequestMutation>;
export type FulfilCassetteOverflowRequestMutationOptions = Apollo.BaseMutationOptions<FulfilCassetteOverflowRequestMutation, FulfilCassetteOverflowRequestMutationVariables>;
export const CoverCropsDocument = gql`
    query CoverCrops($after: String) {
  coverCrops(first: 25, after: $after) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useCoverCropsQuery__
 *
 * To run a query within a React component, call `useCoverCropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverCropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverCropsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCoverCropsQuery(baseOptions?: Apollo.QueryHookOptions<CoverCropsQuery, CoverCropsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoverCropsQuery, CoverCropsQueryVariables>(CoverCropsDocument, options);
      }
export function useCoverCropsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoverCropsQuery, CoverCropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoverCropsQuery, CoverCropsQueryVariables>(CoverCropsDocument, options);
        }
export function useCoverCropsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CoverCropsQuery, CoverCropsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CoverCropsQuery, CoverCropsQueryVariables>(CoverCropsDocument, options);
        }
export type CoverCropsQueryHookResult = ReturnType<typeof useCoverCropsQuery>;
export type CoverCropsLazyQueryHookResult = ReturnType<typeof useCoverCropsLazyQuery>;
export type CoverCropsSuspenseQueryHookResult = ReturnType<typeof useCoverCropsSuspenseQuery>;
export type CoverCropsQueryResult = Apollo.QueryResult<CoverCropsQuery, CoverCropsQueryVariables>;
export const CreateCoverCropDocument = gql`
    mutation CreateCoverCrop($input: CreateCoverCropInput!) {
  createCoverCrop(input: $input) {
    id
    name
  }
}
    `;
export type CreateCoverCropMutationFn = Apollo.MutationFunction<CreateCoverCropMutation, CreateCoverCropMutationVariables>;

/**
 * __useCreateCoverCropMutation__
 *
 * To run a mutation, you first call `useCreateCoverCropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoverCropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoverCropMutation, { data, loading, error }] = useCreateCoverCropMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCoverCropMutation(baseOptions?: Apollo.MutationHookOptions<CreateCoverCropMutation, CreateCoverCropMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCoverCropMutation, CreateCoverCropMutationVariables>(CreateCoverCropDocument, options);
      }
export type CreateCoverCropMutationHookResult = ReturnType<typeof useCreateCoverCropMutation>;
export type CreateCoverCropMutationResult = Apollo.MutationResult<CreateCoverCropMutation>;
export type CreateCoverCropMutationOptions = Apollo.BaseMutationOptions<CreateCoverCropMutation, CreateCoverCropMutationVariables>;
export const CropsDocument = gql`
    query Crops($after: String) {
  crops(first: 25, after: $after) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useCropsQuery__
 *
 * To run a query within a React component, call `useCropsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCropsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCropsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCropsQuery(baseOptions?: Apollo.QueryHookOptions<CropsQuery, CropsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CropsQuery, CropsQueryVariables>(CropsDocument, options);
      }
export function useCropsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CropsQuery, CropsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CropsQuery, CropsQueryVariables>(CropsDocument, options);
        }
export function useCropsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CropsQuery, CropsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CropsQuery, CropsQueryVariables>(CropsDocument, options);
        }
export type CropsQueryHookResult = ReturnType<typeof useCropsQuery>;
export type CropsLazyQueryHookResult = ReturnType<typeof useCropsLazyQuery>;
export type CropsSuspenseQueryHookResult = ReturnType<typeof useCropsSuspenseQuery>;
export type CropsQueryResult = Apollo.QueryResult<CropsQuery, CropsQueryVariables>;
export const CreateCropDocument = gql`
    mutation CreateCrop($input: CreateCropInput!) {
  createCrop(input: $input) {
    id
    name
  }
}
    `;
export type CreateCropMutationFn = Apollo.MutationFunction<CreateCropMutation, CreateCropMutationVariables>;

/**
 * __useCreateCropMutation__
 *
 * To run a mutation, you first call `useCreateCropMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCropMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCropMutation, { data, loading, error }] = useCreateCropMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCropMutation(baseOptions?: Apollo.MutationHookOptions<CreateCropMutation, CreateCropMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCropMutation, CreateCropMutationVariables>(CreateCropDocument, options);
      }
export type CreateCropMutationHookResult = ReturnType<typeof useCreateCropMutation>;
export type CreateCropMutationResult = Apollo.MutationResult<CreateCropMutation>;
export type CreateCropMutationOptions = Apollo.BaseMutationOptions<CreateCropMutation, CreateCropMutationVariables>;
export const CropTypesDocument = gql`
    query CropTypes($after: String) {
  cropTypes(first: 25, after: $after) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useCropTypesQuery__
 *
 * To run a query within a React component, call `useCropTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCropTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCropTypesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCropTypesQuery(baseOptions?: Apollo.QueryHookOptions<CropTypesQuery, CropTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CropTypesQuery, CropTypesQueryVariables>(CropTypesDocument, options);
      }
export function useCropTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CropTypesQuery, CropTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CropTypesQuery, CropTypesQueryVariables>(CropTypesDocument, options);
        }
export function useCropTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CropTypesQuery, CropTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CropTypesQuery, CropTypesQueryVariables>(CropTypesDocument, options);
        }
export type CropTypesQueryHookResult = ReturnType<typeof useCropTypesQuery>;
export type CropTypesLazyQueryHookResult = ReturnType<typeof useCropTypesLazyQuery>;
export type CropTypesSuspenseQueryHookResult = ReturnType<typeof useCropTypesSuspenseQuery>;
export type CropTypesQueryResult = Apollo.QueryResult<CropTypesQuery, CropTypesQueryVariables>;
export const CreateCropTypeDocument = gql`
    mutation CreateCropType($input: CreateCropTypeInput!) {
  createCropType(input: $input) {
    id
    name
  }
}
    `;
export type CreateCropTypeMutationFn = Apollo.MutationFunction<CreateCropTypeMutation, CreateCropTypeMutationVariables>;

/**
 * __useCreateCropTypeMutation__
 *
 * To run a mutation, you first call `useCreateCropTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCropTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCropTypeMutation, { data, loading, error }] = useCreateCropTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCropTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCropTypeMutation, CreateCropTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCropTypeMutation, CreateCropTypeMutationVariables>(CreateCropTypeDocument, options);
      }
export type CreateCropTypeMutationHookResult = ReturnType<typeof useCreateCropTypeMutation>;
export type CreateCropTypeMutationResult = Apollo.MutationResult<CreateCropTypeMutation>;
export type CreateCropTypeMutationOptions = Apollo.BaseMutationOptions<CreateCropTypeMutation, CreateCropTypeMutationVariables>;
export const CultivationsDocument = gql`
    query Cultivations($after: String) {
  cultivations(first: 25, after: $after) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useCultivationsQuery__
 *
 * To run a query within a React component, call `useCultivationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCultivationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCultivationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCultivationsQuery(baseOptions?: Apollo.QueryHookOptions<CultivationsQuery, CultivationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CultivationsQuery, CultivationsQueryVariables>(CultivationsDocument, options);
      }
export function useCultivationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CultivationsQuery, CultivationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CultivationsQuery, CultivationsQueryVariables>(CultivationsDocument, options);
        }
export function useCultivationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CultivationsQuery, CultivationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CultivationsQuery, CultivationsQueryVariables>(CultivationsDocument, options);
        }
export type CultivationsQueryHookResult = ReturnType<typeof useCultivationsQuery>;
export type CultivationsLazyQueryHookResult = ReturnType<typeof useCultivationsLazyQuery>;
export type CultivationsSuspenseQueryHookResult = ReturnType<typeof useCultivationsSuspenseQuery>;
export type CultivationsQueryResult = Apollo.QueryResult<CultivationsQuery, CultivationsQueryVariables>;
export const CreateCultivationDocument = gql`
    mutation CreateCultivation($input: CreateCultivationInput!) {
  createCultivation(input: $input) {
    id
    name
  }
}
    `;
export type CreateCultivationMutationFn = Apollo.MutationFunction<CreateCultivationMutation, CreateCultivationMutationVariables>;

/**
 * __useCreateCultivationMutation__
 *
 * To run a mutation, you first call `useCreateCultivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCultivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCultivationMutation, { data, loading, error }] = useCreateCultivationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCultivationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCultivationMutation, CreateCultivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCultivationMutation, CreateCultivationMutationVariables>(CreateCultivationDocument, options);
      }
export type CreateCultivationMutationHookResult = ReturnType<typeof useCreateCultivationMutation>;
export type CreateCultivationMutationResult = Apollo.MutationResult<CreateCultivationMutation>;
export type CreateCultivationMutationOptions = Apollo.BaseMutationOptions<CreateCultivationMutation, CreateCultivationMutationVariables>;
export const CustomersDocument = gql`
    query Customers($after: String) {
  customers(first: 10, after: $after) {
    nodes {
      id
      name
      description
      contactName
      contactEmail
      contactPhone
      customerSince
      notes
      createdAt
      updatedAt
      limitIndicators
      allowedIndicatorDefinitions {
        id
        name
        displayName
      }
      organisations(first: 10) {
        nodes {
          id
          name
          logoUrl
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      erus(first: 10) {
        nodes {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
      cassettes(first: 10) {
        nodes {
          id
          remainingCustomerTests
          remainingPhysicalSensors
          hasOpenOverflowWarning
          serialNumber {
            serialNumber
            range {
              productType {
                code
              }
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCustomersQuery(baseOptions?: Apollo.QueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
      }
export function useCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export function useCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>;
export type CustomersSuspenseQueryHookResult = ReturnType<typeof useCustomersSuspenseQuery>;
export type CustomersQueryResult = Apollo.QueryResult<CustomersQuery, CustomersQueryVariables>;
export const GetCustomerOrganisationsDocument = gql`
    query GetCustomerOrganisations($id: UUID!, $after: String) {
  customer(id: $id) {
    id
    organisations(first: 25, after: $after) {
      nodes {
        id
        name
        logoUrl
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetCustomerOrganisationsQuery__
 *
 * To run a query within a React component, call `useGetCustomerOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerOrganisationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCustomerOrganisationsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables> & ({ variables: GetCustomerOrganisationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables>(GetCustomerOrganisationsDocument, options);
      }
export function useGetCustomerOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables>(GetCustomerOrganisationsDocument, options);
        }
export function useGetCustomerOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables>(GetCustomerOrganisationsDocument, options);
        }
export type GetCustomerOrganisationsQueryHookResult = ReturnType<typeof useGetCustomerOrganisationsQuery>;
export type GetCustomerOrganisationsLazyQueryHookResult = ReturnType<typeof useGetCustomerOrganisationsLazyQuery>;
export type GetCustomerOrganisationsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerOrganisationsSuspenseQuery>;
export type GetCustomerOrganisationsQueryResult = Apollo.QueryResult<GetCustomerOrganisationsQuery, GetCustomerOrganisationsQueryVariables>;
export const GetCustomerErusDocument = gql`
    query GetCustomerErus($id: UUID!, $after: String) {
  customer(id: $id) {
    id
    erus(first: 25, after: $after) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetCustomerErusQuery__
 *
 * To run a query within a React component, call `useGetCustomerErusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerErusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerErusQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCustomerErusQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerErusQuery, GetCustomerErusQueryVariables> & ({ variables: GetCustomerErusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerErusQuery, GetCustomerErusQueryVariables>(GetCustomerErusDocument, options);
      }
export function useGetCustomerErusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerErusQuery, GetCustomerErusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerErusQuery, GetCustomerErusQueryVariables>(GetCustomerErusDocument, options);
        }
export function useGetCustomerErusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerErusQuery, GetCustomerErusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerErusQuery, GetCustomerErusQueryVariables>(GetCustomerErusDocument, options);
        }
export type GetCustomerErusQueryHookResult = ReturnType<typeof useGetCustomerErusQuery>;
export type GetCustomerErusLazyQueryHookResult = ReturnType<typeof useGetCustomerErusLazyQuery>;
export type GetCustomerErusSuspenseQueryHookResult = ReturnType<typeof useGetCustomerErusSuspenseQuery>;
export type GetCustomerErusQueryResult = Apollo.QueryResult<GetCustomerErusQuery, GetCustomerErusQueryVariables>;
export const GetCustomerCassettesDocument = gql`
    query GetCustomerCassettes($id: UUID!, $after: String) {
  customer(id: $id) {
    id
    cassettes(first: 25, after: $after) {
      nodes {
        id
        remainingCustomerTests
        remainingPhysicalSensors
        hasOpenOverflowWarning
        serialNumber {
          serialNumber
          range {
            productType {
              code
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetCustomerCassettesQuery__
 *
 * To run a query within a React component, call `useGetCustomerCassettesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCassettesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCassettesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCustomerCassettesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables> & ({ variables: GetCustomerCassettesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables>(GetCustomerCassettesDocument, options);
      }
export function useGetCustomerCassettesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables>(GetCustomerCassettesDocument, options);
        }
export function useGetCustomerCassettesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables>(GetCustomerCassettesDocument, options);
        }
export type GetCustomerCassettesQueryHookResult = ReturnType<typeof useGetCustomerCassettesQuery>;
export type GetCustomerCassettesLazyQueryHookResult = ReturnType<typeof useGetCustomerCassettesLazyQuery>;
export type GetCustomerCassettesSuspenseQueryHookResult = ReturnType<typeof useGetCustomerCassettesSuspenseQuery>;
export type GetCustomerCassettesQueryResult = Apollo.QueryResult<GetCustomerCassettesQuery, GetCustomerCassettesQueryVariables>;
export const GetCustomerByIdDocument = gql`
    query GetCustomerById($id: UUID!) {
  customer(id: $id) {
    id
    name
    description
    contactName
    contactEmail
    contactPhone
    customerSince
    notes
    createdAt
    updatedAt
    limitIndicators
    allowedIndicatorDefinitions {
      id
      name
      displayName
    }
    organisations(first: 25) {
      nodes {
        id
        name
        logoUrl
      }
    }
    erus(first: 25) {
      nodes {
        id
        name
      }
    }
    cassettes(first: 25) {
      nodes {
        id
        remainingCustomerTests
        remainingPhysicalSensors
        hasOpenOverflowWarning
        serialNumber {
          serialNumber
          range {
            productType {
              code
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomerByIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables> & ({ variables: GetCustomerByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
      }
export function useGetCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
        }
export function useGetCustomerByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>(GetCustomerByIdDocument, options);
        }
export type GetCustomerByIdQueryHookResult = ReturnType<typeof useGetCustomerByIdQuery>;
export type GetCustomerByIdLazyQueryHookResult = ReturnType<typeof useGetCustomerByIdLazyQuery>;
export type GetCustomerByIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerByIdSuspenseQuery>;
export type GetCustomerByIdQueryResult = Apollo.QueryResult<GetCustomerByIdQuery, GetCustomerByIdQueryVariables>;
export const DashboardCustomersDocument = gql`
    query DashboardCustomers($after: String) {
  customers(first: 25, after: $after) {
    nodes {
      id
      name
      organisations(first: 25) {
        nodes {
          id
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useDashboardCustomersQuery__
 *
 * To run a query within a React component, call `useDashboardCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardCustomersQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDashboardCustomersQuery(baseOptions?: Apollo.QueryHookOptions<DashboardCustomersQuery, DashboardCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardCustomersQuery, DashboardCustomersQueryVariables>(DashboardCustomersDocument, options);
      }
export function useDashboardCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardCustomersQuery, DashboardCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardCustomersQuery, DashboardCustomersQueryVariables>(DashboardCustomersDocument, options);
        }
export function useDashboardCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardCustomersQuery, DashboardCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardCustomersQuery, DashboardCustomersQueryVariables>(DashboardCustomersDocument, options);
        }
export type DashboardCustomersQueryHookResult = ReturnType<typeof useDashboardCustomersQuery>;
export type DashboardCustomersLazyQueryHookResult = ReturnType<typeof useDashboardCustomersLazyQuery>;
export type DashboardCustomersSuspenseQueryHookResult = ReturnType<typeof useDashboardCustomersSuspenseQuery>;
export type DashboardCustomersQueryResult = Apollo.QueryResult<DashboardCustomersQuery, DashboardCustomersQueryVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CreateCustomerInput!) {
  createCustomer(input: $input) {
    id
    name
    description
    contactName
    contactEmail
    contactPhone
    customerSince
    notes
    createdAt
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    id
    name
    description
    contactName
    contactEmail
    contactPhone
    notes
    limitIndicators
    allowedIndicatorDefinitions {
      id
      name
      displayName
    }
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($id: UUID!) {
  deleteCustomer(id: $id)
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const DashboardStatsDocument = gql`
    query DashboardStats($startDate: DateTime!, $endDate: DateTime!, $previousStartDate: DateTime!, $previousEndDate: DateTime!, $includedOrganisationIds: [UUID!], $excludedOrganisationIds: [UUID!]) {
  dashboardStats(
    startDate: $startDate
    endDate: $endDate
    previousStartDate: $previousStartDate
    previousEndDate: $previousEndDate
    includedOrganisationIds: $includedOrganisationIds
    excludedOrganisationIds: $excludedOrganisationIds
  ) {
    currentPeriod {
      date
      totalCount
      soilTests
      successfulSensorChecks
      failedSensorChecks
    }
    previousPeriod {
      date
      totalCount
      soilTests
      successfulSensorChecks
      failedSensorChecks
    }
    organisationStats {
      organisationId
      organisationName
      soilTests
      successfulSensorChecks
      failedSensorChecks
    }
    mapPoints {
      testId
      latitude
      longitude
      what3Words
      testName
      organisationName
    }
  }
}
    `;

/**
 * __useDashboardStatsQuery__
 *
 * To run a query within a React component, call `useDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      previousStartDate: // value for 'previousStartDate'
 *      previousEndDate: // value for 'previousEndDate'
 *      includedOrganisationIds: // value for 'includedOrganisationIds'
 *      excludedOrganisationIds: // value for 'excludedOrganisationIds'
 *   },
 * });
 */
export function useDashboardStatsQuery(baseOptions: Apollo.QueryHookOptions<DashboardStatsQuery, DashboardStatsQueryVariables> & ({ variables: DashboardStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardStatsQuery, DashboardStatsQueryVariables>(DashboardStatsDocument, options);
      }
export function useDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardStatsQuery, DashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardStatsQuery, DashboardStatsQueryVariables>(DashboardStatsDocument, options);
        }
export function useDashboardStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardStatsQuery, DashboardStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardStatsQuery, DashboardStatsQueryVariables>(DashboardStatsDocument, options);
        }
export type DashboardStatsQueryHookResult = ReturnType<typeof useDashboardStatsQuery>;
export type DashboardStatsLazyQueryHookResult = ReturnType<typeof useDashboardStatsLazyQuery>;
export type DashboardStatsSuspenseQueryHookResult = ReturnType<typeof useDashboardStatsSuspenseQuery>;
export type DashboardStatsQueryResult = Apollo.QueryResult<DashboardStatsQuery, DashboardStatsQueryVariables>;
export const DuplicatedLabResultsCountDocument = gql`
    query DuplicatedLabResultsCount {
  duplicatedLabResultsCount
}
    `;

/**
 * __useDuplicatedLabResultsCountQuery__
 *
 * To run a query within a React component, call `useDuplicatedLabResultsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicatedLabResultsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicatedLabResultsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useDuplicatedLabResultsCountQuery(baseOptions?: Apollo.QueryHookOptions<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>(DuplicatedLabResultsCountDocument, options);
      }
export function useDuplicatedLabResultsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>(DuplicatedLabResultsCountDocument, options);
        }
export function useDuplicatedLabResultsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>(DuplicatedLabResultsCountDocument, options);
        }
export type DuplicatedLabResultsCountQueryHookResult = ReturnType<typeof useDuplicatedLabResultsCountQuery>;
export type DuplicatedLabResultsCountLazyQueryHookResult = ReturnType<typeof useDuplicatedLabResultsCountLazyQuery>;
export type DuplicatedLabResultsCountSuspenseQueryHookResult = ReturnType<typeof useDuplicatedLabResultsCountSuspenseQuery>;
export type DuplicatedLabResultsCountQueryResult = Apollo.QueryResult<DuplicatedLabResultsCountQuery, DuplicatedLabResultsCountQueryVariables>;
export const DedupeLabResultsDocument = gql`
    mutation DedupeLabResults {
  dedupeLabResults
}
    `;
export type DedupeLabResultsMutationFn = Apollo.MutationFunction<DedupeLabResultsMutation, DedupeLabResultsMutationVariables>;

/**
 * __useDedupeLabResultsMutation__
 *
 * To run a mutation, you first call `useDedupeLabResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDedupeLabResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dedupeLabResultsMutation, { data, loading, error }] = useDedupeLabResultsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDedupeLabResultsMutation(baseOptions?: Apollo.MutationHookOptions<DedupeLabResultsMutation, DedupeLabResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DedupeLabResultsMutation, DedupeLabResultsMutationVariables>(DedupeLabResultsDocument, options);
      }
export type DedupeLabResultsMutationHookResult = ReturnType<typeof useDedupeLabResultsMutation>;
export type DedupeLabResultsMutationResult = Apollo.MutationResult<DedupeLabResultsMutation>;
export type DedupeLabResultsMutationOptions = Apollo.BaseMutationOptions<DedupeLabResultsMutation, DedupeLabResultsMutationVariables>;
export const ErUsDocument = gql`
    query ERUs($after: String) {
  erus(first: 200, after: $after) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useErUsQuery__
 *
 * To run a query within a React component, call `useErUsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErUsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErUsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useErUsQuery(baseOptions?: Apollo.QueryHookOptions<ErUsQuery, ErUsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErUsQuery, ErUsQueryVariables>(ErUsDocument, options);
      }
export function useErUsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErUsQuery, ErUsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErUsQuery, ErUsQueryVariables>(ErUsDocument, options);
        }
export function useErUsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErUsQuery, ErUsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErUsQuery, ErUsQueryVariables>(ErUsDocument, options);
        }
export type ErUsQueryHookResult = ReturnType<typeof useErUsQuery>;
export type ErUsLazyQueryHookResult = ReturnType<typeof useErUsLazyQuery>;
export type ErUsSuspenseQueryHookResult = ReturnType<typeof useErUsSuspenseQuery>;
export type ErUsQueryResult = Apollo.QueryResult<ErUsQuery, ErUsQueryVariables>;
export const FarmsDocument = gql`
    query farms($after: String) {
  farms(first: 200, after: $after) {
    nodes {
      id
      name
      organisation {
        id
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFarmsQuery__
 *
 * To run a query within a React component, call `useFarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFarmsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFarmsQuery(baseOptions?: Apollo.QueryHookOptions<FarmsQuery, FarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FarmsQuery, FarmsQueryVariables>(FarmsDocument, options);
      }
export function useFarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FarmsQuery, FarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FarmsQuery, FarmsQueryVariables>(FarmsDocument, options);
        }
export function useFarmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FarmsQuery, FarmsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FarmsQuery, FarmsQueryVariables>(FarmsDocument, options);
        }
export type FarmsQueryHookResult = ReturnType<typeof useFarmsQuery>;
export type FarmsLazyQueryHookResult = ReturnType<typeof useFarmsLazyQuery>;
export type FarmsSuspenseQueryHookResult = ReturnType<typeof useFarmsSuspenseQuery>;
export type FarmsQueryResult = Apollo.QueryResult<FarmsQuery, FarmsQueryVariables>;
export const FeatureExtractionExportRunsDocument = gql`
    query FeatureExtractionExportRuns($after: String) {
  featureExtractionExportRuns(first: 25, after: $after) {
    nodes {
      id
      troUuid
      featureSetVersion
      mode
      testLimit
      status
      requestedByEmail
      totalTestCount
      excludedTestCount
      reusedCacheCount
      queuedExtractionCount
      completedExtractionCount
      failedExtractionCount
      labResultWarningCount
      startedAt
      completedAt
      errorSummary
      csvSizeBytes
      csvRowCount
      csvColumnCount
      downloadState
      createdAt
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFeatureExtractionExportRunsQuery__
 *
 * To run a query within a React component, call `useFeatureExtractionExportRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureExtractionExportRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureExtractionExportRunsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeatureExtractionExportRunsQuery(baseOptions?: Apollo.QueryHookOptions<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>(FeatureExtractionExportRunsDocument, options);
      }
export function useFeatureExtractionExportRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>(FeatureExtractionExportRunsDocument, options);
        }
export function useFeatureExtractionExportRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>(FeatureExtractionExportRunsDocument, options);
        }
export type FeatureExtractionExportRunsQueryHookResult = ReturnType<typeof useFeatureExtractionExportRunsQuery>;
export type FeatureExtractionExportRunsLazyQueryHookResult = ReturnType<typeof useFeatureExtractionExportRunsLazyQuery>;
export type FeatureExtractionExportRunsSuspenseQueryHookResult = ReturnType<typeof useFeatureExtractionExportRunsSuspenseQuery>;
export type FeatureExtractionExportRunsQueryResult = Apollo.QueryResult<FeatureExtractionExportRunsQuery, FeatureExtractionExportRunsQueryVariables>;
export const FeatureExtractionExportRunDocument = gql`
    query FeatureExtractionExportRun($id: UUID!, $after: String) {
  featureExtractionExportRun(id: $id) {
    id
    troUuid
    featureSetVersion
    mode
    testLimit
    status
    requestedByEmail
    totalTestCount
    excludedTestCount
    reusedCacheCount
    queuedExtractionCount
    completedExtractionCount
    failedExtractionCount
    labResultWarningCount
    startedAt
    completedAt
    errorSummary
    csvSizeBytes
    csvRowCount
    csvColumnCount
    downloadState
    createdAt
    failedItems(first: 25, after: $after) {
      nodes {
        id
        testId
        testName
        attemptCount
        error
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useFeatureExtractionExportRunQuery__
 *
 * To run a query within a React component, call `useFeatureExtractionExportRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureExtractionExportRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureExtractionExportRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeatureExtractionExportRunQuery(baseOptions: Apollo.QueryHookOptions<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables> & ({ variables: FeatureExtractionExportRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables>(FeatureExtractionExportRunDocument, options);
      }
export function useFeatureExtractionExportRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables>(FeatureExtractionExportRunDocument, options);
        }
export function useFeatureExtractionExportRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables>(FeatureExtractionExportRunDocument, options);
        }
export type FeatureExtractionExportRunQueryHookResult = ReturnType<typeof useFeatureExtractionExportRunQuery>;
export type FeatureExtractionExportRunLazyQueryHookResult = ReturnType<typeof useFeatureExtractionExportRunLazyQuery>;
export type FeatureExtractionExportRunSuspenseQueryHookResult = ReturnType<typeof useFeatureExtractionExportRunSuspenseQuery>;
export type FeatureExtractionExportRunQueryResult = Apollo.QueryResult<FeatureExtractionExportRunQuery, FeatureExtractionExportRunQueryVariables>;
export const StartFeatureExtractionExportDocument = gql`
    mutation StartFeatureExtractionExport($input: StartFeatureExtractionExportInput!) {
  startFeatureExtractionExport(input: $input) {
    id
    troUuid
    featureSetVersion
    mode
    testLimit
    status
    createdAt
  }
}
    `;
export type StartFeatureExtractionExportMutationFn = Apollo.MutationFunction<StartFeatureExtractionExportMutation, StartFeatureExtractionExportMutationVariables>;

/**
 * __useStartFeatureExtractionExportMutation__
 *
 * To run a mutation, you first call `useStartFeatureExtractionExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartFeatureExtractionExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startFeatureExtractionExportMutation, { data, loading, error }] = useStartFeatureExtractionExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartFeatureExtractionExportMutation(baseOptions?: Apollo.MutationHookOptions<StartFeatureExtractionExportMutation, StartFeatureExtractionExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartFeatureExtractionExportMutation, StartFeatureExtractionExportMutationVariables>(StartFeatureExtractionExportDocument, options);
      }
export type StartFeatureExtractionExportMutationHookResult = ReturnType<typeof useStartFeatureExtractionExportMutation>;
export type StartFeatureExtractionExportMutationResult = Apollo.MutationResult<StartFeatureExtractionExportMutation>;
export type StartFeatureExtractionExportMutationOptions = Apollo.BaseMutationOptions<StartFeatureExtractionExportMutation, StartFeatureExtractionExportMutationVariables>;
export const FeatureExtractionExportDownloadUrlDocument = gql`
    mutation FeatureExtractionExportDownloadUrl($id: UUID!) {
  featureExtractionExportDownloadUrl(id: $id) {
    url
    expiresAt
    fileName
  }
}
    `;
export type FeatureExtractionExportDownloadUrlMutationFn = Apollo.MutationFunction<FeatureExtractionExportDownloadUrlMutation, FeatureExtractionExportDownloadUrlMutationVariables>;

/**
 * __useFeatureExtractionExportDownloadUrlMutation__
 *
 * To run a mutation, you first call `useFeatureExtractionExportDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeatureExtractionExportDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [featureExtractionExportDownloadUrlMutation, { data, loading, error }] = useFeatureExtractionExportDownloadUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFeatureExtractionExportDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<FeatureExtractionExportDownloadUrlMutation, FeatureExtractionExportDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeatureExtractionExportDownloadUrlMutation, FeatureExtractionExportDownloadUrlMutationVariables>(FeatureExtractionExportDownloadUrlDocument, options);
      }
export type FeatureExtractionExportDownloadUrlMutationHookResult = ReturnType<typeof useFeatureExtractionExportDownloadUrlMutation>;
export type FeatureExtractionExportDownloadUrlMutationResult = Apollo.MutationResult<FeatureExtractionExportDownloadUrlMutation>;
export type FeatureExtractionExportDownloadUrlMutationOptions = Apollo.BaseMutationOptions<FeatureExtractionExportDownloadUrlMutation, FeatureExtractionExportDownloadUrlMutationVariables>;
export const FieldsDocument = gql`
    query fields($after: String) {
  fields(first: 25, after: $after) {
    nodes {
      name
      id
      farm {
        id
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFieldsQuery__
 *
 * To run a query within a React component, call `useFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFieldsQuery(baseOptions?: Apollo.QueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
      }
export function useFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
        }
export function useFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FieldsQuery, FieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FieldsQuery, FieldsQueryVariables>(FieldsDocument, options);
        }
export type FieldsQueryHookResult = ReturnType<typeof useFieldsQuery>;
export type FieldsLazyQueryHookResult = ReturnType<typeof useFieldsLazyQuery>;
export type FieldsSuspenseQueryHookResult = ReturnType<typeof useFieldsSuspenseQuery>;
export type FieldsQueryResult = Apollo.QueryResult<FieldsQuery, FieldsQueryVariables>;
export const FieldsForFarmDocument = gql`
    query fieldsForFarm($farmId: UUID!, $after: String) {
  farm(id: $farmId) {
    id
    fields(first: 200, after: $after) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useFieldsForFarmQuery__
 *
 * To run a query within a React component, call `useFieldsForFarmQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldsForFarmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldsForFarmQuery({
 *   variables: {
 *      farmId: // value for 'farmId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFieldsForFarmQuery(baseOptions: Apollo.QueryHookOptions<FieldsForFarmQuery, FieldsForFarmQueryVariables> & ({ variables: FieldsForFarmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldsForFarmQuery, FieldsForFarmQueryVariables>(FieldsForFarmDocument, options);
      }
export function useFieldsForFarmLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldsForFarmQuery, FieldsForFarmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldsForFarmQuery, FieldsForFarmQueryVariables>(FieldsForFarmDocument, options);
        }
export function useFieldsForFarmSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FieldsForFarmQuery, FieldsForFarmQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FieldsForFarmQuery, FieldsForFarmQueryVariables>(FieldsForFarmDocument, options);
        }
export type FieldsForFarmQueryHookResult = ReturnType<typeof useFieldsForFarmQuery>;
export type FieldsForFarmLazyQueryHookResult = ReturnType<typeof useFieldsForFarmLazyQuery>;
export type FieldsForFarmSuspenseQueryHookResult = ReturnType<typeof useFieldsForFarmSuspenseQuery>;
export type FieldsForFarmQueryResult = Apollo.QueryResult<FieldsForFarmQuery, FieldsForFarmQueryVariables>;
export const FirmwareVersionsDocument = gql`
    query FirmwareVersions($after: String) {
  firmwareVersions(first: 25, after: $after) {
    nodes {
      id
      createdAt
      version
      fileName
      byteLength
      sha256
      isActive
      installCount
      uploadedByUser {
        id
        fullName
        email
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFirmwareVersionsQuery__
 *
 * To run a query within a React component, call `useFirmwareVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmwareVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmwareVersionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFirmwareVersionsQuery(baseOptions?: Apollo.QueryHookOptions<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>(FirmwareVersionsDocument, options);
      }
export function useFirmwareVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>(FirmwareVersionsDocument, options);
        }
export function useFirmwareVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>(FirmwareVersionsDocument, options);
        }
export type FirmwareVersionsQueryHookResult = ReturnType<typeof useFirmwareVersionsQuery>;
export type FirmwareVersionsLazyQueryHookResult = ReturnType<typeof useFirmwareVersionsLazyQuery>;
export type FirmwareVersionsSuspenseQueryHookResult = ReturnType<typeof useFirmwareVersionsSuspenseQuery>;
export type FirmwareVersionsQueryResult = Apollo.QueryResult<FirmwareVersionsQuery, FirmwareVersionsQueryVariables>;
export const FirmwareInstallLogsDocument = gql`
    query FirmwareInstallLogs($after: String) {
  firmwareInstallLogs(first: 25, after: $after) {
    nodes {
      id
      createdAt
      updatedAt
      status
      eruName
      runtimePortName
      runtimeSerialNumber
      runtimeProductId
      dfuSerialNumber
      dfuProductId
      fromVersion
      toVersion
      completedAt
      errorMessage
      technicalLog
      firmwareVersion {
        id
        version
      }
      eru {
        id
        name
        bleId
        bleMac
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useFirmwareInstallLogsQuery__
 *
 * To run a query within a React component, call `useFirmwareInstallLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirmwareInstallLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirmwareInstallLogsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFirmwareInstallLogsQuery(baseOptions?: Apollo.QueryHookOptions<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>(FirmwareInstallLogsDocument, options);
      }
export function useFirmwareInstallLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>(FirmwareInstallLogsDocument, options);
        }
export function useFirmwareInstallLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>(FirmwareInstallLogsDocument, options);
        }
export type FirmwareInstallLogsQueryHookResult = ReturnType<typeof useFirmwareInstallLogsQuery>;
export type FirmwareInstallLogsLazyQueryHookResult = ReturnType<typeof useFirmwareInstallLogsLazyQuery>;
export type FirmwareInstallLogsSuspenseQueryHookResult = ReturnType<typeof useFirmwareInstallLogsSuspenseQuery>;
export type FirmwareInstallLogsQueryResult = Apollo.QueryResult<FirmwareInstallLogsQuery, FirmwareInstallLogsQueryVariables>;
export const UploadFirmwareDocument = gql`
    mutation UploadFirmware($input: UploadFirmwareInput!) {
  uploadFirmware(input: $input) {
    id
    version
    isActive
  }
}
    `;
export type UploadFirmwareMutationFn = Apollo.MutationFunction<UploadFirmwareMutation, UploadFirmwareMutationVariables>;

/**
 * __useUploadFirmwareMutation__
 *
 * To run a mutation, you first call `useUploadFirmwareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFirmwareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFirmwareMutation, { data, loading, error }] = useUploadFirmwareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadFirmwareMutation(baseOptions?: Apollo.MutationHookOptions<UploadFirmwareMutation, UploadFirmwareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFirmwareMutation, UploadFirmwareMutationVariables>(UploadFirmwareDocument, options);
      }
export type UploadFirmwareMutationHookResult = ReturnType<typeof useUploadFirmwareMutation>;
export type UploadFirmwareMutationResult = Apollo.MutationResult<UploadFirmwareMutation>;
export type UploadFirmwareMutationOptions = Apollo.BaseMutationOptions<UploadFirmwareMutation, UploadFirmwareMutationVariables>;
export const SetActiveFirmwareVersionDocument = gql`
    mutation SetActiveFirmwareVersion($id: UUID!) {
  setActiveFirmwareVersion(id: $id) {
    id
    version
    isActive
  }
}
    `;
export type SetActiveFirmwareVersionMutationFn = Apollo.MutationFunction<SetActiveFirmwareVersionMutation, SetActiveFirmwareVersionMutationVariables>;

/**
 * __useSetActiveFirmwareVersionMutation__
 *
 * To run a mutation, you first call `useSetActiveFirmwareVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveFirmwareVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveFirmwareVersionMutation, { data, loading, error }] = useSetActiveFirmwareVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetActiveFirmwareVersionMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveFirmwareVersionMutation, SetActiveFirmwareVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveFirmwareVersionMutation, SetActiveFirmwareVersionMutationVariables>(SetActiveFirmwareVersionDocument, options);
      }
export type SetActiveFirmwareVersionMutationHookResult = ReturnType<typeof useSetActiveFirmwareVersionMutation>;
export type SetActiveFirmwareVersionMutationResult = Apollo.MutationResult<SetActiveFirmwareVersionMutation>;
export type SetActiveFirmwareVersionMutationOptions = Apollo.BaseMutationOptions<SetActiveFirmwareVersionMutation, SetActiveFirmwareVersionMutationVariables>;
export const LabIndicatorDefinitionDocument = gql`
    query LabIndicatorDefinition($id: UUID!) {
  labIndicatorDefinition(id: $id) {
    id
    valueType
    unit
    name
    displayName
    updatedAt
    createdAt
    alwaysShow
  }
}
    `;

/**
 * __useLabIndicatorDefinitionQuery__
 *
 * To run a query within a React component, call `useLabIndicatorDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabIndicatorDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabIndicatorDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLabIndicatorDefinitionQuery(baseOptions: Apollo.QueryHookOptions<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables> & ({ variables: LabIndicatorDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables>(LabIndicatorDefinitionDocument, options);
      }
export function useLabIndicatorDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables>(LabIndicatorDefinitionDocument, options);
        }
export function useLabIndicatorDefinitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables>(LabIndicatorDefinitionDocument, options);
        }
export type LabIndicatorDefinitionQueryHookResult = ReturnType<typeof useLabIndicatorDefinitionQuery>;
export type LabIndicatorDefinitionLazyQueryHookResult = ReturnType<typeof useLabIndicatorDefinitionLazyQuery>;
export type LabIndicatorDefinitionSuspenseQueryHookResult = ReturnType<typeof useLabIndicatorDefinitionSuspenseQuery>;
export type LabIndicatorDefinitionQueryResult = Apollo.QueryResult<LabIndicatorDefinitionQuery, LabIndicatorDefinitionQueryVariables>;
export const LabIndicatorDefinitionsDocument = gql`
    query LabIndicatorDefinitions($after: String) {
  labIndicatorDefinitions(first: 25, after: $after) {
    nodes {
      id
      valueType
      unit
      name
      displayName
      updatedAt
      createdAt
      alwaysShow
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useLabIndicatorDefinitionsQuery__
 *
 * To run a query within a React component, call `useLabIndicatorDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabIndicatorDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabIndicatorDefinitionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLabIndicatorDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>(LabIndicatorDefinitionsDocument, options);
      }
export function useLabIndicatorDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>(LabIndicatorDefinitionsDocument, options);
        }
export function useLabIndicatorDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>(LabIndicatorDefinitionsDocument, options);
        }
export type LabIndicatorDefinitionsQueryHookResult = ReturnType<typeof useLabIndicatorDefinitionsQuery>;
export type LabIndicatorDefinitionsLazyQueryHookResult = ReturnType<typeof useLabIndicatorDefinitionsLazyQuery>;
export type LabIndicatorDefinitionsSuspenseQueryHookResult = ReturnType<typeof useLabIndicatorDefinitionsSuspenseQuery>;
export type LabIndicatorDefinitionsQueryResult = Apollo.QueryResult<LabIndicatorDefinitionsQuery, LabIndicatorDefinitionsQueryVariables>;
export const CreateLabIndicatorDefinitionDocument = gql`
    mutation CreateLabIndicatorDefinition($input: CreateLabIndicatorDefinitionInput!) {
  createLabIndicatorDefinition(input: $input) {
    id
    valueType
    unit
    name
    updatedAt
    createdAt
    alwaysShow
  }
}
    `;
export type CreateLabIndicatorDefinitionMutationFn = Apollo.MutationFunction<CreateLabIndicatorDefinitionMutation, CreateLabIndicatorDefinitionMutationVariables>;

/**
 * __useCreateLabIndicatorDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateLabIndicatorDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabIndicatorDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabIndicatorDefinitionMutation, { data, loading, error }] = useCreateLabIndicatorDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabIndicatorDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabIndicatorDefinitionMutation, CreateLabIndicatorDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabIndicatorDefinitionMutation, CreateLabIndicatorDefinitionMutationVariables>(CreateLabIndicatorDefinitionDocument, options);
      }
export type CreateLabIndicatorDefinitionMutationHookResult = ReturnType<typeof useCreateLabIndicatorDefinitionMutation>;
export type CreateLabIndicatorDefinitionMutationResult = Apollo.MutationResult<CreateLabIndicatorDefinitionMutation>;
export type CreateLabIndicatorDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateLabIndicatorDefinitionMutation, CreateLabIndicatorDefinitionMutationVariables>;
export const LabResultDocument = gql`
    query LabResult($id: UUID!) {
  labResult(id: $id) {
    id
    laboratory {
      id
      name
    }
    indicator {
      id
      name
    }
    soilSample {
      id
    }
    createdAt
    updatedAt
    value
  }
}
    `;

/**
 * __useLabResultQuery__
 *
 * To run a query within a React component, call `useLabResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useLabResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLabResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLabResultQuery(baseOptions: Apollo.QueryHookOptions<LabResultQuery, LabResultQueryVariables> & ({ variables: LabResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LabResultQuery, LabResultQueryVariables>(LabResultDocument, options);
      }
export function useLabResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LabResultQuery, LabResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LabResultQuery, LabResultQueryVariables>(LabResultDocument, options);
        }
export function useLabResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LabResultQuery, LabResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LabResultQuery, LabResultQueryVariables>(LabResultDocument, options);
        }
export type LabResultQueryHookResult = ReturnType<typeof useLabResultQuery>;
export type LabResultLazyQueryHookResult = ReturnType<typeof useLabResultLazyQuery>;
export type LabResultSuspenseQueryHookResult = ReturnType<typeof useLabResultSuspenseQuery>;
export type LabResultQueryResult = Apollo.QueryResult<LabResultQuery, LabResultQueryVariables>;
export const CreateLabResultDocument = gql`
    mutation CreateLabResult($input: CreateLabResultInput!) {
  createLabResult(input: $input) {
    id
    laboratory {
      id
      name
    }
    indicator {
      id
      name
    }
    soilSample {
      id
    }
    createdAt
    updatedAt
    value
  }
}
    `;
export type CreateLabResultMutationFn = Apollo.MutationFunction<CreateLabResultMutation, CreateLabResultMutationVariables>;

/**
 * __useCreateLabResultMutation__
 *
 * To run a mutation, you first call `useCreateLabResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLabResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLabResultMutation, { data, loading, error }] = useCreateLabResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLabResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateLabResultMutation, CreateLabResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLabResultMutation, CreateLabResultMutationVariables>(CreateLabResultDocument, options);
      }
export type CreateLabResultMutationHookResult = ReturnType<typeof useCreateLabResultMutation>;
export type CreateLabResultMutationResult = Apollo.MutationResult<CreateLabResultMutation>;
export type CreateLabResultMutationOptions = Apollo.BaseMutationOptions<CreateLabResultMutation, CreateLabResultMutationVariables>;
export const UpdateLabResultDocument = gql`
    mutation UpdateLabResult($input: UpdateLabResultInput!) {
  updateLabResult(input: $input) {
    id
    laboratory {
      id
      name
    }
    indicator {
      id
      name
    }
    soilSample {
      id
    }
    createdAt
    updatedAt
    value
  }
}
    `;
export type UpdateLabResultMutationFn = Apollo.MutationFunction<UpdateLabResultMutation, UpdateLabResultMutationVariables>;

/**
 * __useUpdateLabResultMutation__
 *
 * To run a mutation, you first call `useUpdateLabResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLabResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLabResultMutation, { data, loading, error }] = useUpdateLabResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLabResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLabResultMutation, UpdateLabResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLabResultMutation, UpdateLabResultMutationVariables>(UpdateLabResultDocument, options);
      }
export type UpdateLabResultMutationHookResult = ReturnType<typeof useUpdateLabResultMutation>;
export type UpdateLabResultMutationResult = Apollo.MutationResult<UpdateLabResultMutation>;
export type UpdateLabResultMutationOptions = Apollo.BaseMutationOptions<UpdateLabResultMutation, UpdateLabResultMutationVariables>;
export const LaboratoriesDocument = gql`
    query Laboratories($after: String) {
  laboratories(first: 25, after: $after) {
    nodes {
      id
      name
      updatedAt
      createdAt
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useLaboratoriesQuery__
 *
 * To run a query within a React component, call `useLaboratoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLaboratoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLaboratoriesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLaboratoriesQuery(baseOptions?: Apollo.QueryHookOptions<LaboratoriesQuery, LaboratoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LaboratoriesQuery, LaboratoriesQueryVariables>(LaboratoriesDocument, options);
      }
export function useLaboratoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LaboratoriesQuery, LaboratoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LaboratoriesQuery, LaboratoriesQueryVariables>(LaboratoriesDocument, options);
        }
export function useLaboratoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LaboratoriesQuery, LaboratoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LaboratoriesQuery, LaboratoriesQueryVariables>(LaboratoriesDocument, options);
        }
export type LaboratoriesQueryHookResult = ReturnType<typeof useLaboratoriesQuery>;
export type LaboratoriesLazyQueryHookResult = ReturnType<typeof useLaboratoriesLazyQuery>;
export type LaboratoriesSuspenseQueryHookResult = ReturnType<typeof useLaboratoriesSuspenseQuery>;
export type LaboratoriesQueryResult = Apollo.QueryResult<LaboratoriesQuery, LaboratoriesQueryVariables>;
export const CreateLaboratoryDocument = gql`
    mutation CreateLaboratory($input: CreateLaboratoryInput!) {
  createLaboratory(input: $input) {
    id
    name
    updatedAt
    createdAt
  }
}
    `;
export type CreateLaboratoryMutationFn = Apollo.MutationFunction<CreateLaboratoryMutation, CreateLaboratoryMutationVariables>;

/**
 * __useCreateLaboratoryMutation__
 *
 * To run a mutation, you first call `useCreateLaboratoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLaboratoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLaboratoryMutation, { data, loading, error }] = useCreateLaboratoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLaboratoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateLaboratoryMutation, CreateLaboratoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLaboratoryMutation, CreateLaboratoryMutationVariables>(CreateLaboratoryDocument, options);
      }
export type CreateLaboratoryMutationHookResult = ReturnType<typeof useCreateLaboratoryMutation>;
export type CreateLaboratoryMutationResult = Apollo.MutationResult<CreateLaboratoryMutation>;
export type CreateLaboratoryMutationOptions = Apollo.BaseMutationOptions<CreateLaboratoryMutation, CreateLaboratoryMutationVariables>;
export const LocalisationAdminOverviewDocument = gql`
    query LocalisationAdminOverview {
  localisationAdminOverview {
    enabledLocales
    enabledLocaleSummaries {
      locale
      setupStatus
      setupFailureMessage
      setupUpdatedAt
    }
    files {
      name
      baseEntryCount
      targetLocaleCount
      targetLocales
      translationContext
      updatedAt
      setupStatus
      setupFailureMessage
      setupUpdatedAt
    }
  }
}
    `;

/**
 * __useLocalisationAdminOverviewQuery__
 *
 * To run a query within a React component, call `useLocalisationAdminOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalisationAdminOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalisationAdminOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocalisationAdminOverviewQuery(baseOptions?: Apollo.QueryHookOptions<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>(LocalisationAdminOverviewDocument, options);
      }
export function useLocalisationAdminOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>(LocalisationAdminOverviewDocument, options);
        }
export function useLocalisationAdminOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>(LocalisationAdminOverviewDocument, options);
        }
export type LocalisationAdminOverviewQueryHookResult = ReturnType<typeof useLocalisationAdminOverviewQuery>;
export type LocalisationAdminOverviewLazyQueryHookResult = ReturnType<typeof useLocalisationAdminOverviewLazyQuery>;
export type LocalisationAdminOverviewSuspenseQueryHookResult = ReturnType<typeof useLocalisationAdminOverviewSuspenseQuery>;
export type LocalisationAdminOverviewQueryResult = Apollo.QueryResult<LocalisationAdminOverviewQuery, LocalisationAdminOverviewQueryVariables>;
export const LocalisationEditorDocument = gql`
    query LocalisationEditor($name: String!, $locale: String!) {
  localisationEditor(name: $name, locale: $locale) {
    fileName
    locale
    rows {
      key
      baseValue
      targetValue
      effectiveValue
      isFallback
      isApproved
      isTranslating
    }
  }
}
    `;

/**
 * __useLocalisationEditorQuery__
 *
 * To run a query within a React component, call `useLocalisationEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalisationEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalisationEditorQuery({
 *   variables: {
 *      name: // value for 'name'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useLocalisationEditorQuery(baseOptions: Apollo.QueryHookOptions<LocalisationEditorQuery, LocalisationEditorQueryVariables> & ({ variables: LocalisationEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalisationEditorQuery, LocalisationEditorQueryVariables>(LocalisationEditorDocument, options);
      }
export function useLocalisationEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalisationEditorQuery, LocalisationEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalisationEditorQuery, LocalisationEditorQueryVariables>(LocalisationEditorDocument, options);
        }
export function useLocalisationEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocalisationEditorQuery, LocalisationEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocalisationEditorQuery, LocalisationEditorQueryVariables>(LocalisationEditorDocument, options);
        }
export type LocalisationEditorQueryHookResult = ReturnType<typeof useLocalisationEditorQuery>;
export type LocalisationEditorLazyQueryHookResult = ReturnType<typeof useLocalisationEditorLazyQuery>;
export type LocalisationEditorSuspenseQueryHookResult = ReturnType<typeof useLocalisationEditorSuspenseQuery>;
export type LocalisationEditorQueryResult = Apollo.QueryResult<LocalisationEditorQuery, LocalisationEditorQueryVariables>;
export const CreateLocalisationFileDocument = gql`
    mutation CreateLocalisationFile($input: CreateLocalisationFileInput!) {
  createLocalisationFile(input: $input) {
    name
    baseEntryCount
    targetLocaleCount
    targetLocales
    translationContext
    updatedAt
  }
}
    `;
export type CreateLocalisationFileMutationFn = Apollo.MutationFunction<CreateLocalisationFileMutation, CreateLocalisationFileMutationVariables>;

/**
 * __useCreateLocalisationFileMutation__
 *
 * To run a mutation, you first call `useCreateLocalisationFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocalisationFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocalisationFileMutation, { data, loading, error }] = useCreateLocalisationFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocalisationFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocalisationFileMutation, CreateLocalisationFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocalisationFileMutation, CreateLocalisationFileMutationVariables>(CreateLocalisationFileDocument, options);
      }
export type CreateLocalisationFileMutationHookResult = ReturnType<typeof useCreateLocalisationFileMutation>;
export type CreateLocalisationFileMutationResult = Apollo.MutationResult<CreateLocalisationFileMutation>;
export type CreateLocalisationFileMutationOptions = Apollo.BaseMutationOptions<CreateLocalisationFileMutation, CreateLocalisationFileMutationVariables>;
export const UpdateLocalisationFileDocument = gql`
    mutation UpdateLocalisationFile($input: UpdateLocalisationFileInput!) {
  updateLocalisationFile(input: $input) {
    name
    baseEntryCount
    targetLocaleCount
    targetLocales
    translationContext
    updatedAt
  }
}
    `;
export type UpdateLocalisationFileMutationFn = Apollo.MutationFunction<UpdateLocalisationFileMutation, UpdateLocalisationFileMutationVariables>;

/**
 * __useUpdateLocalisationFileMutation__
 *
 * To run a mutation, you first call `useUpdateLocalisationFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalisationFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalisationFileMutation, { data, loading, error }] = useUpdateLocalisationFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalisationFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocalisationFileMutation, UpdateLocalisationFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocalisationFileMutation, UpdateLocalisationFileMutationVariables>(UpdateLocalisationFileDocument, options);
      }
export type UpdateLocalisationFileMutationHookResult = ReturnType<typeof useUpdateLocalisationFileMutation>;
export type UpdateLocalisationFileMutationResult = Apollo.MutationResult<UpdateLocalisationFileMutation>;
export type UpdateLocalisationFileMutationOptions = Apollo.BaseMutationOptions<UpdateLocalisationFileMutation, UpdateLocalisationFileMutationVariables>;
export const AddLocalisationTargetLocaleDocument = gql`
    mutation AddLocalisationTargetLocale($input: AddLocalisationTargetLocaleInput!) {
  addLocalisationTargetLocale(input: $input) {
    name
    baseEntryCount
    targetLocaleCount
    targetLocales
    translationContext
    updatedAt
  }
}
    `;
export type AddLocalisationTargetLocaleMutationFn = Apollo.MutationFunction<AddLocalisationTargetLocaleMutation, AddLocalisationTargetLocaleMutationVariables>;

/**
 * __useAddLocalisationTargetLocaleMutation__
 *
 * To run a mutation, you first call `useAddLocalisationTargetLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLocalisationTargetLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLocalisationTargetLocaleMutation, { data, loading, error }] = useAddLocalisationTargetLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddLocalisationTargetLocaleMutation(baseOptions?: Apollo.MutationHookOptions<AddLocalisationTargetLocaleMutation, AddLocalisationTargetLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLocalisationTargetLocaleMutation, AddLocalisationTargetLocaleMutationVariables>(AddLocalisationTargetLocaleDocument, options);
      }
export type AddLocalisationTargetLocaleMutationHookResult = ReturnType<typeof useAddLocalisationTargetLocaleMutation>;
export type AddLocalisationTargetLocaleMutationResult = Apollo.MutationResult<AddLocalisationTargetLocaleMutation>;
export type AddLocalisationTargetLocaleMutationOptions = Apollo.BaseMutationOptions<AddLocalisationTargetLocaleMutation, AddLocalisationTargetLocaleMutationVariables>;
export const UpdateLocalisationTranslationDocument = gql`
    mutation UpdateLocalisationTranslation($input: UpdateLocalisationTranslationInput!) {
  updateLocalisationTranslation(input: $input)
}
    `;
export type UpdateLocalisationTranslationMutationFn = Apollo.MutationFunction<UpdateLocalisationTranslationMutation, UpdateLocalisationTranslationMutationVariables>;

/**
 * __useUpdateLocalisationTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateLocalisationTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalisationTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalisationTranslationMutation, { data, loading, error }] = useUpdateLocalisationTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocalisationTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocalisationTranslationMutation, UpdateLocalisationTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocalisationTranslationMutation, UpdateLocalisationTranslationMutationVariables>(UpdateLocalisationTranslationDocument, options);
      }
export type UpdateLocalisationTranslationMutationHookResult = ReturnType<typeof useUpdateLocalisationTranslationMutation>;
export type UpdateLocalisationTranslationMutationResult = Apollo.MutationResult<UpdateLocalisationTranslationMutation>;
export type UpdateLocalisationTranslationMutationOptions = Apollo.BaseMutationOptions<UpdateLocalisationTranslationMutation, UpdateLocalisationTranslationMutationVariables>;
export const QueueLocalisationTranslationDocument = gql`
    mutation QueueLocalisationTranslation($input: QueueLocalisationTranslationInput!) {
  queueLocalisationTranslation(input: $input)
}
    `;
export type QueueLocalisationTranslationMutationFn = Apollo.MutationFunction<QueueLocalisationTranslationMutation, QueueLocalisationTranslationMutationVariables>;

/**
 * __useQueueLocalisationTranslationMutation__
 *
 * To run a mutation, you first call `useQueueLocalisationTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueLocalisationTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueLocalisationTranslationMutation, { data, loading, error }] = useQueueLocalisationTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueueLocalisationTranslationMutation(baseOptions?: Apollo.MutationHookOptions<QueueLocalisationTranslationMutation, QueueLocalisationTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueueLocalisationTranslationMutation, QueueLocalisationTranslationMutationVariables>(QueueLocalisationTranslationDocument, options);
      }
export type QueueLocalisationTranslationMutationHookResult = ReturnType<typeof useQueueLocalisationTranslationMutation>;
export type QueueLocalisationTranslationMutationResult = Apollo.MutationResult<QueueLocalisationTranslationMutation>;
export type QueueLocalisationTranslationMutationOptions = Apollo.BaseMutationOptions<QueueLocalisationTranslationMutation, QueueLocalisationTranslationMutationVariables>;
export const SetLocalisationLocaleEnabledDocument = gql`
    mutation SetLocalisationLocaleEnabled($input: SetLocalisationLocaleEnabledInput!) {
  setLocalisationLocaleEnabled(input: $input) {
    locale
    isEnabled
  }
}
    `;
export type SetLocalisationLocaleEnabledMutationFn = Apollo.MutationFunction<SetLocalisationLocaleEnabledMutation, SetLocalisationLocaleEnabledMutationVariables>;

/**
 * __useSetLocalisationLocaleEnabledMutation__
 *
 * To run a mutation, you first call `useSetLocalisationLocaleEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLocalisationLocaleEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLocalisationLocaleEnabledMutation, { data, loading, error }] = useSetLocalisationLocaleEnabledMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetLocalisationLocaleEnabledMutation(baseOptions?: Apollo.MutationHookOptions<SetLocalisationLocaleEnabledMutation, SetLocalisationLocaleEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLocalisationLocaleEnabledMutation, SetLocalisationLocaleEnabledMutationVariables>(SetLocalisationLocaleEnabledDocument, options);
      }
export type SetLocalisationLocaleEnabledMutationHookResult = ReturnType<typeof useSetLocalisationLocaleEnabledMutation>;
export type SetLocalisationLocaleEnabledMutationResult = Apollo.MutationResult<SetLocalisationLocaleEnabledMutation>;
export type SetLocalisationLocaleEnabledMutationOptions = Apollo.BaseMutationOptions<SetLocalisationLocaleEnabledMutation, SetLocalisationLocaleEnabledMutationVariables>;
export const MlModelsDocument = gql`
    query MlModels($after: String) {
  mlModels(first: 25, after: $after) {
    nodes {
      id
      name
      createdAt
      trainedIndicators(first: 25) {
        nodes {
          id
          name
          inferenceModelName
          maxValue
          minValue
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useMlModelsQuery__
 *
 * To run a query within a React component, call `useMlModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMlModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMlModelsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMlModelsQuery(baseOptions?: Apollo.QueryHookOptions<MlModelsQuery, MlModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MlModelsQuery, MlModelsQueryVariables>(MlModelsDocument, options);
      }
export function useMlModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MlModelsQuery, MlModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MlModelsQuery, MlModelsQueryVariables>(MlModelsDocument, options);
        }
export function useMlModelsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MlModelsQuery, MlModelsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MlModelsQuery, MlModelsQueryVariables>(MlModelsDocument, options);
        }
export type MlModelsQueryHookResult = ReturnType<typeof useMlModelsQuery>;
export type MlModelsLazyQueryHookResult = ReturnType<typeof useMlModelsLazyQuery>;
export type MlModelsSuspenseQueryHookResult = ReturnType<typeof useMlModelsSuspenseQuery>;
export type MlModelsQueryResult = Apollo.QueryResult<MlModelsQuery, MlModelsQueryVariables>;
export const OrganisationsDocument = gql`
    query Organisations($after: String) {
  organisations(first: 200, after: $after) {
    nodes {
      name
      id
      logoUrl
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useOrganisationsQuery__
 *
 * To run a query within a React component, call `useOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
      }
export function useOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
        }
export function useOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
        }
export type OrganisationsQueryHookResult = ReturnType<typeof useOrganisationsQuery>;
export type OrganisationsLazyQueryHookResult = ReturnType<typeof useOrganisationsLazyQuery>;
export type OrganisationsSuspenseQueryHookResult = ReturnType<typeof useOrganisationsSuspenseQuery>;
export type OrganisationsQueryResult = Apollo.QueryResult<OrganisationsQuery, OrganisationsQueryVariables>;
export const PesTestDocument = gql`
    query PesTest($id: UUID!, $resultsAfter: String) {
  pesTest(id: $id) {
    id
    createdAt
    utcTestTime
    runId
    name
    displayCropTypeName
    hasResults
    isReferenceZone
    testType
    isFailure
    failureReasons
    excludeFromMl
    sampleFileUrl
    originalModelName
    troUuid
    tro {
      id
      name
    }
    organisation {
      id
      name
    }
    createdBy {
      id
      fullName
      email
      organisationMemberships {
        id
        name
      }
    }
    cropType {
      id
      name
    }
    farm {
      id
      name
    }
    field {
      id
      name
    }
    location {
      id
      what3Words {
        words
      }
      latitude
      longitude
    }
    moisture
    soilTexture
    season
    cassette {
      id
      serialNumber {
        id
        serialNumber
        range {
          id
          productType {
            id
            code
          }
        }
      }
    }
    eru {
      id
      name
    }
    featureCaches {
      id
      sampleId
      featureSetVersion
      featureCount
      extractedAt
      sourceUri
      payloadSha256
      createdAt
      updatedAt
      warningSummary {
        hasWarnings
        status
        messages
      }
    }
    soilSample {
      id
      name
      location {
        id
        latitude
        longitude
        what3Words {
          words
        }
      }
    }
    results(first: 50, after: $resultsAfter) {
      nodes {
        id
        value
        createdAt
        updatedAt
        indicator {
          id
          minValue
          maxValue
          model {
            id
            name
          }
          indicatorDefinition {
            id
            name
            unit
            description
            displayName
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __usePesTestQuery__
 *
 * To run a query within a React component, call `usePesTestQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesTestQuery({
 *   variables: {
 *      id: // value for 'id'
 *      resultsAfter: // value for 'resultsAfter'
 *   },
 * });
 */
export function usePesTestQuery(baseOptions: Apollo.QueryHookOptions<PesTestQuery, PesTestQueryVariables> & ({ variables: PesTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesTestQuery, PesTestQueryVariables>(PesTestDocument, options);
      }
export function usePesTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesTestQuery, PesTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesTestQuery, PesTestQueryVariables>(PesTestDocument, options);
        }
export function usePesTestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesTestQuery, PesTestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesTestQuery, PesTestQueryVariables>(PesTestDocument, options);
        }
export type PesTestQueryHookResult = ReturnType<typeof usePesTestQuery>;
export type PesTestLazyQueryHookResult = ReturnType<typeof usePesTestLazyQuery>;
export type PesTestSuspenseQueryHookResult = ReturnType<typeof usePesTestSuspenseQuery>;
export type PesTestQueryResult = Apollo.QueryResult<PesTestQuery, PesTestQueryVariables>;
export const PesTestFeatureCacheFeaturesDocument = gql`
    query PesTestFeatureCacheFeatures($id: UUID!, $search: String!, $limit: Int!) {
  pesTest(id: $id) {
    id
    featureCaches {
      id
      featureMatches(search: $search, limit: $limit) {
        name
        value
        displayValue
        hasValue
      }
    }
  }
}
    `;

/**
 * __usePesTestFeatureCacheFeaturesQuery__
 *
 * To run a query within a React component, call `usePesTestFeatureCacheFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesTestFeatureCacheFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesTestFeatureCacheFeaturesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePesTestFeatureCacheFeaturesQuery(baseOptions: Apollo.QueryHookOptions<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables> & ({ variables: PesTestFeatureCacheFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables>(PesTestFeatureCacheFeaturesDocument, options);
      }
export function usePesTestFeatureCacheFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables>(PesTestFeatureCacheFeaturesDocument, options);
        }
export function usePesTestFeatureCacheFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables>(PesTestFeatureCacheFeaturesDocument, options);
        }
export type PesTestFeatureCacheFeaturesQueryHookResult = ReturnType<typeof usePesTestFeatureCacheFeaturesQuery>;
export type PesTestFeatureCacheFeaturesLazyQueryHookResult = ReturnType<typeof usePesTestFeatureCacheFeaturesLazyQuery>;
export type PesTestFeatureCacheFeaturesSuspenseQueryHookResult = ReturnType<typeof usePesTestFeatureCacheFeaturesSuspenseQuery>;
export type PesTestFeatureCacheFeaturesQueryResult = Apollo.QueryResult<PesTestFeatureCacheFeaturesQuery, PesTestFeatureCacheFeaturesQueryVariables>;
export const UserPesTestDocument = gql`
    query UserPesTest($id: UUID!, $resultsAfter: String) {
  pesTest(id: $id) {
    id
    createdAt
    name
    hasResults
    displayCropTypeName
    isReferenceZone
    cropType {
      id
      name
    }
    farm {
      id
      name
    }
    field {
      id
      name
    }
    location {
      id
      what3Words {
        words
      }
      latitude
      longitude
    }
    moisture
    soilTexture
    season
    results(first: 50, after: $resultsAfter) {
      nodes {
        id
        value
        createdAt
        indicator {
          id
          minValue
          maxValue
          model {
            id
            name
          }
          indicatorDefinition {
            id
            name
            unit
            description
            displayName
            displayDecimalPlaces
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useUserPesTestQuery__
 *
 * To run a query within a React component, call `useUserPesTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPesTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPesTestQuery({
 *   variables: {
 *      id: // value for 'id'
 *      resultsAfter: // value for 'resultsAfter'
 *   },
 * });
 */
export function useUserPesTestQuery(baseOptions: Apollo.QueryHookOptions<UserPesTestQuery, UserPesTestQueryVariables> & ({ variables: UserPesTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPesTestQuery, UserPesTestQueryVariables>(UserPesTestDocument, options);
      }
export function useUserPesTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPesTestQuery, UserPesTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPesTestQuery, UserPesTestQueryVariables>(UserPesTestDocument, options);
        }
export function useUserPesTestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserPesTestQuery, UserPesTestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserPesTestQuery, UserPesTestQueryVariables>(UserPesTestDocument, options);
        }
export type UserPesTestQueryHookResult = ReturnType<typeof useUserPesTestQuery>;
export type UserPesTestLazyQueryHookResult = ReturnType<typeof useUserPesTestLazyQuery>;
export type UserPesTestSuspenseQueryHookResult = ReturnType<typeof useUserPesTestSuspenseQuery>;
export type UserPesTestQueryResult = Apollo.QueryResult<UserPesTestQuery, UserPesTestQueryVariables>;
export const PesTestsDocument = gql`
    query PESTests($first: Int!, $after: String, $where: PESTestFilterInput, $order: [PESTestSortInput!]) {
  pesTests(first: $first, after: $after, where: $where, order: $order) {
    nodes {
      id
      name
      organisation {
        id
        name
      }
      sampleFileUrl
      createdAt
      utcTestTime
      testType
      isFailure
      excludeFromMl
      createdBy {
        id
        fullName
        email
      }
      location {
        id
        what3Words {
          words
        }
        latitude
        longitude
      }
      soilSample {
        id
        name
      }
      farm {
        id
        name
      }
      field {
        id
        name
      }
      cassette {
        id
        serialNumber {
          id
          serialNumber
          range {
            id
            productType {
              id
              code
            }
          }
        }
      }
      eru {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __usePesTestsQuery__
 *
 * To run a query within a React component, call `usePesTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesTestsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePesTestsQuery(baseOptions: Apollo.QueryHookOptions<PesTestsQuery, PesTestsQueryVariables> & ({ variables: PesTestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesTestsQuery, PesTestsQueryVariables>(PesTestsDocument, options);
      }
export function usePesTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesTestsQuery, PesTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesTestsQuery, PesTestsQueryVariables>(PesTestsDocument, options);
        }
export function usePesTestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesTestsQuery, PesTestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesTestsQuery, PesTestsQueryVariables>(PesTestsDocument, options);
        }
export type PesTestsQueryHookResult = ReturnType<typeof usePesTestsQuery>;
export type PesTestsLazyQueryHookResult = ReturnType<typeof usePesTestsLazyQuery>;
export type PesTestsSuspenseQueryHookResult = ReturnType<typeof usePesTestsSuspenseQuery>;
export type PesTestsQueryResult = Apollo.QueryResult<PesTestsQuery, PesTestsQueryVariables>;
export const SearchPesTestsDocument = gql`
    query SearchPESTests($after: String, $where: PESTestFilterInput, $order: [PESTestSortInput!]) {
  pesTests(first: 25, after: $after, where: $where, order: $order) {
    nodes {
      id
      createdAt
      utcTestTime
      name
      testType
      location {
        id
        what3Words {
          words
        }
        latitude
        longitude
      }
      isReferenceZone
      farm {
        id
        name
      }
      field {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useSearchPesTestsQuery__
 *
 * To run a query within a React component, call `useSearchPesTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPesTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPesTestsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSearchPesTestsQuery(baseOptions?: Apollo.QueryHookOptions<SearchPesTestsQuery, SearchPesTestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPesTestsQuery, SearchPesTestsQueryVariables>(SearchPesTestsDocument, options);
      }
export function useSearchPesTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPesTestsQuery, SearchPesTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPesTestsQuery, SearchPesTestsQueryVariables>(SearchPesTestsDocument, options);
        }
export function useSearchPesTestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPesTestsQuery, SearchPesTestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPesTestsQuery, SearchPesTestsQueryVariables>(SearchPesTestsDocument, options);
        }
export type SearchPesTestsQueryHookResult = ReturnType<typeof useSearchPesTestsQuery>;
export type SearchPesTestsLazyQueryHookResult = ReturnType<typeof useSearchPesTestsLazyQuery>;
export type SearchPesTestsSuspenseQueryHookResult = ReturnType<typeof useSearchPesTestsSuspenseQuery>;
export type SearchPesTestsQueryResult = Apollo.QueryResult<SearchPesTestsQuery, SearchPesTestsQueryVariables>;
export const UpdateExcludeFromMlDocument = gql`
    mutation UpdateExcludeFromMl($testId: UUID!, $exclude: Boolean!) {
  updateExcludeFromMl(testId: $testId, exclude: $exclude) {
    id
    excludeFromMl
  }
}
    `;
export type UpdateExcludeFromMlMutationFn = Apollo.MutationFunction<UpdateExcludeFromMlMutation, UpdateExcludeFromMlMutationVariables>;

/**
 * __useUpdateExcludeFromMlMutation__
 *
 * To run a mutation, you first call `useUpdateExcludeFromMlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExcludeFromMlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExcludeFromMlMutation, { data, loading, error }] = useUpdateExcludeFromMlMutation({
 *   variables: {
 *      testId: // value for 'testId'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useUpdateExcludeFromMlMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExcludeFromMlMutation, UpdateExcludeFromMlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExcludeFromMlMutation, UpdateExcludeFromMlMutationVariables>(UpdateExcludeFromMlDocument, options);
      }
export type UpdateExcludeFromMlMutationHookResult = ReturnType<typeof useUpdateExcludeFromMlMutation>;
export type UpdateExcludeFromMlMutationResult = Apollo.MutationResult<UpdateExcludeFromMlMutation>;
export type UpdateExcludeFromMlMutationOptions = Apollo.BaseMutationOptions<UpdateExcludeFromMlMutation, UpdateExcludeFromMlMutationVariables>;
export const RenamePesTestDocument = gql`
    mutation RenamePesTest($input: UpdatePesTestNameInput!) {
  renamePesTest(input: $input) {
    id
    name
  }
}
    `;
export type RenamePesTestMutationFn = Apollo.MutationFunction<RenamePesTestMutation, RenamePesTestMutationVariables>;

/**
 * __useRenamePesTestMutation__
 *
 * To run a mutation, you first call `useRenamePesTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenamePesTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renamePesTestMutation, { data, loading, error }] = useRenamePesTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenamePesTestMutation(baseOptions?: Apollo.MutationHookOptions<RenamePesTestMutation, RenamePesTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenamePesTestMutation, RenamePesTestMutationVariables>(RenamePesTestDocument, options);
      }
export type RenamePesTestMutationHookResult = ReturnType<typeof useRenamePesTestMutation>;
export type RenamePesTestMutationResult = Apollo.MutationResult<RenamePesTestMutation>;
export type RenamePesTestMutationOptions = Apollo.BaseMutationOptions<RenamePesTestMutation, RenamePesTestMutationVariables>;
export const UpdatePesTestLocationDocument = gql`
    mutation UpdatePesTestLocation($input: UpdatePesTestLocationInput!) {
  updatePesTestLocation(input: $input) {
    id
  }
}
    `;
export type UpdatePesTestLocationMutationFn = Apollo.MutationFunction<UpdatePesTestLocationMutation, UpdatePesTestLocationMutationVariables>;

/**
 * __useUpdatePesTestLocationMutation__
 *
 * To run a mutation, you first call `useUpdatePesTestLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePesTestLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePesTestLocationMutation, { data, loading, error }] = useUpdatePesTestLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePesTestLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePesTestLocationMutation, UpdatePesTestLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePesTestLocationMutation, UpdatePesTestLocationMutationVariables>(UpdatePesTestLocationDocument, options);
      }
export type UpdatePesTestLocationMutationHookResult = ReturnType<typeof useUpdatePesTestLocationMutation>;
export type UpdatePesTestLocationMutationResult = Apollo.MutationResult<UpdatePesTestLocationMutation>;
export type UpdatePesTestLocationMutationOptions = Apollo.BaseMutationOptions<UpdatePesTestLocationMutation, UpdatePesTestLocationMutationVariables>;
export const UpdatePesTestCharacteristicsDocument = gql`
    mutation UpdatePesTestCharacteristics($input: UpdatePesTestCharacteristicsInput!) {
  updatePesTestCharacteristics(input: $input) {
    id
  }
}
    `;
export type UpdatePesTestCharacteristicsMutationFn = Apollo.MutationFunction<UpdatePesTestCharacteristicsMutation, UpdatePesTestCharacteristicsMutationVariables>;

/**
 * __useUpdatePesTestCharacteristicsMutation__
 *
 * To run a mutation, you first call `useUpdatePesTestCharacteristicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePesTestCharacteristicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePesTestCharacteristicsMutation, { data, loading, error }] = useUpdatePesTestCharacteristicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePesTestCharacteristicsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePesTestCharacteristicsMutation, UpdatePesTestCharacteristicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePesTestCharacteristicsMutation, UpdatePesTestCharacteristicsMutationVariables>(UpdatePesTestCharacteristicsDocument, options);
      }
export type UpdatePesTestCharacteristicsMutationHookResult = ReturnType<typeof useUpdatePesTestCharacteristicsMutation>;
export type UpdatePesTestCharacteristicsMutationResult = Apollo.MutationResult<UpdatePesTestCharacteristicsMutation>;
export type UpdatePesTestCharacteristicsMutationOptions = Apollo.BaseMutationOptions<UpdatePesTestCharacteristicsMutation, UpdatePesTestCharacteristicsMutationVariables>;
export const MarkTestFailedDocument = gql`
    mutation MarkTestFailed($input: MarkTestFailedInput!) {
  markTestFailed(input: $input) {
    id
    isFailure
    failureReasons
  }
}
    `;
export type MarkTestFailedMutationFn = Apollo.MutationFunction<MarkTestFailedMutation, MarkTestFailedMutationVariables>;

/**
 * __useMarkTestFailedMutation__
 *
 * To run a mutation, you first call `useMarkTestFailedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTestFailedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTestFailedMutation, { data, loading, error }] = useMarkTestFailedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkTestFailedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTestFailedMutation, MarkTestFailedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTestFailedMutation, MarkTestFailedMutationVariables>(MarkTestFailedDocument, options);
      }
export type MarkTestFailedMutationHookResult = ReturnType<typeof useMarkTestFailedMutation>;
export type MarkTestFailedMutationResult = Apollo.MutationResult<MarkTestFailedMutation>;
export type MarkTestFailedMutationOptions = Apollo.BaseMutationOptions<MarkTestFailedMutation, MarkTestFailedMutationVariables>;
export const TransferPesTestDocument = gql`
    mutation TransferPesTest($input: TransferPesTestInput!) {
  transferPesTest(input: $input) {
    id
    createdBy {
      id
      fullName
      email
      organisationMemberships {
        id
        name
      }
    }
    organisation {
      id
      name
    }
    farm {
      id
      name
    }
    field {
      id
      name
    }
  }
}
    `;
export type TransferPesTestMutationFn = Apollo.MutationFunction<TransferPesTestMutation, TransferPesTestMutationVariables>;

/**
 * __useTransferPesTestMutation__
 *
 * To run a mutation, you first call `useTransferPesTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferPesTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferPesTestMutation, { data, loading, error }] = useTransferPesTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransferPesTestMutation(baseOptions?: Apollo.MutationHookOptions<TransferPesTestMutation, TransferPesTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferPesTestMutation, TransferPesTestMutationVariables>(TransferPesTestDocument, options);
      }
export type TransferPesTestMutationHookResult = ReturnType<typeof useTransferPesTestMutation>;
export type TransferPesTestMutationResult = Apollo.MutationResult<TransferPesTestMutation>;
export type TransferPesTestMutationOptions = Apollo.BaseMutationOptions<TransferPesTestMutation, TransferPesTestMutationVariables>;
export const DeletePesTestDocument = gql`
    mutation DeletePesTest($input: DeletePesTestInput!) {
  deletePESTest(input: $input)
}
    `;
export type DeletePesTestMutationFn = Apollo.MutationFunction<DeletePesTestMutation, DeletePesTestMutationVariables>;

/**
 * __useDeletePesTestMutation__
 *
 * To run a mutation, you first call `useDeletePesTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePesTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePesTestMutation, { data, loading, error }] = useDeletePesTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePesTestMutation(baseOptions?: Apollo.MutationHookOptions<DeletePesTestMutation, DeletePesTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePesTestMutation, DeletePesTestMutationVariables>(DeletePesTestDocument, options);
      }
export type DeletePesTestMutationHookResult = ReturnType<typeof useDeletePesTestMutation>;
export type DeletePesTestMutationResult = Apollo.MutationResult<DeletePesTestMutation>;
export type DeletePesTestMutationOptions = Apollo.BaseMutationOptions<DeletePesTestMutation, DeletePesTestMutationVariables>;
export const QueuePesTestPredictionDocument = gql`
    mutation QueuePesTestPrediction($input: QueuePesTestPredictionInput!) {
  queuePesTestPrediction(input: $input) {
    id
  }
}
    `;
export type QueuePesTestPredictionMutationFn = Apollo.MutationFunction<QueuePesTestPredictionMutation, QueuePesTestPredictionMutationVariables>;

/**
 * __useQueuePesTestPredictionMutation__
 *
 * To run a mutation, you first call `useQueuePesTestPredictionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueuePesTestPredictionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queuePesTestPredictionMutation, { data, loading, error }] = useQueuePesTestPredictionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueuePesTestPredictionMutation(baseOptions?: Apollo.MutationHookOptions<QueuePesTestPredictionMutation, QueuePesTestPredictionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QueuePesTestPredictionMutation, QueuePesTestPredictionMutationVariables>(QueuePesTestPredictionDocument, options);
      }
export type QueuePesTestPredictionMutationHookResult = ReturnType<typeof useQueuePesTestPredictionMutation>;
export type QueuePesTestPredictionMutationResult = Apollo.MutationResult<QueuePesTestPredictionMutation>;
export type QueuePesTestPredictionMutationOptions = Apollo.BaseMutationOptions<QueuePesTestPredictionMutation, QueuePesTestPredictionMutationVariables>;
export const RecoverPesTestFeatureCacheDocument = gql`
    mutation RecoverPesTestFeatureCache($testId: UUID!) {
  recoverPesTestFeatureCache(testId: $testId) {
    id
  }
}
    `;
export type RecoverPesTestFeatureCacheMutationFn = Apollo.MutationFunction<RecoverPesTestFeatureCacheMutation, RecoverPesTestFeatureCacheMutationVariables>;

/**
 * __useRecoverPesTestFeatureCacheMutation__
 *
 * To run a mutation, you first call `useRecoverPesTestFeatureCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverPesTestFeatureCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverPesTestFeatureCacheMutation, { data, loading, error }] = useRecoverPesTestFeatureCacheMutation({
 *   variables: {
 *      testId: // value for 'testId'
 *   },
 * });
 */
export function useRecoverPesTestFeatureCacheMutation(baseOptions?: Apollo.MutationHookOptions<RecoverPesTestFeatureCacheMutation, RecoverPesTestFeatureCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverPesTestFeatureCacheMutation, RecoverPesTestFeatureCacheMutationVariables>(RecoverPesTestFeatureCacheDocument, options);
      }
export type RecoverPesTestFeatureCacheMutationHookResult = ReturnType<typeof useRecoverPesTestFeatureCacheMutation>;
export type RecoverPesTestFeatureCacheMutationResult = Apollo.MutationResult<RecoverPesTestFeatureCacheMutation>;
export type RecoverPesTestFeatureCacheMutationOptions = Apollo.BaseMutationOptions<RecoverPesTestFeatureCacheMutation, RecoverPesTestFeatureCacheMutationVariables>;
export const PurgePesTestFeatureCacheDocument = gql`
    mutation PurgePesTestFeatureCache($input: PurgePesTestFeatureCacheInput!) {
  purgePesTestFeatureCache(input: $input) {
    purgedCount
    testIds
    sampleIds
  }
}
    `;
export type PurgePesTestFeatureCacheMutationFn = Apollo.MutationFunction<PurgePesTestFeatureCacheMutation, PurgePesTestFeatureCacheMutationVariables>;

/**
 * __usePurgePesTestFeatureCacheMutation__
 *
 * To run a mutation, you first call `usePurgePesTestFeatureCacheMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurgePesTestFeatureCacheMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purgePesTestFeatureCacheMutation, { data, loading, error }] = usePurgePesTestFeatureCacheMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurgePesTestFeatureCacheMutation(baseOptions?: Apollo.MutationHookOptions<PurgePesTestFeatureCacheMutation, PurgePesTestFeatureCacheMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurgePesTestFeatureCacheMutation, PurgePesTestFeatureCacheMutationVariables>(PurgePesTestFeatureCacheDocument, options);
      }
export type PurgePesTestFeatureCacheMutationHookResult = ReturnType<typeof usePurgePesTestFeatureCacheMutation>;
export type PurgePesTestFeatureCacheMutationResult = Apollo.MutationResult<PurgePesTestFeatureCacheMutation>;
export type PurgePesTestFeatureCacheMutationOptions = Apollo.BaseMutationOptions<PurgePesTestFeatureCacheMutation, PurgePesTestFeatureCacheMutationVariables>;
export const PurgePesTestFeatureCachesDocument = gql`
    mutation PurgePesTestFeatureCaches($input: PurgePesTestFeatureCachesInput!) {
  purgePesTestFeatureCaches(input: $input) {
    purgedCount
    testIds
    sampleIds
  }
}
    `;
export type PurgePesTestFeatureCachesMutationFn = Apollo.MutationFunction<PurgePesTestFeatureCachesMutation, PurgePesTestFeatureCachesMutationVariables>;

/**
 * __usePurgePesTestFeatureCachesMutation__
 *
 * To run a mutation, you first call `usePurgePesTestFeatureCachesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurgePesTestFeatureCachesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purgePesTestFeatureCachesMutation, { data, loading, error }] = usePurgePesTestFeatureCachesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePurgePesTestFeatureCachesMutation(baseOptions?: Apollo.MutationHookOptions<PurgePesTestFeatureCachesMutation, PurgePesTestFeatureCachesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurgePesTestFeatureCachesMutation, PurgePesTestFeatureCachesMutationVariables>(PurgePesTestFeatureCachesDocument, options);
      }
export type PurgePesTestFeatureCachesMutationHookResult = ReturnType<typeof usePurgePesTestFeatureCachesMutation>;
export type PurgePesTestFeatureCachesMutationResult = Apollo.MutationResult<PurgePesTestFeatureCachesMutation>;
export type PurgePesTestFeatureCachesMutationOptions = Apollo.BaseMutationOptions<PurgePesTestFeatureCachesMutation, PurgePesTestFeatureCachesMutationVariables>;
export const PesTestFeatureCacheOverviewDocument = gql`
    query PesTestFeatureCacheOverview {
  pesTestFeatureCacheOverview {
    activeCacheCount
    activeTestCount
    activeFeatureCount
    lastExtractedAt
  }
}
    `;

/**
 * __usePesTestFeatureCacheOverviewQuery__
 *
 * To run a query within a React component, call `usePesTestFeatureCacheOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesTestFeatureCacheOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesTestFeatureCacheOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function usePesTestFeatureCacheOverviewQuery(baseOptions?: Apollo.QueryHookOptions<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>(PesTestFeatureCacheOverviewDocument, options);
      }
export function usePesTestFeatureCacheOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>(PesTestFeatureCacheOverviewDocument, options);
        }
export function usePesTestFeatureCacheOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>(PesTestFeatureCacheOverviewDocument, options);
        }
export type PesTestFeatureCacheOverviewQueryHookResult = ReturnType<typeof usePesTestFeatureCacheOverviewQuery>;
export type PesTestFeatureCacheOverviewLazyQueryHookResult = ReturnType<typeof usePesTestFeatureCacheOverviewLazyQuery>;
export type PesTestFeatureCacheOverviewSuspenseQueryHookResult = ReturnType<typeof usePesTestFeatureCacheOverviewSuspenseQuery>;
export type PesTestFeatureCacheOverviewQueryResult = Apollo.QueryResult<PesTestFeatureCacheOverviewQuery, PesTestFeatureCacheOverviewQueryVariables>;
export const PesTestResultsDocument = gql`
    query PesTestResults($testId: UUID!, $after: String) {
  pesTest(id: $testId) {
    id
    results(first: 50, after: $after) {
      nodes {
        id
        value
        createdAt
        indicator {
          id
          name
          model {
            id
            name
          }
          indicatorDefinition {
            id
            name
            displayName
            description
            unit
            displayDecimalPlaces
          }
          minValue
          maxValue
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __usePesTestResultsQuery__
 *
 * To run a query within a React component, call `usePesTestResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesTestResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesTestResultsQuery({
 *   variables: {
 *      testId: // value for 'testId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePesTestResultsQuery(baseOptions: Apollo.QueryHookOptions<PesTestResultsQuery, PesTestResultsQueryVariables> & ({ variables: PesTestResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesTestResultsQuery, PesTestResultsQueryVariables>(PesTestResultsDocument, options);
      }
export function usePesTestResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesTestResultsQuery, PesTestResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesTestResultsQuery, PesTestResultsQueryVariables>(PesTestResultsDocument, options);
        }
export function usePesTestResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesTestResultsQuery, PesTestResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesTestResultsQuery, PesTestResultsQueryVariables>(PesTestResultsDocument, options);
        }
export type PesTestResultsQueryHookResult = ReturnType<typeof usePesTestResultsQuery>;
export type PesTestResultsLazyQueryHookResult = ReturnType<typeof usePesTestResultsLazyQuery>;
export type PesTestResultsSuspenseQueryHookResult = ReturnType<typeof usePesTestResultsSuspenseQuery>;
export type PesTestResultsQueryResult = Apollo.QueryResult<PesTestResultsQuery, PesTestResultsQueryVariables>;
export const AdjacentPesTestDocument = gql`
    query AdjacentPesTest($where: PESTestFilterInput, $order: [PESTestSortInput!]) {
  pesTests(first: 1, where: $where, order: $order) {
    nodes {
      id
    }
  }
}
    `;

/**
 * __useAdjacentPesTestQuery__
 *
 * To run a query within a React component, call `useAdjacentPesTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdjacentPesTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdjacentPesTestQuery({
 *   variables: {
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAdjacentPesTestQuery(baseOptions?: Apollo.QueryHookOptions<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>(AdjacentPesTestDocument, options);
      }
export function useAdjacentPesTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>(AdjacentPesTestDocument, options);
        }
export function useAdjacentPesTestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>(AdjacentPesTestDocument, options);
        }
export type AdjacentPesTestQueryHookResult = ReturnType<typeof useAdjacentPesTestQuery>;
export type AdjacentPesTestLazyQueryHookResult = ReturnType<typeof useAdjacentPesTestLazyQuery>;
export type AdjacentPesTestSuspenseQueryHookResult = ReturnType<typeof useAdjacentPesTestSuspenseQuery>;
export type AdjacentPesTestQueryResult = Apollo.QueryResult<AdjacentPesTestQuery, AdjacentPesTestQueryVariables>;
export const TransferOrganisationsDocument = gql`
    query TransferOrganisations($after: String) {
  organisations(first: 25, after: $after) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useTransferOrganisationsQuery__
 *
 * To run a query within a React component, call `useTransferOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferOrganisationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTransferOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>(TransferOrganisationsDocument, options);
      }
export function useTransferOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>(TransferOrganisationsDocument, options);
        }
export function useTransferOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>(TransferOrganisationsDocument, options);
        }
export type TransferOrganisationsQueryHookResult = ReturnType<typeof useTransferOrganisationsQuery>;
export type TransferOrganisationsLazyQueryHookResult = ReturnType<typeof useTransferOrganisationsLazyQuery>;
export type TransferOrganisationsSuspenseQueryHookResult = ReturnType<typeof useTransferOrganisationsSuspenseQuery>;
export type TransferOrganisationsQueryResult = Apollo.QueryResult<TransferOrganisationsQuery, TransferOrganisationsQueryVariables>;
export const TransferFarmsDocument = gql`
    query TransferFarms($organisationId: UUID!, $after: String) {
  organisationById(id: $organisationId) {
    farms(first: 25, after: $after) {
      nodes {
        id
        name
        organisation {
          id
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useTransferFarmsQuery__
 *
 * To run a query within a React component, call `useTransferFarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferFarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferFarmsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTransferFarmsQuery(baseOptions: Apollo.QueryHookOptions<TransferFarmsQuery, TransferFarmsQueryVariables> & ({ variables: TransferFarmsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferFarmsQuery, TransferFarmsQueryVariables>(TransferFarmsDocument, options);
      }
export function useTransferFarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferFarmsQuery, TransferFarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferFarmsQuery, TransferFarmsQueryVariables>(TransferFarmsDocument, options);
        }
export function useTransferFarmsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferFarmsQuery, TransferFarmsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferFarmsQuery, TransferFarmsQueryVariables>(TransferFarmsDocument, options);
        }
export type TransferFarmsQueryHookResult = ReturnType<typeof useTransferFarmsQuery>;
export type TransferFarmsLazyQueryHookResult = ReturnType<typeof useTransferFarmsLazyQuery>;
export type TransferFarmsSuspenseQueryHookResult = ReturnType<typeof useTransferFarmsSuspenseQuery>;
export type TransferFarmsQueryResult = Apollo.QueryResult<TransferFarmsQuery, TransferFarmsQueryVariables>;
export const TransferFieldsDocument = gql`
    query TransferFields($farmId: UUID!, $after: String) {
  farm(id: $farmId) {
    id
    fields(first: 25, after: $after) {
      nodes {
        id
        name
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useTransferFieldsQuery__
 *
 * To run a query within a React component, call `useTransferFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransferFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransferFieldsQuery({
 *   variables: {
 *      farmId: // value for 'farmId'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTransferFieldsQuery(baseOptions: Apollo.QueryHookOptions<TransferFieldsQuery, TransferFieldsQueryVariables> & ({ variables: TransferFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransferFieldsQuery, TransferFieldsQueryVariables>(TransferFieldsDocument, options);
      }
export function useTransferFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransferFieldsQuery, TransferFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransferFieldsQuery, TransferFieldsQueryVariables>(TransferFieldsDocument, options);
        }
export function useTransferFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransferFieldsQuery, TransferFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransferFieldsQuery, TransferFieldsQueryVariables>(TransferFieldsDocument, options);
        }
export type TransferFieldsQueryHookResult = ReturnType<typeof useTransferFieldsQuery>;
export type TransferFieldsLazyQueryHookResult = ReturnType<typeof useTransferFieldsLazyQuery>;
export type TransferFieldsSuspenseQueryHookResult = ReturnType<typeof useTransferFieldsSuspenseQuery>;
export type TransferFieldsQueryResult = Apollo.QueryResult<TransferFieldsQuery, TransferFieldsQueryVariables>;
export const PesTestIndicatorLimitDocument = gql`
    query PesTestIndicatorLimit($id: UUID!) {
  pesTest(id: $id) {
    id
    allowedIndicatorDefinitions {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __usePesTestIndicatorLimitQuery__
 *
 * To run a query within a React component, call `usePesTestIndicatorLimitQuery` and pass it any options that fit your needs.
 * When your component renders, `usePesTestIndicatorLimitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePesTestIndicatorLimitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePesTestIndicatorLimitQuery(baseOptions: Apollo.QueryHookOptions<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables> & ({ variables: PesTestIndicatorLimitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables>(PesTestIndicatorLimitDocument, options);
      }
export function usePesTestIndicatorLimitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables>(PesTestIndicatorLimitDocument, options);
        }
export function usePesTestIndicatorLimitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables>(PesTestIndicatorLimitDocument, options);
        }
export type PesTestIndicatorLimitQueryHookResult = ReturnType<typeof usePesTestIndicatorLimitQuery>;
export type PesTestIndicatorLimitLazyQueryHookResult = ReturnType<typeof usePesTestIndicatorLimitLazyQuery>;
export type PesTestIndicatorLimitSuspenseQueryHookResult = ReturnType<typeof usePesTestIndicatorLimitSuspenseQuery>;
export type PesTestIndicatorLimitQueryResult = Apollo.QueryResult<PesTestIndicatorLimitQuery, PesTestIndicatorLimitQueryVariables>;
export const ProductTypesDocument = gql`
    query ProductTypes($after: String) {
  productTypes(first: 25, after: $after) {
    nodes {
      id
      createdAt
      name
      code
      location
      model
      subType
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useProductTypesQuery__
 *
 * To run a query within a React component, call `useProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductTypesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<ProductTypesQuery, ProductTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductTypesQuery, ProductTypesQueryVariables>(ProductTypesDocument, options);
      }
export function useProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductTypesQuery, ProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductTypesQuery, ProductTypesQueryVariables>(ProductTypesDocument, options);
        }
export function useProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductTypesQuery, ProductTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductTypesQuery, ProductTypesQueryVariables>(ProductTypesDocument, options);
        }
export type ProductTypesQueryHookResult = ReturnType<typeof useProductTypesQuery>;
export type ProductTypesLazyQueryHookResult = ReturnType<typeof useProductTypesLazyQuery>;
export type ProductTypesSuspenseQueryHookResult = ReturnType<typeof useProductTypesSuspenseQuery>;
export type ProductTypesQueryResult = Apollo.QueryResult<ProductTypesQuery, ProductTypesQueryVariables>;
export const ReportDocument = gql`
    query Report($id: UUID!) {
  reports(first: 1, where: {id: {eq: $id}}) {
    nodes {
      id
      name
      createdBy {
        id
        fullName
        email
      }
    }
  }
}
    `;

/**
 * __useReportQuery__
 *
 * To run a query within a React component, call `useReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportQuery(baseOptions: Apollo.QueryHookOptions<ReportQuery, ReportQueryVariables> & ({ variables: ReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
      }
export function useReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export function useReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportQuery, ReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportQuery, ReportQueryVariables>(ReportDocument, options);
        }
export type ReportQueryHookResult = ReturnType<typeof useReportQuery>;
export type ReportLazyQueryHookResult = ReturnType<typeof useReportLazyQuery>;
export type ReportSuspenseQueryHookResult = ReturnType<typeof useReportSuspenseQuery>;
export type ReportQueryResult = Apollo.QueryResult<ReportQuery, ReportQueryVariables>;
export const ReportPesTestsDocument = gql`
    query ReportPesTests($id: UUID!, $after: String) {
  reports(first: 1, where: {id: {eq: $id}}) {
    nodes {
      pesTests(first: 10, after: $after) {
        nodes {
          id
          originalModelName
          isFailure
          createdAt
          allowedIndicatorDefinitions {
            id
            name
            displayName
          }
          location {
            id
            latitude
            longitude
            what3Words {
              words
            }
          }
          name
          farm {
            id
            name
          }
          field {
            id
            name
          }
          results(first: 50) {
            nodes {
              id
              createdAt
              indicator {
                id
                name
                model {
                  id
                  name
                }
                indicatorDefinition {
                  id
                  name
                  displayName
                  description
                  unit
                  displayDecimalPlaces
                }
                minValue
                maxValue
              }
              value
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;

/**
 * __useReportPesTestsQuery__
 *
 * To run a query within a React component, call `useReportPesTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportPesTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportPesTestsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportPesTestsQuery(baseOptions: Apollo.QueryHookOptions<ReportPesTestsQuery, ReportPesTestsQueryVariables> & ({ variables: ReportPesTestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportPesTestsQuery, ReportPesTestsQueryVariables>(ReportPesTestsDocument, options);
      }
export function useReportPesTestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportPesTestsQuery, ReportPesTestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportPesTestsQuery, ReportPesTestsQueryVariables>(ReportPesTestsDocument, options);
        }
export function useReportPesTestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportPesTestsQuery, ReportPesTestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportPesTestsQuery, ReportPesTestsQueryVariables>(ReportPesTestsDocument, options);
        }
export type ReportPesTestsQueryHookResult = ReturnType<typeof useReportPesTestsQuery>;
export type ReportPesTestsLazyQueryHookResult = ReturnType<typeof useReportPesTestsLazyQuery>;
export type ReportPesTestsSuspenseQueryHookResult = ReturnType<typeof useReportPesTestsSuspenseQuery>;
export type ReportPesTestsQueryResult = Apollo.QueryResult<ReportPesTestsQuery, ReportPesTestsQueryVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($input: CreateReportInput!) {
  createReport(input: $input) {
    id
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const SerialRangesDocument = gql`
    query SerialRanges($after: String) {
  serialRanges(first: 25, after: $after) {
    nodes {
      id
      createdAt
      startNumber
      endNumber
      nextAvailable
      buildStartDate
      buildEndDate
      buildDescription
      firmwareVersion
      notes
      productType {
        id
        createdAt
        name
        code
        location
        model
        subType
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useSerialRangesQuery__
 *
 * To run a query within a React component, call `useSerialRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSerialRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSerialRangesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSerialRangesQuery(baseOptions?: Apollo.QueryHookOptions<SerialRangesQuery, SerialRangesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SerialRangesQuery, SerialRangesQueryVariables>(SerialRangesDocument, options);
      }
export function useSerialRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SerialRangesQuery, SerialRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SerialRangesQuery, SerialRangesQueryVariables>(SerialRangesDocument, options);
        }
export function useSerialRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SerialRangesQuery, SerialRangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SerialRangesQuery, SerialRangesQueryVariables>(SerialRangesDocument, options);
        }
export type SerialRangesQueryHookResult = ReturnType<typeof useSerialRangesQuery>;
export type SerialRangesLazyQueryHookResult = ReturnType<typeof useSerialRangesLazyQuery>;
export type SerialRangesSuspenseQueryHookResult = ReturnType<typeof useSerialRangesSuspenseQuery>;
export type SerialRangesQueryResult = Apollo.QueryResult<SerialRangesQuery, SerialRangesQueryVariables>;
export const CreateSerialRangeDocument = gql`
    mutation CreateSerialRange($input: CreateSerialRangeInput!) {
  createSerialRange(input: $input) {
    id
  }
}
    `;
export type CreateSerialRangeMutationFn = Apollo.MutationFunction<CreateSerialRangeMutation, CreateSerialRangeMutationVariables>;

/**
 * __useCreateSerialRangeMutation__
 *
 * To run a mutation, you first call `useCreateSerialRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSerialRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSerialRangeMutation, { data, loading, error }] = useCreateSerialRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSerialRangeMutation(baseOptions?: Apollo.MutationHookOptions<CreateSerialRangeMutation, CreateSerialRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSerialRangeMutation, CreateSerialRangeMutationVariables>(CreateSerialRangeDocument, options);
      }
export type CreateSerialRangeMutationHookResult = ReturnType<typeof useCreateSerialRangeMutation>;
export type CreateSerialRangeMutationResult = Apollo.MutationResult<CreateSerialRangeMutation>;
export type CreateSerialRangeMutationOptions = Apollo.BaseMutationOptions<CreateSerialRangeMutation, CreateSerialRangeMutationVariables>;
export const UpdateSerialRangeDocument = gql`
    mutation UpdateSerialRange($input: UpdateSerialRangeInput!) {
  updateSerialRange(input: $input) {
    id
  }
}
    `;
export type UpdateSerialRangeMutationFn = Apollo.MutationFunction<UpdateSerialRangeMutation, UpdateSerialRangeMutationVariables>;

/**
 * __useUpdateSerialRangeMutation__
 *
 * To run a mutation, you first call `useUpdateSerialRangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSerialRangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSerialRangeMutation, { data, loading, error }] = useUpdateSerialRangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSerialRangeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSerialRangeMutation, UpdateSerialRangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSerialRangeMutation, UpdateSerialRangeMutationVariables>(UpdateSerialRangeDocument, options);
      }
export type UpdateSerialRangeMutationHookResult = ReturnType<typeof useUpdateSerialRangeMutation>;
export type UpdateSerialRangeMutationResult = Apollo.MutationResult<UpdateSerialRangeMutation>;
export type UpdateSerialRangeMutationOptions = Apollo.BaseMutationOptions<UpdateSerialRangeMutation, UpdateSerialRangeMutationVariables>;
export const SoilSampleDocument = gql`
    query SoilSample($id: UUID!) {
  soilSample(id: $id) {
    id
    createdAt
    updatedAt
    name
    isReferenceZone
    moisture
    season
    sampleDate
    strawRemoved
    fym
    coverCrop {
      id
      name
    }
    cropType {
      id
      name
    }
    lastYearCrop {
      id
      name
    }
    yearBeforeLastCrop {
      id
      name
    }
    soilType {
      id
      name
    }
    cultivation {
      id
      name
    }
    labResults(first: 25) {
      nodes {
        id
        value
        laboratory {
          id
          name
        }
        indicator {
          id
          name
          unit
          valueType
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useSoilSampleQuery__
 *
 * To run a query within a React component, call `useSoilSampleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoilSampleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoilSampleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSoilSampleQuery(baseOptions: Apollo.QueryHookOptions<SoilSampleQuery, SoilSampleQueryVariables> & ({ variables: SoilSampleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoilSampleQuery, SoilSampleQueryVariables>(SoilSampleDocument, options);
      }
export function useSoilSampleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoilSampleQuery, SoilSampleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoilSampleQuery, SoilSampleQueryVariables>(SoilSampleDocument, options);
        }
export function useSoilSampleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SoilSampleQuery, SoilSampleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoilSampleQuery, SoilSampleQueryVariables>(SoilSampleDocument, options);
        }
export type SoilSampleQueryHookResult = ReturnType<typeof useSoilSampleQuery>;
export type SoilSampleLazyQueryHookResult = ReturnType<typeof useSoilSampleLazyQuery>;
export type SoilSampleSuspenseQueryHookResult = ReturnType<typeof useSoilSampleSuspenseQuery>;
export type SoilSampleQueryResult = Apollo.QueryResult<SoilSampleQuery, SoilSampleQueryVariables>;
export const SoilSamplesDocument = gql`
    query SoilSamples($after: String, $search: String, $where: SoilSampleFilterInput, $order: [SoilSampleSortInput!]) {
  soilSamples(
    first: 25
    after: $after
    search: $search
    where: $where
    order: $order
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      labResults(first: 25) {
        nodes {
          id
          value
          laboratory {
            id
            name
          }
          indicator {
            id
            name
            unit
            valueType
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useSoilSamplesQuery__
 *
 * To run a query within a React component, call `useSoilSamplesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoilSamplesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoilSamplesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSoilSamplesQuery(baseOptions?: Apollo.QueryHookOptions<SoilSamplesQuery, SoilSamplesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoilSamplesQuery, SoilSamplesQueryVariables>(SoilSamplesDocument, options);
      }
export function useSoilSamplesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoilSamplesQuery, SoilSamplesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoilSamplesQuery, SoilSamplesQueryVariables>(SoilSamplesDocument, options);
        }
export function useSoilSamplesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SoilSamplesQuery, SoilSamplesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoilSamplesQuery, SoilSamplesQueryVariables>(SoilSamplesDocument, options);
        }
export type SoilSamplesQueryHookResult = ReturnType<typeof useSoilSamplesQuery>;
export type SoilSamplesLazyQueryHookResult = ReturnType<typeof useSoilSamplesLazyQuery>;
export type SoilSamplesSuspenseQueryHookResult = ReturnType<typeof useSoilSamplesSuspenseQuery>;
export type SoilSamplesQueryResult = Apollo.QueryResult<SoilSamplesQuery, SoilSamplesQueryVariables>;
export const UpdateSoilSampleDocument = gql`
    mutation UpdateSoilSample($input: UpdateSoilSampleInput!) {
  updateSoilSample(input: $input) {
    id
    createdAt
    updatedAt
    name
    isReferenceZone
    moisture
    season
    sampleDate
    strawRemoved
    fym
    coverCrop {
      id
      name
    }
    cropType {
      id
      name
    }
    lastYearCrop {
      id
      name
    }
    yearBeforeLastCrop {
      id
      name
    }
    soilType {
      id
      name
    }
    cultivation {
      id
      name
    }
    labResults(first: 25) {
      nodes {
        id
        value
        laboratory {
          id
          name
        }
        indicator {
          id
          name
          unit
          valueType
        }
      }
    }
  }
}
    `;
export type UpdateSoilSampleMutationFn = Apollo.MutationFunction<UpdateSoilSampleMutation, UpdateSoilSampleMutationVariables>;

/**
 * __useUpdateSoilSampleMutation__
 *
 * To run a mutation, you first call `useUpdateSoilSampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSoilSampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSoilSampleMutation, { data, loading, error }] = useUpdateSoilSampleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSoilSampleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSoilSampleMutation, UpdateSoilSampleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSoilSampleMutation, UpdateSoilSampleMutationVariables>(UpdateSoilSampleDocument, options);
      }
export type UpdateSoilSampleMutationHookResult = ReturnType<typeof useUpdateSoilSampleMutation>;
export type UpdateSoilSampleMutationResult = Apollo.MutationResult<UpdateSoilSampleMutation>;
export type UpdateSoilSampleMutationOptions = Apollo.BaseMutationOptions<UpdateSoilSampleMutation, UpdateSoilSampleMutationVariables>;
export const CreateSoilSampleDocument = gql`
    mutation CreateSoilSample($input: CreateSoilSampleInput!) {
  createSoilSample(input: $input) {
    id
    createdAt
    updatedAt
    name
    isReferenceZone
    moisture
    season
    sampleDate
    strawRemoved
    fym
    coverCrop {
      id
      name
    }
    cropType {
      id
      name
    }
    lastYearCrop {
      id
      name
    }
    yearBeforeLastCrop {
      id
      name
    }
    soilType {
      id
      name
    }
    cultivation {
      id
      name
    }
    labResults(first: 25) {
      nodes {
        id
        value
        laboratory {
          id
          name
        }
        indicator {
          id
          name
          unit
          valueType
        }
      }
    }
  }
}
    `;
export type CreateSoilSampleMutationFn = Apollo.MutationFunction<CreateSoilSampleMutation, CreateSoilSampleMutationVariables>;

/**
 * __useCreateSoilSampleMutation__
 *
 * To run a mutation, you first call `useCreateSoilSampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoilSampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoilSampleMutation, { data, loading, error }] = useCreateSoilSampleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoilSampleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoilSampleMutation, CreateSoilSampleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoilSampleMutation, CreateSoilSampleMutationVariables>(CreateSoilSampleDocument, options);
      }
export type CreateSoilSampleMutationHookResult = ReturnType<typeof useCreateSoilSampleMutation>;
export type CreateSoilSampleMutationResult = Apollo.MutationResult<CreateSoilSampleMutation>;
export type CreateSoilSampleMutationOptions = Apollo.BaseMutationOptions<CreateSoilSampleMutation, CreateSoilSampleMutationVariables>;
export const SoilTypesDocument = gql`
    query SoilTypes($after: String) {
  soilTypes(first: 25, after: $after) {
    nodes {
      id
      name
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useSoilTypesQuery__
 *
 * To run a query within a React component, call `useSoilTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoilTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoilTypesQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSoilTypesQuery(baseOptions?: Apollo.QueryHookOptions<SoilTypesQuery, SoilTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoilTypesQuery, SoilTypesQueryVariables>(SoilTypesDocument, options);
      }
export function useSoilTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoilTypesQuery, SoilTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoilTypesQuery, SoilTypesQueryVariables>(SoilTypesDocument, options);
        }
export function useSoilTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SoilTypesQuery, SoilTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoilTypesQuery, SoilTypesQueryVariables>(SoilTypesDocument, options);
        }
export type SoilTypesQueryHookResult = ReturnType<typeof useSoilTypesQuery>;
export type SoilTypesLazyQueryHookResult = ReturnType<typeof useSoilTypesLazyQuery>;
export type SoilTypesSuspenseQueryHookResult = ReturnType<typeof useSoilTypesSuspenseQuery>;
export type SoilTypesQueryResult = Apollo.QueryResult<SoilTypesQuery, SoilTypesQueryVariables>;
export const CreateSoilTypeDocument = gql`
    mutation CreateSoilType($input: CreateSoilTypeInput!) {
  createSoilType(input: $input) {
    id
    name
  }
}
    `;
export type CreateSoilTypeMutationFn = Apollo.MutationFunction<CreateSoilTypeMutation, CreateSoilTypeMutationVariables>;

/**
 * __useCreateSoilTypeMutation__
 *
 * To run a mutation, you first call `useCreateSoilTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoilTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoilTypeMutation, { data, loading, error }] = useCreateSoilTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoilTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoilTypeMutation, CreateSoilTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoilTypeMutation, CreateSoilTypeMutationVariables>(CreateSoilTypeDocument, options);
      }
export type CreateSoilTypeMutationHookResult = ReturnType<typeof useCreateSoilTypeMutation>;
export type CreateSoilTypeMutationResult = Apollo.MutationResult<CreateSoilTypeMutation>;
export type CreateSoilTypeMutationOptions = Apollo.BaseMutationOptions<CreateSoilTypeMutation, CreateSoilTypeMutationVariables>;
export const TroManagementOverviewDocument = gql`
    query TroManagementOverview {
  troManagementOverview {
    tros {
      id
      uuid
      name
      showTestAlerts
      totalTestCount
      lastUsedAt
    }
    unknownTros {
      uuid
      totalTestCount
      lastUsedAt
    }
  }
}
    `;

/**
 * __useTroManagementOverviewQuery__
 *
 * To run a query within a React component, call `useTroManagementOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTroManagementOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTroManagementOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useTroManagementOverviewQuery(baseOptions?: Apollo.QueryHookOptions<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>(TroManagementOverviewDocument, options);
      }
export function useTroManagementOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>(TroManagementOverviewDocument, options);
        }
export function useTroManagementOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>(TroManagementOverviewDocument, options);
        }
export type TroManagementOverviewQueryHookResult = ReturnType<typeof useTroManagementOverviewQuery>;
export type TroManagementOverviewLazyQueryHookResult = ReturnType<typeof useTroManagementOverviewLazyQuery>;
export type TroManagementOverviewSuspenseQueryHookResult = ReturnType<typeof useTroManagementOverviewSuspenseQuery>;
export type TroManagementOverviewQueryResult = Apollo.QueryResult<TroManagementOverviewQuery, TroManagementOverviewQueryVariables>;
export const UpdateTroDocument = gql`
    mutation UpdateTro($input: UpdateTROInput!) {
  updateTRO(input: $input) {
    id
    uuid
    name
    showTestAlerts
  }
}
    `;
export type UpdateTroMutationFn = Apollo.MutationFunction<UpdateTroMutation, UpdateTroMutationVariables>;

/**
 * __useUpdateTroMutation__
 *
 * To run a mutation, you first call `useUpdateTroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTroMutation, { data, loading, error }] = useUpdateTroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTroMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTroMutation, UpdateTroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTroMutation, UpdateTroMutationVariables>(UpdateTroDocument, options);
      }
export type UpdateTroMutationHookResult = ReturnType<typeof useUpdateTroMutation>;
export type UpdateTroMutationResult = Apollo.MutationResult<UpdateTroMutation>;
export type UpdateTroMutationOptions = Apollo.BaseMutationOptions<UpdateTroMutation, UpdateTroMutationVariables>;
export const CreateTroFromUnknownDocument = gql`
    mutation CreateTroFromUnknown($input: CreateTROFromUnknownInput!) {
  createTROFromUnknown(input: $input) {
    id
    uuid
    name
    showTestAlerts
  }
}
    `;
export type CreateTroFromUnknownMutationFn = Apollo.MutationFunction<CreateTroFromUnknownMutation, CreateTroFromUnknownMutationVariables>;

/**
 * __useCreateTroFromUnknownMutation__
 *
 * To run a mutation, you first call `useCreateTroFromUnknownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTroFromUnknownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTroFromUnknownMutation, { data, loading, error }] = useCreateTroFromUnknownMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTroFromUnknownMutation(baseOptions?: Apollo.MutationHookOptions<CreateTroFromUnknownMutation, CreateTroFromUnknownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTroFromUnknownMutation, CreateTroFromUnknownMutationVariables>(CreateTroFromUnknownDocument, options);
      }
export type CreateTroFromUnknownMutationHookResult = ReturnType<typeof useCreateTroFromUnknownMutation>;
export type CreateTroFromUnknownMutationResult = Apollo.MutationResult<CreateTroFromUnknownMutation>;
export type CreateTroFromUnknownMutationOptions = Apollo.BaseMutationOptions<CreateTroFromUnknownMutation, CreateTroFromUnknownMutationVariables>;
export const UpdateTrainedIndicatorDocument = gql`
    mutation UpdateTrainedIndicator($input: UpdateTrainedIndicatorInput!) {
  updateTrainedIndicator(input: $input) {
    id
    minValue
    maxValue
    inferenceModelName
  }
}
    `;
export type UpdateTrainedIndicatorMutationFn = Apollo.MutationFunction<UpdateTrainedIndicatorMutation, UpdateTrainedIndicatorMutationVariables>;

/**
 * __useUpdateTrainedIndicatorMutation__
 *
 * To run a mutation, you first call `useUpdateTrainedIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTrainedIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTrainedIndicatorMutation, { data, loading, error }] = useUpdateTrainedIndicatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTrainedIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTrainedIndicatorMutation, UpdateTrainedIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTrainedIndicatorMutation, UpdateTrainedIndicatorMutationVariables>(UpdateTrainedIndicatorDocument, options);
      }
export type UpdateTrainedIndicatorMutationHookResult = ReturnType<typeof useUpdateTrainedIndicatorMutation>;
export type UpdateTrainedIndicatorMutationResult = Apollo.MutationResult<UpdateTrainedIndicatorMutation>;
export type UpdateTrainedIndicatorMutationOptions = Apollo.BaseMutationOptions<UpdateTrainedIndicatorMutation, UpdateTrainedIndicatorMutationVariables>;
export const CopyTrainedIndicatorDocument = gql`
    mutation CopyTrainedIndicator($input: CopyTrainedIndicatorInput!) {
  copyTrainedIndicator(input: $input) {
    id
    name
    inferenceModelName
    minValue
    maxValue
  }
}
    `;
export type CopyTrainedIndicatorMutationFn = Apollo.MutationFunction<CopyTrainedIndicatorMutation, CopyTrainedIndicatorMutationVariables>;

/**
 * __useCopyTrainedIndicatorMutation__
 *
 * To run a mutation, you first call `useCopyTrainedIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyTrainedIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyTrainedIndicatorMutation, { data, loading, error }] = useCopyTrainedIndicatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyTrainedIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<CopyTrainedIndicatorMutation, CopyTrainedIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyTrainedIndicatorMutation, CopyTrainedIndicatorMutationVariables>(CopyTrainedIndicatorDocument, options);
      }
export type CopyTrainedIndicatorMutationHookResult = ReturnType<typeof useCopyTrainedIndicatorMutation>;
export type CopyTrainedIndicatorMutationResult = Apollo.MutationResult<CopyTrainedIndicatorMutation>;
export type CopyTrainedIndicatorMutationOptions = Apollo.BaseMutationOptions<CopyTrainedIndicatorMutation, CopyTrainedIndicatorMutationVariables>;
export const DeleteTrainedIndicatorDocument = gql`
    mutation DeleteTrainedIndicator($id: UUID!) {
  deleteTrainedIndicator(id: $id)
}
    `;
export type DeleteTrainedIndicatorMutationFn = Apollo.MutationFunction<DeleteTrainedIndicatorMutation, DeleteTrainedIndicatorMutationVariables>;

/**
 * __useDeleteTrainedIndicatorMutation__
 *
 * To run a mutation, you first call `useDeleteTrainedIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTrainedIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTrainedIndicatorMutation, { data, loading, error }] = useDeleteTrainedIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTrainedIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTrainedIndicatorMutation, DeleteTrainedIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTrainedIndicatorMutation, DeleteTrainedIndicatorMutationVariables>(DeleteTrainedIndicatorDocument, options);
      }
export type DeleteTrainedIndicatorMutationHookResult = ReturnType<typeof useDeleteTrainedIndicatorMutation>;
export type DeleteTrainedIndicatorMutationResult = Apollo.MutationResult<DeleteTrainedIndicatorMutation>;
export type DeleteTrainedIndicatorMutationOptions = Apollo.BaseMutationOptions<DeleteTrainedIndicatorMutation, DeleteTrainedIndicatorMutationVariables>;
export const CreateTrainedIndicatorDocument = gql`
    mutation CreateTrainedIndicator($input: CreateTrainedIndicatorInput!) {
  createTrainedIndicator(input: $input) {
    id
    name
    inferenceModelName
    maxValue
    minValue
    model {
      id
    }
  }
}
    `;
export type CreateTrainedIndicatorMutationFn = Apollo.MutationFunction<CreateTrainedIndicatorMutation, CreateTrainedIndicatorMutationVariables>;

/**
 * __useCreateTrainedIndicatorMutation__
 *
 * To run a mutation, you first call `useCreateTrainedIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrainedIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrainedIndicatorMutation, { data, loading, error }] = useCreateTrainedIndicatorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTrainedIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<CreateTrainedIndicatorMutation, CreateTrainedIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTrainedIndicatorMutation, CreateTrainedIndicatorMutationVariables>(CreateTrainedIndicatorDocument, options);
      }
export type CreateTrainedIndicatorMutationHookResult = ReturnType<typeof useCreateTrainedIndicatorMutation>;
export type CreateTrainedIndicatorMutationResult = Apollo.MutationResult<CreateTrainedIndicatorMutation>;
export type CreateTrainedIndicatorMutationOptions = Apollo.BaseMutationOptions<CreateTrainedIndicatorMutation, CreateTrainedIndicatorMutationVariables>;
export const GetUsersDocument = gql`
    query GetUsers($after: String, $where: UserFilterInput, $order: [UserSortInput!], $role: String, $organisationId: UUID) {
  users(
    first: 25
    after: $after
    where: $where
    order: $order
    role: $role
    organisationId: $organisationId
  ) {
    nodes {
      id
      email
      fullName
      createdAt
      roles
      organisationMemberships {
        id
        name
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      after: // value for 'after'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      role: // value for 'role'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const ImpersonateUserDocument = gql`
    query ImpersonateUser($userId: UUID!) {
  impersonateUser(userId: $userId)
}
    `;

/**
 * __useImpersonateUserQuery__
 *
 * To run a query within a React component, call `useImpersonateUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpersonateUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpersonateUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useImpersonateUserQuery(baseOptions: Apollo.QueryHookOptions<ImpersonateUserQuery, ImpersonateUserQueryVariables> & ({ variables: ImpersonateUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpersonateUserQuery, ImpersonateUserQueryVariables>(ImpersonateUserDocument, options);
      }
export function useImpersonateUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpersonateUserQuery, ImpersonateUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpersonateUserQuery, ImpersonateUserQueryVariables>(ImpersonateUserDocument, options);
        }
export function useImpersonateUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpersonateUserQuery, ImpersonateUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpersonateUserQuery, ImpersonateUserQueryVariables>(ImpersonateUserDocument, options);
        }
export type ImpersonateUserQueryHookResult = ReturnType<typeof useImpersonateUserQuery>;
export type ImpersonateUserLazyQueryHookResult = ReturnType<typeof useImpersonateUserLazyQuery>;
export type ImpersonateUserSuspenseQueryHookResult = ReturnType<typeof useImpersonateUserSuspenseQuery>;
export type ImpersonateUserQueryResult = Apollo.QueryResult<ImpersonateUserQuery, ImpersonateUserQueryVariables>;
export const AdminSetUserPasswordDocument = gql`
    mutation AdminSetUserPassword($input: AdminSetUserPasswordInput!) {
  adminSetUserPassword(input: $input)
}
    `;
export type AdminSetUserPasswordMutationFn = Apollo.MutationFunction<AdminSetUserPasswordMutation, AdminSetUserPasswordMutationVariables>;

/**
 * __useAdminSetUserPasswordMutation__
 *
 * To run a mutation, you first call `useAdminSetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminSetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminSetUserPasswordMutation, { data, loading, error }] = useAdminSetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminSetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminSetUserPasswordMutation, AdminSetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminSetUserPasswordMutation, AdminSetUserPasswordMutationVariables>(AdminSetUserPasswordDocument, options);
      }
export type AdminSetUserPasswordMutationHookResult = ReturnType<typeof useAdminSetUserPasswordMutation>;
export type AdminSetUserPasswordMutationResult = Apollo.MutationResult<AdminSetUserPasswordMutation>;
export type AdminSetUserPasswordMutationOptions = Apollo.BaseMutationOptions<AdminSetUserPasswordMutation, AdminSetUserPasswordMutationVariables>;
export const AssignableRolesDocument = gql`
    query AssignableRoles {
  assignableRoles
}
    `;

/**
 * __useAssignableRolesQuery__
 *
 * To run a query within a React component, call `useAssignableRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignableRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignableRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignableRolesQuery(baseOptions?: Apollo.QueryHookOptions<AssignableRolesQuery, AssignableRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignableRolesQuery, AssignableRolesQueryVariables>(AssignableRolesDocument, options);
      }
export function useAssignableRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignableRolesQuery, AssignableRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignableRolesQuery, AssignableRolesQueryVariables>(AssignableRolesDocument, options);
        }
export function useAssignableRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignableRolesQuery, AssignableRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssignableRolesQuery, AssignableRolesQueryVariables>(AssignableRolesDocument, options);
        }
export type AssignableRolesQueryHookResult = ReturnType<typeof useAssignableRolesQuery>;
export type AssignableRolesLazyQueryHookResult = ReturnType<typeof useAssignableRolesLazyQuery>;
export type AssignableRolesSuspenseQueryHookResult = ReturnType<typeof useAssignableRolesSuspenseQuery>;
export type AssignableRolesQueryResult = Apollo.QueryResult<AssignableRolesQuery, AssignableRolesQueryVariables>;
export const SetUserRoleDocument = gql`
    mutation SetUserRole($input: SetUserRoleInput!) {
  setUserRole(input: $input) {
    id
    roles
  }
}
    `;
export type SetUserRoleMutationFn = Apollo.MutationFunction<SetUserRoleMutation, SetUserRoleMutationVariables>;

/**
 * __useSetUserRoleMutation__
 *
 * To run a mutation, you first call `useSetUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserRoleMutation, { data, loading, error }] = useSetUserRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetUserRoleMutation, SetUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserRoleMutation, SetUserRoleMutationVariables>(SetUserRoleDocument, options);
      }
export type SetUserRoleMutationHookResult = ReturnType<typeof useSetUserRoleMutation>;
export type SetUserRoleMutationResult = Apollo.MutationResult<SetUserRoleMutation>;
export type SetUserRoleMutationOptions = Apollo.BaseMutationOptions<SetUserRoleMutation, SetUserRoleMutationVariables>;